import React from "react";
import classNames from "classnames";

import { SternumIconProps } from "../SternumIcon.types";
import { useIconStyle } from "./style";

export function SternumDeviceSecurityPlatformIcon({
    className,
    height = 480,
    width = 567,
    ...props
}: SternumIconProps) {
    const classes = useIconStyle();

    return (
        <svg
            className={classNames(className, classes.svg)}
            width={width}
            height={height}
            viewBox="0 0 567 480"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#clip0_984_11217)">
                <path
                    d="M462.74 383.93H355.85V393.31L355.87 394.31C355.87 394.45 355.85 393.59 355.85 393.74C355.85 410.93 379.78 424.86 409.3 424.86C438.82 424.86 462.75 410.93 462.75 393.74C462.75 393.6 462.73 393.45 462.73 393.31H462.75V383.93H462.74Z"
                    fill="url(#paint0_linear_984_11217)"
                />
                <path
                    d="M409.3 415.27C438.82 415.27 462.75 401.337 462.75 384.15C462.75 366.963 438.82 353.03 409.3 353.03C379.78 353.03 355.85 366.963 355.85 384.15C355.85 401.337 379.78 415.27 409.3 415.27Z"
                    fill="url(#paint1_linear_984_11217)"
                />
                <path
                    d="M409.3 415.14C380.1 415.14 356.39 401.5 355.88 384.57C355.87 384.76 355.86 384.94 355.86 385.13C355.86 402.32 379.79 416.25 409.31 416.25C438.83 416.25 462.76 402.32 462.76 385.13C462.76 384.94 462.74 384.76 462.74 384.57C462.21 401.51 438.49 415.14 409.3 415.14Z"
                    fill="url(#paint2_radial_984_11217)"
                />
                <path
                    d="M215.74 383.93H108.85V393.31L108.87 394.31C108.87 394.45 108.85 393.59 108.85 393.74C108.85 410.93 132.78 424.86 162.3 424.86C191.82 424.86 215.75 410.93 215.75 393.74C215.75 393.6 215.73 393.45 215.73 393.31H215.75V383.93H215.74Z"
                    fill="url(#paint3_linear_984_11217)"
                />
                <path
                    d="M162.3 415.27C191.82 415.27 215.75 401.337 215.75 384.15C215.75 366.963 191.82 353.03 162.3 353.03C132.78 353.03 108.85 366.963 108.85 384.15C108.85 401.337 132.78 415.27 162.3 415.27Z"
                    fill="url(#paint4_linear_984_11217)"
                />
                <path
                    d="M162.3 415.14C133.1 415.14 109.39 401.5 108.88 384.57C108.87 384.76 108.86 384.94 108.86 385.13C108.86 402.32 132.79 416.25 162.31 416.25C191.83 416.25 215.76 402.32 215.76 385.13C215.76 384.94 215.74 384.76 215.74 384.57C215.21 401.51 191.49 415.14 162.3 415.14Z"
                    fill="url(#paint5_radial_984_11217)"
                />
                <path
                    d="M566.91 217.93H460.02V227.31L460.04 228.31C460.04 228.45 460.02 227.59 460.02 227.74C460.02 244.93 483.95 258.86 513.47 258.86C542.99 258.86 566.92 244.93 566.92 227.74C566.92 227.6 566.9 227.45 566.9 227.31H566.92V217.93H566.91Z"
                    fill="url(#paint6_linear_984_11217)"
                />
                <path
                    d="M513.46 249.27C542.98 249.27 566.91 235.337 566.91 218.15C566.91 200.963 542.98 187.03 513.46 187.03C483.94 187.03 460.01 200.963 460.01 218.15C460.01 235.337 483.94 249.27 513.46 249.27Z"
                    fill="url(#paint7_linear_984_11217)"
                />
                <path
                    d="M513.46 249.15C484.26 249.15 460.55 235.51 460.04 218.58C460.03 218.77 460.02 218.95 460.02 219.14C460.02 236.33 483.95 250.26 513.47 250.26C542.99 250.26 566.92 236.33 566.92 219.14C566.92 218.95 566.9 218.77 566.9 218.58C566.37 235.51 542.66 249.15 513.46 249.15Z"
                    fill="url(#paint8_radial_984_11217)"
                />
                <path
                    d="M111.58 217.93H4.67993V227.31L4.69993 228.31C4.69993 228.45 4.67993 227.59 4.67993 227.74C4.67993 244.93 28.6099 258.86 58.1299 258.86C87.6499 258.86 111.58 244.93 111.58 227.74C111.58 227.6 111.56 227.45 111.56 227.31H111.58V217.93Z"
                    fill="url(#paint9_linear_984_11217)"
                />
                <path
                    d="M58.1299 249.27C87.6496 249.27 111.58 235.337 111.58 218.15C111.58 200.963 87.6496 187.03 58.1299 187.03C28.6103 187.03 4.67993 200.963 4.67993 218.15C4.67993 235.337 28.6103 249.27 58.1299 249.27Z"
                    fill="url(#paint10_linear_984_11217)"
                />
                <path
                    d="M58.1299 249.15C28.9299 249.15 5.21994 235.51 4.70994 218.58C4.69994 218.77 4.68994 218.95 4.68994 219.14C4.68994 236.33 28.6199 250.26 58.1399 250.26C87.6599 250.26 111.59 236.33 111.59 219.14C111.59 218.95 111.57 218.77 111.57 218.58C111.04 235.51 87.3299 249.15 58.1299 249.15Z"
                    fill="url(#paint11_radial_984_11217)"
                />
                <path
                    d="M215.74 77.26H108.85V86.64L108.87 87.64C108.87 87.78 108.85 86.92 108.85 87.07C108.85 104.26 132.78 118.19 162.3 118.19C191.82 118.19 215.75 104.26 215.75 87.07C215.75 86.93 215.73 86.78 215.73 86.64H215.75V77.26H215.74Z"
                    fill="url(#paint12_linear_984_11217)"
                />
                <path
                    d="M162.3 108.6C191.82 108.6 215.75 94.6672 215.75 77.4801C215.75 60.293 191.82 46.3601 162.3 46.3601C132.78 46.3601 108.85 60.293 108.85 77.4801C108.85 94.6672 132.78 108.6 162.3 108.6Z"
                    fill="url(#paint13_linear_984_11217)"
                />
                <path
                    d="M162.3 108.48C133.1 108.48 109.39 94.8402 108.88 77.9102C108.87 78.1002 108.86 78.2802 108.86 78.4702C108.86 95.6602 132.79 109.59 162.31 109.59C191.83 109.59 215.76 95.6602 215.76 78.4702C215.76 78.2802 215.74 78.1002 215.74 77.9102C215.21 94.8402 191.49 108.48 162.3 108.48Z"
                    fill="url(#paint14_radial_984_11217)"
                />
                <path
                    d="M462.74 77.26H355.85V86.64L355.87 87.64C355.87 87.78 355.85 86.92 355.85 87.07C355.85 104.26 379.78 118.19 409.3 118.19C438.82 118.19 462.75 104.26 462.75 87.07C462.75 86.93 462.73 86.78 462.73 86.64H462.75V77.26H462.74Z"
                    fill="url(#paint15_linear_984_11217)"
                />
                <path
                    d="M409.3 108.6C438.82 108.6 462.75 94.6672 462.75 77.4801C462.75 60.293 438.82 46.3601 409.3 46.3601C379.78 46.3601 355.85 60.293 355.85 77.4801C355.85 94.6672 379.78 108.6 409.3 108.6Z"
                    fill="url(#paint16_linear_984_11217)"
                />
                <path
                    d="M409.3 108.48C380.1 108.48 356.39 94.8402 355.88 77.9102C355.87 78.1002 355.86 78.2802 355.86 78.4702C355.86 95.6602 379.79 109.59 409.31 109.59C438.83 109.59 462.76 95.6602 462.76 78.4702C462.76 78.2802 462.74 78.1002 462.74 77.9102C462.21 94.8402 438.49 108.48 409.3 108.48Z"
                    fill="url(#paint17_radial_984_11217)"
                />
                <g className={classes.opacityAnimation50}>
                    <path
                        d="M229.06 341.21C229.3 341.35 229.56 341.42 229.82 341.42C230.08 341.42 230.34 341.35 230.58 341.21L249.42 330.18C249.88 329.91 250.16 329.41 250.16 328.88C250.16 328.35 249.87 327.85 249.41 327.59L212.03 306.04L236.43 292.21C237.56 292.62 238.85 292.84 240.19 292.84C242.12 292.84 243.96 292.39 245.37 291.58C247.01 290.63 247.96 289.23 247.96 287.72C247.96 286.23 247.03 284.83 245.4 283.89C244.01 283.09 242.19 282.64 240.27 282.64C238.34 282.64 236.5 283.09 235.09 283.9C233.45 284.85 232.5 286.25 232.5 287.76C232.5 288.7 232.87 289.61 233.56 290.38L208.27 304.71C207.8 304.97 207.51 305.47 207.51 306.01C207.51 306.55 207.79 307.05 208.26 307.32L245.67 328.89L229.82 338.17L198.25 319.51C198.87 318.76 199.22 317.9 199.22 317C199.22 315.5 198.28 314.09 196.63 313.14C195.22 312.33 193.38 311.88 191.45 311.88C189.54 311.88 187.71 312.32 186.32 313.13C184.69 314.07 183.76 315.46 183.76 316.96C183.76 318.46 184.7 319.87 186.35 320.82C187.76 321.63 189.6 322.08 191.53 322.08C192.95 322.08 194.33 321.83 195.51 321.38L229.06 341.21ZM236.6 286.52C237.55 285.97 238.89 285.66 240.28 285.66C241.66 285.66 242.98 285.97 243.91 286.5C244.57 286.88 244.97 287.34 244.97 287.73C244.97 288.12 244.56 288.59 243.88 288.99C242.93 289.54 241.57 289.82 240.19 289.82C238.84 289.82 237.5 289.54 236.57 289.01C235.91 288.63 235.51 288.17 235.51 287.78C235.51 287.38 235.92 286.91 236.6 286.52ZM187.86 318.23C187.18 317.84 186.77 317.37 186.77 316.97C186.77 316.58 187.17 316.13 187.83 315.74C188.76 315.2 190.08 314.9 191.46 314.9C192.85 314.9 194.19 315.21 195.14 315.76C195.82 316.15 196.23 316.62 196.23 317.02C196.23 317.41 195.83 317.86 195.17 318.25C193.3 319.32 189.74 319.31 187.86 318.23Z"
                        fill="#45108A"
                    />
                    <path
                        d="M271.69 399.5L217.93 367.34L279.47 333.4C279.94 333.14 280.24 332.65 280.25 332.11C280.26 331.57 279.98 331.07 279.51 330.8L239.4 307.18L251.04 300.57L251.03 300.56C252.06 300.88 253.19 301.06 254.37 301.06C256.3 301.06 258.14 300.61 259.55 299.8C261.19 298.85 262.14 297.45 262.14 295.94C262.14 294.45 261.21 293.05 259.58 292.11C258.19 291.31 256.37 290.86 254.45 290.86C252.52 290.86 250.68 291.31 249.27 292.12C247.63 293.07 246.68 294.47 246.68 295.98C246.68 297.03 247.15 298.02 247.98 298.85L235.65 305.85C235.18 306.11 234.9 306.61 234.89 307.14C234.89 307.68 235.17 308.17 235.63 308.44L275.71 332.04L214.19 365.97C213.72 366.23 213.42 366.72 213.41 367.26C213.4 367.8 213.68 368.3 214.14 368.57L267.89 400.73L221.84 425.94L200.33 413.13L198.79 415.71L221.04 428.96C221.28 429.1 221.54 429.17 221.81 429.17C222.06 429.17 222.31 429.11 222.53 428.99L271.62 402.11C272.09 401.85 272.39 401.36 272.4 400.82C272.43 400.28 272.15 399.78 271.69 399.5ZM250.76 294.73C251.71 294.18 253.05 293.87 254.44 293.87C255.82 293.87 257.14 294.18 258.07 294.71C258.73 295.09 259.13 295.55 259.13 295.94C259.13 296.33 258.72 296.8 258.04 297.2C256.16 298.29 252.6 298.29 250.73 297.22C250.07 296.84 249.67 296.38 249.67 295.99C249.68 295.59 250.08 295.12 250.76 294.73Z"
                        fill="#45108A"
                    />
                    <path
                        d="M394.92 337.12L327.44 297.87C327.78 297.28 327.97 296.64 327.97 295.98C327.97 294.48 327.03 293.07 325.38 292.12C323.97 291.31 322.13 290.86 320.2 290.86C318.29 290.86 316.46 291.3 315.07 292.11C313.44 293.05 312.51 294.44 312.51 295.94C312.51 297.44 313.45 298.85 315.1 299.8C316.51 300.61 318.35 301.06 320.28 301.06C322.05 301.06 323.73 300.67 325.07 299.97L391.1 338.37L316.34 379.1C315.87 379.35 315.58 379.84 315.56 380.37C315.54 380.9 315.81 381.4 316.26 381.69L342.75 398.47L287.65 429.95C287.18 430.22 286.89 430.72 286.89 431.26C286.89 431.8 287.19 432.3 287.66 432.56L312.83 446.48C313.06 446.6 313.31 446.67 313.56 446.67C313.82 446.67 314.08 446.6 314.31 446.47L370.31 414.21L368.81 411.61L313.55 443.44L291.46 431.22L346.41 399.83C346.87 399.57 347.15 399.09 347.17 398.56C347.18 398.03 346.92 397.54 346.47 397.26L320.03 380.51L394.89 339.73C395.37 339.47 395.66 338.98 395.67 338.43C395.68 337.9 395.39 337.39 394.92 337.12ZM316.61 297.2C315.93 296.81 315.52 296.34 315.52 295.94C315.52 295.55 315.92 295.1 316.58 294.71C317.51 294.17 318.83 293.87 320.21 293.87C321.6 293.87 322.94 294.18 323.89 294.73C324.57 295.12 324.98 295.59 324.98 295.99C324.98 296.38 324.58 296.83 323.92 297.22C322.05 298.29 318.49 298.29 316.61 297.2Z"
                        fill="#45108A"
                    />
                    <path
                        d="M339.55 283.92C338.14 283.11 336.3 282.66 334.37 282.66C332.46 282.66 330.63 283.1 329.24 283.91C327.61 284.85 326.68 286.24 326.68 287.74C326.68 289.24 327.62 290.65 329.27 291.6C330.68 292.41 332.52 292.86 334.45 292.86C336.28 292.86 338.01 292.45 339.37 291.71L339.18 292.02L362.19 305.86C361.8 306.48 361.59 307.16 361.59 307.86C361.59 309.36 362.53 310.77 364.18 311.72C365.59 312.53 367.43 312.98 369.36 312.98C371.28 312.98 373.1 312.54 374.49 311.73C376.12 310.79 377.05 309.4 377.05 307.9C377.05 306.4 376.11 304.99 374.46 304.04C373.05 303.23 371.21 302.78 369.28 302.78C367.56 302.78 365.94 303.15 364.62 303.8L341.48 289.88C341.91 289.23 342.14 288.52 342.14 287.77C342.14 286.28 341.2 284.87 339.55 283.92ZM338.08 289.01C336.21 290.09 332.66 290.08 330.77 288.99C330.09 288.6 329.68 288.13 329.68 287.73C329.68 287.34 330.08 286.89 330.74 286.5C331.67 285.96 332.99 285.66 334.37 285.66C335.76 285.66 337.1 285.97 338.05 286.52C338.73 286.91 339.14 287.38 339.14 287.78C339.14 288.16 338.74 288.62 338.08 289.01ZM369.28 305.78C370.67 305.78 372.01 306.09 372.96 306.64C373.64 307.03 374.05 307.5 374.05 307.9C374.05 308.29 373.65 308.75 372.99 309.13C371.12 310.21 367.57 310.2 365.68 309.11C365 308.72 364.59 308.25 364.59 307.85C364.59 307.46 364.99 307.01 365.65 306.62C366.58 306.09 367.91 305.78 369.28 305.78Z"
                        fill="#45108A"
                    />
                    <path
                        d="M465.02 298.1C463.61 297.29 461.77 296.84 459.84 296.84C457.93 296.84 456.1 297.28 454.71 298.09C453.08 299.03 452.15 300.42 452.15 301.92C452.15 303.42 453.09 304.83 454.74 305.78C456.15 306.59 457.99 307.04 459.92 307.04C461.84 307.04 463.66 306.6 465.05 305.79C466.68 304.85 467.61 303.46 467.61 301.96C467.61 301.41 467.48 300.88 467.24 300.38L513 274.43L552.37 296.45L489.49 332.85C488.1 332.09 486.34 331.67 484.48 331.67C482.57 331.67 480.74 332.11 479.35 332.92C477.72 333.86 476.79 335.25 476.79 336.75C476.79 338.25 477.73 339.66 479.38 340.61C480.79 341.42 482.63 341.87 484.56 341.87C486.48 341.87 488.3 341.43 489.69 340.62C491.32 339.68 492.25 338.29 492.25 336.79C492.25 336.17 492.08 335.56 491.77 335L558.44 296.41L513 270.99L465.09 298.16C465.06 298.14 465.04 298.12 465.02 298.1ZM489.25 336.79C489.25 337.18 488.85 337.63 488.19 338.02C486.32 339.1 482.77 339.09 480.88 338C480.2 337.61 479.79 337.14 479.79 336.74C479.79 336.35 480.19 335.9 480.85 335.51C481.78 334.97 483.1 334.67 484.48 334.67C485.87 334.67 487.21 334.98 488.16 335.53C488.37 335.65 488.55 335.78 488.7 335.92L489.07 336.56L489.17 336.5C489.22 336.59 489.25 336.69 489.25 336.79ZM463.54 303.19C461.67 304.27 458.12 304.26 456.23 303.17C455.55 302.78 455.14 302.31 455.14 301.91C455.14 301.52 455.54 301.07 456.2 300.68C457.13 300.14 458.45 299.84 459.83 299.84C461.22 299.84 462.56 300.15 463.51 300.7C464.19 301.09 464.6 301.56 464.6 301.96C464.6 302.35 464.21 302.81 463.54 303.19Z"
                        fill="#45108A"
                    />
                    <path
                        d="M320.16 327.27L293.47 311.38C293.96 310.7 294.23 309.93 294.23 309.14C294.23 307.64 293.29 306.23 291.64 305.28C290.23 304.47 288.39 304.02 286.46 304.02C284.54 304.02 282.72 304.46 281.33 305.27C279.7 306.21 278.77 307.6 278.77 309.1C278.77 310.6 279.71 312.01 281.36 312.96C282.77 313.77 284.61 314.22 286.54 314.22C288.12 314.22 289.63 313.9 290.89 313.34L316.4 328.53L248.33 367.12C247.86 367.39 247.57 367.88 247.57 368.42C247.57 368.96 247.86 369.46 248.32 369.72L296.57 397.42C296.05 398.12 295.77 398.9 295.77 399.72C295.77 401.22 296.71 402.63 298.36 403.58C299.77 404.39 301.61 404.84 303.54 404.84C305.46 404.84 307.28 404.4 308.67 403.59C310.3 402.65 311.23 401.26 311.23 399.76C311.23 398.26 310.29 396.85 308.64 395.9C307.23 395.09 305.39 394.64 303.46 394.64C301.92 394.64 300.45 394.94 299.21 395.47L252.1 368.43L320.13 329.86C320.6 329.6 320.88 329.11 320.89 328.57C320.9 328.04 320.62 327.55 320.16 327.27ZM282.86 310.36C282.18 309.97 281.77 309.5 281.77 309.1C281.77 308.71 282.17 308.26 282.83 307.87C283.76 307.33 285.08 307.03 286.46 307.03C287.85 307.03 289.19 307.34 290.14 307.89C290.82 308.28 291.23 308.75 291.23 309.15C291.23 309.54 290.83 310 290.17 310.38C288.3 311.45 284.74 311.45 282.86 310.36ZM307.14 398.51C307.82 398.9 308.23 399.37 308.23 399.77C308.23 400.16 307.83 400.61 307.17 401C305.3 402.08 301.75 402.07 299.86 400.98C299.18 400.59 298.77 400.12 298.77 399.72C298.77 399.33 299.17 398.88 299.83 398.49C300.76 397.95 302.08 397.65 303.46 397.65C304.85 397.65 306.19 397.96 307.14 398.51Z"
                        fill="#45108A"
                    />
                    <path
                        d="M66.1601 303.05C67.5701 303.86 69.4101 304.31 71.3401 304.31C73.2601 304.31 75.0801 303.87 76.4701 303.06C78.1001 302.12 79.0301 300.73 79.0301 299.23C79.0301 298.13 78.5201 297.08 77.6001 296.23L111.61 274.18L160.34 303.01L208.45 275.89C209.5 276.22 210.66 276.42 211.87 276.42C213.8 276.42 215.64 275.97 217.05 275.16C218.69 274.21 219.64 272.81 219.64 271.31C219.64 269.82 218.71 268.42 217.08 267.48C215.69 266.68 213.87 266.23 211.95 266.23C210.02 266.23 208.18 266.68 206.77 267.49C205.13 268.44 204.18 269.84 204.18 271.35C204.18 272.37 204.62 273.34 205.42 274.15L160.37 299.55L111.53 270.65L74.5801 294.6C73.5501 294.29 72.4301 294.11 71.2601 294.11C69.3401 294.11 67.5201 294.55 66.1301 295.36C64.5001 296.3 63.5701 297.69 63.5701 299.19C63.5701 300.69 64.5201 302.1 66.1601 303.05ZM208.27 270.1C209.22 269.55 210.56 269.24 211.95 269.24C213.33 269.24 214.65 269.55 215.58 270.08C216.24 270.46 216.64 270.92 216.64 271.31C216.64 271.7 216.23 272.17 215.55 272.57C214.6 273.12 213.25 273.41 211.87 273.41C210.5 273.41 209.17 273.12 208.25 272.58C207.59 272.2 207.19 271.74 207.19 271.35C207.18 270.96 207.59 270.49 208.27 270.1ZM67.6301 297.96C68.5601 297.42 69.8801 297.12 71.2601 297.12C72.6501 297.12 73.9901 297.43 74.9401 297.98C75.6201 298.37 76.0301 298.84 76.0301 299.24C76.0301 299.63 75.6301 300.08 74.9701 300.47C73.1001 301.55 69.5501 301.54 67.6601 300.45C66.9801 300.06 66.5701 299.59 66.5701 299.19C66.5701 298.8 66.9701 298.34 67.6301 297.96Z"
                        fill="#45108A"
                    />
                    <path
                        d="M266.42 95.1799C266.42 96.6799 267.36 98.0899 269.01 99.0399C270.42 99.8499 272.26 100.3 274.19 100.3C276.1 100.3 277.93 99.8599 279.32 99.0499C280.95 98.1099 281.88 96.7199 281.88 95.2199C281.88 93.7199 280.94 92.3099 279.29 91.3599C277.88 90.5499 276.04 90.0999 274.11 90.0999C272.24 90.0999 270.46 90.5299 269.08 91.2999L227.92 68.5799L263.44 47.1499L343.11 91.1599L311.42 110.89C311.35 110.85 311.29 110.8 311.22 110.76C309.81 109.95 307.97 109.5 306.04 109.5C304.12 109.5 302.3 109.94 300.91 110.75C299.28 111.69 298.35 113.08 298.35 114.58C298.35 116.08 299.29 117.49 300.94 118.44C302.35 119.25 304.19 119.7 306.12 119.7C308.04 119.7 309.86 119.26 311.25 118.45C312.88 117.51 313.81 116.12 313.81 114.62C313.81 114.11 313.69 113.61 313.48 113.14L349.03 91.0099L263.37 43.6899L221.91 68.6999L266.83 93.4999C266.57 94.0299 266.42 94.5999 266.42 95.1799ZM309.75 115.86C307.88 116.94 304.33 116.93 302.44 115.84C301.76 115.45 301.35 114.98 301.35 114.58C301.35 114.19 301.75 113.73 302.41 113.35C303.34 112.81 304.66 112.51 306.04 112.51C307.43 112.51 308.77 112.82 309.72 113.37C310.4 113.76 310.81 114.23 310.81 114.63C310.81 115.01 310.41 115.47 309.75 115.86ZM277.79 93.9699C278.47 94.3599 278.88 94.8299 278.88 95.2299C278.88 95.6199 278.48 96.0799 277.82 96.4599C275.95 97.5399 272.4 97.5299 270.51 96.4399C269.83 96.0499 269.42 95.5799 269.42 95.1799C269.42 95.1099 269.45 95.0299 269.47 94.9599L269.67 95.0699L270.18 94.1499C270.28 94.0799 270.37 94.0099 270.48 93.9499C271.41 93.4099 272.73 93.1099 274.11 93.1099C275.5 93.1099 276.84 93.4199 277.79 93.9699Z"
                        fill="#45108A"
                    />
                    <path
                        d="M371.25 128.84C369.62 129.78 368.69 131.17 368.69 132.67C368.69 134.17 369.63 135.58 371.28 136.53C372.69 137.34 374.53 137.79 376.46 137.79C377.99 137.79 379.45 137.5 380.69 136.97L403.09 150.23L443.98 125.49C443.99 125.5 444 125.51 444.02 125.51C445.43 126.32 447.27 126.77 449.2 126.77C451.12 126.77 452.94 126.33 454.33 125.52C455.96 124.58 456.89 123.19 456.89 121.69C456.89 120.19 455.95 118.78 454.3 117.83C452.89 117.02 451.05 116.57 449.12 116.57C447.2 116.57 445.38 117.01 443.99 117.82C442.36 118.76 441.43 120.15 441.43 121.65C441.43 122.21 441.56 122.77 441.82 123.28L403.08 146.72L383.32 135.03C383.85 134.32 384.15 133.53 384.15 132.71C384.15 131.21 383.21 129.8 381.56 128.85C380.15 128.04 378.31 127.59 376.38 127.59C374.46 127.59 372.64 128.04 371.25 128.84ZM445.49 120.42C446.42 119.88 447.74 119.58 449.12 119.58C450.51 119.58 451.85 119.89 452.8 120.44C453.48 120.83 453.89 121.3 453.89 121.7C453.89 122.09 453.49 122.55 452.83 122.93C450.96 124.01 447.41 124 445.52 122.91C444.84 122.52 444.43 122.05 444.43 121.65C444.43 121.26 444.82 120.81 445.49 120.42ZM381.14 132.71C381.14 132.95 380.97 133.22 380.69 133.48L380.66 133.46L380.6 133.56C380.45 133.69 380.28 133.82 380.07 133.94C378.2 135.02 374.65 135.01 372.76 133.92C372.08 133.53 371.67 133.06 371.67 132.66C371.67 132.27 372.07 131.81 372.73 131.43C373.66 130.89 374.98 130.59 376.36 130.59C377.75 130.59 379.09 130.9 380.04 131.45C380.74 131.85 381.14 132.32 381.14 132.71Z"
                        fill="#45108A"
                    />
                    <path
                        d="M355.4 281.99C355.98 281.26 356.3 280.43 356.3 279.57C356.3 278.07 355.36 276.66 353.71 275.71C352.3 274.9 350.46 274.45 348.53 274.45C346.62 274.45 344.79 274.89 343.4 275.7C341.77 276.64 340.84 278.03 340.84 279.53C340.84 281.03 341.78 282.44 343.43 283.39C344.84 284.2 346.68 284.65 348.61 284.65C350.26 284.65 351.82 284.31 353.11 283.7L352.92 284.04L502.86 368.98L490.64 376.47C489.55 376.11 488.34 375.9 487.08 375.9C485.16 375.9 483.34 376.34 481.95 377.15C480.32 378.09 479.39 379.48 479.39 380.98C479.39 382.48 480.33 383.89 481.98 384.84C483.39 385.65 485.23 386.1 487.16 386.1C489.08 386.1 490.9 385.66 492.29 384.85C493.92 383.91 494.85 382.52 494.85 381.02C494.85 379.99 494.4 379.01 493.59 378.19L508.77 368.88L355.4 281.99ZM352.24 280.8C350.37 281.88 346.82 281.87 344.93 280.78C344.25 280.39 343.84 279.92 343.84 279.52C343.84 279.13 344.24 278.68 344.9 278.29C345.83 277.75 347.15 277.45 348.53 277.45C349.92 277.45 351.26 277.76 352.21 278.31C352.89 278.7 353.3 279.17 353.3 279.57C353.3 279.95 352.91 280.41 352.24 280.8ZM491.85 381.01C491.85 381.4 491.45 381.85 490.79 382.24C488.92 383.32 485.37 383.31 483.48 382.22C482.8 381.83 482.39 381.36 482.39 380.96C482.39 380.57 482.79 380.11 483.45 379.73C484.38 379.19 485.7 378.89 487.08 378.89C488.37 378.89 489.61 379.17 490.54 379.65L490.72 379.94L490.89 379.84C491.49 380.21 491.85 380.64 491.85 381.01Z"
                        fill="#45108A"
                    />
                    <path
                        d="M99.9099 247.49L164.2 284.81L193.84 267.55C195 267.98 196.33 268.22 197.71 268.22C199.64 268.22 201.48 267.77 202.89 266.96C204.53 266.01 205.48 264.61 205.48 263.11C205.48 261.62 204.55 260.22 202.92 259.28C201.53 258.48 199.71 258.03 197.79 258.03C195.86 258.03 194.02 258.48 192.61 259.29C190.97 260.24 190.02 261.64 190.02 263.15C190.02 264.07 190.38 264.95 191.03 265.72L164.2 281.35L101.42 244.91L99.9099 247.49ZM194.11 261.89C195.06 261.34 196.4 261.03 197.79 261.03C199.17 261.03 200.49 261.34 201.42 261.87C202.08 262.25 202.48 262.71 202.48 263.1C202.48 263.49 202.07 263.96 201.39 264.36C200.44 264.91 199.1 265.21 197.71 265.21C196.34 265.21 195.01 264.91 194.08 264.37C193.42 263.99 193.02 263.53 193.02 263.14C193.02 262.75 193.43 262.28 194.11 261.89Z"
                        fill="#45108A"
                    />
                    <path
                        d="M75.28 326.21L76.08 326.67L104.29 308.39C105.59 308.98 107.14 309.32 108.77 309.32C110.69 309.32 112.51 308.88 113.9 308.07C115.53 307.13 116.46 305.74 116.46 304.24C116.46 302.74 115.52 301.33 113.87 300.38C112.46 299.57 110.62 299.12 108.69 299.12C106.77 299.12 104.95 299.56 103.56 300.37C101.93 301.31 101 302.7 101 304.2C101 304.99 101.27 305.76 101.76 306.45L75.99 323.15L15.23 287.88C15.37 287.48 15.46 287.07 15.46 286.65C15.46 285.15 14.52 283.74 12.87 282.79C11.46 281.98 9.62 281.53 7.69 281.53C5.78 281.53 3.95 281.97 2.56 282.78C0.93 283.72 0 285.11 0 286.6C0 288.1 0.94 289.51 2.59 290.46C4 291.27 5.84 291.72 7.77 291.72C9.68 291.72 11.51 291.28 12.9 290.47C13.04 290.39 13.16 290.3 13.29 290.22L75.28 326.21ZM105.06 302.98C105.99 302.44 107.31 302.14 108.69 302.14C110.08 302.14 111.42 302.45 112.37 303C113.05 303.39 113.46 303.86 113.46 304.26C113.46 304.65 113.06 305.1 112.4 305.49C110.53 306.57 106.98 306.56 105.09 305.47C104.41 305.08 104 304.61 104 304.21C104 303.82 104.4 303.36 105.06 302.98ZM4.09 287.86C3.41 287.47 3 287 3 286.6C3 286.21 3.4 285.76 4.06 285.37C4.99 284.83 6.31 284.53 7.69 284.53C9.08 284.53 10.42 284.84 11.37 285.39C12.05 285.78 12.46 286.25 12.46 286.65C12.46 287.04 12.06 287.49 11.4 287.88C9.53 288.96 5.97 288.95 4.09 287.86Z"
                        fill="#45108A"
                    />
                    <path
                        d="M222.8 284.31L222.7 284.14C223.73 284.45 224.85 284.64 226.03 284.64C227.96 284.64 229.8 284.19 231.21 283.38C232.85 282.43 233.8 281.03 233.8 279.52C233.8 278.03 232.87 276.63 231.24 275.69C229.85 274.89 228.03 274.44 226.11 274.44C224.18 274.44 222.34 274.89 220.93 275.7C219.29 276.65 218.34 278.05 218.34 279.56C218.34 280.67 218.85 281.72 219.78 282.57L83.56 360.57C83.51 360.54 83.46 360.5 83.41 360.47C82 359.66 80.16 359.21 78.23 359.21C76.32 359.21 74.5 359.65 73.1 360.46C71.47 361.4 70.54 362.8 70.54 364.29C70.54 365.79 71.48 367.2 73.13 368.14C74.54 368.95 76.38 369.4 78.31 369.4C80.23 369.4 82.05 368.96 83.44 368.15C85.07 367.21 86 365.82 86 364.32C86 363.8 85.88 363.3 85.66 362.81L222.8 284.31ZM222.44 278.31C223.39 277.76 224.73 277.45 226.12 277.45C227.5 277.45 228.82 277.76 229.75 278.29C230.41 278.67 230.81 279.13 230.81 279.52C230.81 279.91 230.4 280.38 229.72 280.78C228.77 281.33 227.41 281.62 226.04 281.62C224.68 281.62 223.35 281.34 222.42 280.8C221.76 280.42 221.36 279.96 221.36 279.57C221.35 279.17 221.75 278.7 222.44 278.31ZM81.94 365.56C80.07 366.64 76.52 366.63 74.63 365.54C73.95 365.15 73.54 364.68 73.54 364.28C73.54 363.89 73.94 363.44 74.6 363.05C75.53 362.51 76.85 362.21 78.23 362.21C79.62 362.21 80.96 362.52 81.91 363.07C82.59 363.46 83 363.93 83 364.33C83 364.72 82.61 365.18 81.94 365.56Z"
                        fill="#45108A"
                    />
                    <path
                        d="M426.59 291.56L383.41 265.93C384.2 265.12 384.64 264.15 384.64 263.14C384.64 261.64 383.7 260.23 382.05 259.28C380.64 258.47 378.8 258.02 376.87 258.02C374.96 258.02 373.14 258.46 371.74 259.27C370.11 260.21 369.18 261.6 369.18 263.1C369.18 264.6 370.12 266.01 371.77 266.95C373.18 267.76 375.02 268.21 376.95 268.21C378.19 268.21 379.38 268.01 380.45 267.66L426.59 295.04L494.19 255.23L492.67 252.64L426.59 291.56ZM373.27 264.36C372.59 263.97 372.18 263.5 372.18 263.1C372.18 262.71 372.58 262.26 373.24 261.87C374.17 261.33 375.49 261.03 376.87 261.03C378.26 261.03 379.6 261.34 380.55 261.89C381.23 262.28 381.64 262.75 381.64 263.15C381.64 263.54 381.24 263.99 380.58 264.38C378.7 265.45 375.15 265.45 373.27 264.36Z"
                        fill="#45108A"
                    />
                    <path
                        d="M462.71 329.53L492.26 311.01C493.56 311.61 495.12 311.95 496.76 311.95C498.68 311.95 500.5 311.51 501.89 310.7C503.52 309.76 504.45 308.37 504.45 306.87C504.45 305.37 503.51 303.96 501.86 303.01C500.45 302.2 498.61 301.75 496.68 301.75C494.76 301.75 492.94 302.19 491.55 303C489.92 303.94 488.99 305.33 488.99 306.83C488.99 307.62 489.25 308.37 489.74 309.05L462.64 326.04L369.63 273.71C370.18 273 370.48 272.19 370.48 271.35C370.48 269.85 369.54 268.44 367.89 267.49C366.48 266.68 364.64 266.23 362.71 266.23C360.8 266.23 358.98 266.67 357.58 267.48C355.95 268.42 355.02 269.81 355.02 271.31C355.02 272.81 355.96 274.22 357.61 275.16C359.02 275.97 360.86 276.42 362.79 276.42C364.4 276.42 365.93 276.09 367.21 275.51L367.09 275.72L462.71 329.53ZM493.04 305.6C493.97 305.06 495.29 304.76 496.67 304.76C498.06 304.76 499.4 305.07 500.35 305.62C501.03 306.01 501.44 306.48 501.44 306.88C501.44 307.27 501.04 307.72 500.38 308.11C499.45 308.65 498.13 308.95 496.75 308.95C495.36 308.95 494.02 308.64 493.07 308.09C492.39 307.7 491.98 307.23 491.98 306.83C491.98 306.45 492.38 305.99 493.04 305.6ZM366.41 272.59C364.54 273.67 360.99 273.66 359.1 272.57C358.42 272.18 358.01 271.71 358.01 271.31C358.01 270.92 358.41 270.47 359.07 270.08C360 269.54 361.32 269.24 362.7 269.24C364.09 269.24 365.43 269.55 366.38 270.1C367.06 270.49 367.47 270.96 367.47 271.36C367.47 271.74 367.07 272.2 366.41 272.59Z"
                        fill="#45108A"
                    />
                    <path
                        d="M449.45 238.22L407.14 263.55L397.41 257.89C398.3 257.05 398.8 256.02 398.8 254.93C398.8 253.43 397.86 252.02 396.21 251.07C394.8 250.26 392.96 249.81 391.03 249.81C389.12 249.81 387.3 250.25 385.9 251.06C384.27 252 383.34 253.39 383.34 254.89C383.34 256.39 384.28 257.8 385.93 258.74C387.34 259.55 389.18 260 391.11 260C392.23 260 393.31 259.83 394.29 259.55L407.16 267.03L455.37 238.17L411.72 213L450.24 190.24C451.47 190.74 452.91 191.02 454.41 191.02C456.32 191.02 458.15 190.58 459.54 189.77C461.17 188.83 462.1 187.44 462.1 185.94C462.1 184.44 461.16 183.03 459.51 182.08C458.1 181.27 456.26 180.82 454.33 180.82C452.41 180.82 450.59 181.26 449.2 182.07C447.57 183.01 446.64 184.4 446.64 185.9C446.64 186.77 446.97 187.6 447.55 188.34L405.76 213.03L449.45 238.22ZM387.43 256.15C386.75 255.76 386.34 255.29 386.34 254.89C386.34 254.5 386.74 254.05 387.4 253.66C388.33 253.12 389.65 252.82 391.03 252.82C392.42 252.82 393.76 253.13 394.71 253.68C395.39 254.07 395.8 254.54 395.8 254.94C395.8 255.33 395.4 255.78 394.74 256.17C392.87 257.24 389.31 257.24 387.43 256.15ZM450.71 184.67C451.64 184.13 452.96 183.83 454.34 183.83C455.73 183.83 457.07 184.14 458.02 184.69C458.7 185.08 459.11 185.55 459.11 185.95C459.11 186.34 458.71 186.79 458.05 187.18C456.18 188.26 452.63 188.25 450.74 187.16C450.06 186.77 449.65 186.3 449.65 185.9C449.65 185.51 450.04 185.05 450.71 184.67Z"
                        fill="#45108A"
                    />
                    <path
                        d="M378.87 160.73L335.91 185.74L337.42 188.34L384.96 160.66L341.38 136.71L381.12 111.93L379.53 109.38L335.45 136.87L378.87 160.73Z"
                        fill="#45108A"
                    />
                    <path
                        d="M298.17 183.59L345.72 155.91L272.89 116.23L314.82 90.0799L282.45 72.8699C282.68 72.3699 282.81 71.8499 282.81 71.3099C282.81 69.8099 281.87 68.3999 280.22 67.4499C278.81 66.6399 276.97 66.1899 275.04 66.1899C273.13 66.1899 271.3 66.6299 269.91 67.4399C268.28 68.3799 267.35 69.7699 267.35 71.2699C267.35 72.7699 268.29 74.1799 269.94 75.1299C271.35 75.9399 273.19 76.3899 275.12 76.3899C277.03 76.3899 278.86 75.9499 280.25 75.1399C280.26 75.1299 280.27 75.1299 280.28 75.1199L308.82 90.2999L266.94 116.42L339.61 156.01L296.66 181.01L298.17 183.59ZM278.75 72.5199C276.88 73.5999 273.33 73.5899 271.44 72.4999C270.76 72.1099 270.35 71.6399 270.35 71.2399C270.35 70.8499 270.75 70.3899 271.41 70.0099C272.34 69.4699 273.66 69.1699 275.04 69.1699C276.43 69.1699 277.77 69.4799 278.72 70.0299C279.4 70.4199 279.81 70.8899 279.81 71.2899C279.81 71.6799 279.41 72.1399 278.75 72.5199Z"
                        fill="#45108A"
                    />
                    <path
                        d="M164.74 136.77C166.13 137.57 167.95 138.02 169.87 138.02C171.49 138.02 173.02 137.69 174.31 137.11L205.48 155.44L169.13 177.45L246.91 222.59L248.42 219.99L175.01 177.39L211.33 155.4L176.87 135.13C177.36 134.45 177.63 133.68 177.63 132.89C177.63 131.4 176.7 130 175.07 129.06C173.68 128.26 171.86 127.81 169.94 127.81C168.01 127.81 166.17 128.26 164.76 129.07C163.12 130.02 162.17 131.42 162.17 132.93C162.18 134.44 163.11 135.83 164.74 136.77ZM166.26 131.69C167.21 131.14 168.55 130.83 169.94 130.83C171.32 130.83 172.64 131.14 173.57 131.67C174.23 132.05 174.63 132.51 174.63 132.9C174.63 133.29 174.22 133.76 173.54 134.16C172.59 134.71 171.25 135.02 169.86 135.02C168.48 135.02 167.16 134.71 166.23 134.18C165.57 133.8 165.17 133.34 165.17 132.95C165.18 132.55 165.58 132.08 166.26 131.69Z"
                        fill="#45108A"
                    />
                    <path
                        d="M85.5099 113.74C86.8999 114.54 88.7199 114.99 90.6399 114.99C92.4899 114.99 94.2499 114.57 95.6299 113.82L162.76 155.14C162.6 155.56 162.5 156 162.5 156.46C162.5 157.95 163.43 159.35 165.06 160.29C166.45 161.09 168.27 161.54 170.19 161.54C172.12 161.54 173.96 161.09 175.37 160.28C177.01 159.33 177.96 157.93 177.96 156.42C177.96 154.93 177.03 153.53 175.4 152.59C174.01 151.79 172.19 151.34 170.27 151.34C168.34 151.34 166.5 151.79 165.09 152.6C164.96 152.67 164.85 152.75 164.73 152.83L97.8999 111.7C98.2199 111.13 98.3999 110.51 98.3999 109.88C98.3999 108.39 97.4699 106.99 95.8399 106.05C94.4499 105.25 92.6299 104.8 90.7099 104.8C88.7799 104.8 86.9399 105.25 85.5299 106.06C83.8899 107.01 82.9399 108.41 82.9399 109.92C82.9499 111.4 83.8899 112.8 85.5099 113.74ZM170.28 154.33C171.66 154.33 172.98 154.64 173.91 155.17C174.57 155.55 174.97 156.01 174.97 156.4C174.97 156.79 174.56 157.26 173.88 157.66C172 158.75 168.44 158.75 166.57 157.68C165.91 157.3 165.51 156.84 165.51 156.45C165.51 156.06 165.92 155.59 166.6 155.19C167.54 154.64 168.89 154.33 170.28 154.33ZM87.0399 108.65C87.9899 108.1 89.3299 107.79 90.7199 107.79C92.0999 107.79 93.4199 108.1 94.3499 108.63C95.0099 109.01 95.4099 109.47 95.4099 109.86C95.4099 110.25 94.9999 110.72 94.3199 111.12C93.3699 111.67 92.0299 111.98 90.6399 111.98C89.2599 111.98 87.9399 111.67 87.0099 111.14C86.3499 110.76 85.9499 110.3 85.9499 109.91C85.9499 109.52 86.3599 109.05 87.0399 108.65Z"
                        fill="#45108A"
                    />
                    <path
                        d="M122.56 237.64L168.9 264.95L179.03 259.06C180.33 259.67 181.89 260.01 183.54 260.01C185.47 260.01 187.31 259.56 188.72 258.75C190.36 257.8 191.31 256.4 191.31 254.9C191.31 253.41 190.38 252.01 188.75 251.07C187.36 250.27 185.54 249.82 183.62 249.82C181.69 249.82 179.85 250.27 178.44 251.08C176.8 252.03 175.85 253.43 175.85 254.94C175.85 255.68 176.08 256.4 176.51 257.05L168.9 261.48L128.43 237.63L169.02 213.42L145.26 199.62C145.84 198.89 146.16 198.06 146.16 197.2C146.16 195.71 145.23 194.31 143.6 193.37C142.21 192.57 140.39 192.12 138.47 192.12C136.54 192.12 134.7 192.57 133.29 193.38C131.65 194.33 130.7 195.73 130.7 197.24C130.7 198.73 131.63 200.13 133.26 201.07C134.65 201.87 136.47 202.32 138.39 202.32C139.9 202.32 141.34 202.04 142.57 201.53L163.11 213.46L122.56 237.64ZM179.94 253.68C180.89 253.13 182.23 252.82 183.62 252.82C185 252.82 186.32 253.13 187.25 253.66C187.91 254.04 188.31 254.5 188.31 254.89C188.31 255.28 187.9 255.75 187.22 256.15C186.27 256.7 184.93 257.01 183.54 257.01C182.16 257.01 180.84 256.7 179.91 256.17C179.25 255.79 178.85 255.33 178.85 254.94C178.86 254.54 179.26 254.07 179.94 253.68ZM134.77 198.45C134.11 198.07 133.71 197.61 133.71 197.22C133.71 196.83 134.12 196.36 134.8 195.96C135.75 195.41 137.09 195.1 138.48 195.1C139.86 195.1 141.18 195.41 142.11 195.94C142.77 196.32 143.17 196.78 143.17 197.17C143.17 197.56 142.76 198.03 142.08 198.43C140.19 199.52 136.64 199.53 134.77 198.45Z"
                        fill="#45108A"
                    />
                    <path
                        d="M291.72 366.85C290.37 366.17 288.7 365.78 286.95 365.78C285.03 365.78 283.21 366.22 281.82 367.03C280.19 367.97 279.26 369.36 279.26 370.86C279.26 372.36 280.2 373.77 281.85 374.72C283.26 375.53 285.1 375.98 287.03 375.98C288.95 375.98 290.77 375.54 292.16 374.73C293.79 373.79 294.72 372.4 294.72 370.9C294.72 370.13 294.47 369.39 294 368.71L350.4 337.14C351.78 337.88 353.52 338.3 355.36 338.3C357.28 338.3 359.1 337.86 360.49 337.05C362.12 336.11 363.05 334.72 363.05 333.22C363.05 331.72 362.11 330.31 360.46 329.36C359.05 328.55 357.21 328.1 355.28 328.1C353.37 328.1 351.54 328.54 350.15 329.35C348.52 330.29 347.59 331.68 347.59 333.18C347.59 333.81 347.77 334.43 348.08 335L291.59 366.62L291.72 366.85ZM290.65 372.12C288.78 373.2 285.23 373.19 283.34 372.1C282.66 371.71 282.25 371.24 282.25 370.84C282.25 370.45 282.65 370 283.31 369.61C284.24 369.07 285.56 368.77 286.94 368.77C288.33 368.77 289.67 369.08 290.62 369.63C291.3 370.02 291.71 370.49 291.71 370.89C291.71 371.28 291.32 371.74 290.65 372.12ZM351.65 331.96C352.58 331.42 353.9 331.12 355.28 331.12C356.67 331.12 358.01 331.43 358.96 331.98C359.64 332.37 360.05 332.84 360.05 333.24C360.05 333.63 359.65 334.09 358.99 334.47C357.12 335.55 353.57 335.54 351.68 334.45C351 334.06 350.59 333.59 350.59 333.19C350.59 332.8 350.99 332.34 351.65 331.96Z"
                        fill="#45108A"
                    />
                    <path
                        d="M245.62 122.42L272 137.18L219.06 166.89L308.65 219.58L310.18 217L225.08 166.95L278.14 137.17L245.52 118.93L229.52 129.18L189.8 107.11L188.34 109.73L229.63 132.67L245.62 122.42Z"
                        fill="#45108A"
                    />
                    <path
                        d="M408.07 237.53C407.79 238.07 407.64 238.64 407.64 239.23C407.64 240.73 408.58 242.14 410.23 243.09C411.64 243.9 413.48 244.35 415.41 244.35C417.32 244.35 419.14 243.91 420.54 243.1C422.17 242.16 423.1 240.76 423.1 239.27C423.1 237.77 422.16 236.36 420.51 235.42C419.1 234.61 417.26 234.16 415.33 234.16C413.47 234.16 411.7 234.59 410.32 235.35L351.69 203.24L394.3 178.03C395.66 178.72 397.34 179.12 399.12 179.12C401.04 179.12 402.86 178.68 404.25 177.87C405.88 176.93 406.81 175.54 406.81 174.04C406.81 172.54 405.87 171.13 404.22 170.18C402.81 169.37 400.97 168.92 399.04 168.92C397.12 168.92 395.3 169.36 393.91 170.17C392.28 171.11 391.35 172.5 391.35 174C391.35 174.68 391.55 175.34 391.92 175.95L345.63 203.34L408.07 237.53ZM419.01 238.02C419.69 238.41 420.1 238.88 420.1 239.28C420.1 239.67 419.7 240.13 419.04 240.51C417.17 241.59 413.62 241.58 411.73 240.49C411.05 240.1 410.64 239.63 410.64 239.23C410.64 239.15 410.67 239.06 410.7 238.97L410.94 239.1L411.45 238.17C411.53 238.11 411.61 238.05 411.7 238C412.63 237.46 413.95 237.16 415.33 237.16C416.73 237.16 418.07 237.47 419.01 238.02ZM395.42 172.77C396.35 172.23 397.67 171.93 399.05 171.93C400.44 171.93 401.78 172.24 402.73 172.79C403.41 173.18 403.82 173.65 403.82 174.05C403.82 174.44 403.42 174.89 402.76 175.28C400.89 176.36 397.34 176.35 395.45 175.26C394.77 174.87 394.36 174.4 394.36 174C394.36 173.61 394.75 173.15 395.42 172.77Z"
                        fill="#45108A"
                    />
                    <path
                        d="M421.72 159.23L438.14 168.33L376.97 204.46L378.5 207.04L444.18 168.24L427.69 159.1L479.33 127.65C479.49 127.76 479.64 127.86 479.81 127.96C481.22 128.77 483.06 129.22 484.99 129.22C486.91 129.22 488.73 128.78 490.12 127.97C491.75 127.03 492.68 125.64 492.68 124.14C492.68 122.64 491.74 121.23 490.09 120.28C488.68 119.47 486.84 119.02 484.91 119.02C482.99 119.02 481.17 119.46 479.78 120.27C478.15 121.21 477.22 122.6 477.22 124.1C477.22 124.5 477.29 124.9 477.43 125.29L421.72 159.23ZM481.29 122.89C482.22 122.35 483.54 122.05 484.92 122.05C486.31 122.05 487.65 122.36 488.6 122.91C489.28 123.3 489.69 123.77 489.69 124.17C489.69 124.56 489.29 125.02 488.63 125.4C486.76 126.48 483.21 126.47 481.32 125.38C480.64 124.99 480.23 124.52 480.23 124.12C480.23 123.73 480.63 123.27 481.29 122.89Z"
                        fill="#45108A"
                    />
                    <path
                        d="M210.3 217.78L146.22 182.11L160.08 174.19L121.77 150C122.03 149.48 122.17 148.92 122.17 148.35C122.17 146.86 121.24 145.46 119.61 144.52C118.22 143.72 116.4 143.27 114.48 143.27C112.55 143.27 110.71 143.72 109.3 144.53C107.66 145.48 106.71 146.89 106.71 148.39C106.71 149.88 107.64 151.28 109.27 152.22C110.66 153.02 112.48 153.47 114.4 153.47C116.33 153.47 118.17 153.02 119.58 152.21C119.59 152.2 119.6 152.19 119.62 152.19L154.26 174.07L140.12 182.15L208.85 220.41L210.3 217.78ZM114.4 150.46C113.02 150.46 111.7 150.15 110.77 149.62C110.11 149.24 109.71 148.78 109.71 148.39C109.71 148 110.12 147.53 110.8 147.13C111.75 146.58 113.09 146.27 114.48 146.27C115.86 146.27 117.18 146.58 118.11 147.11C118.77 147.49 119.17 147.95 119.17 148.34C119.17 148.73 118.76 149.2 118.08 149.6C117.13 150.15 115.79 150.46 114.4 150.46Z"
                        fill="#45108A"
                    />
                </g>
                <g opacity="0.2">
                    <path
                        opacity="0.0909"
                        d="M274.95 194.56L190.13 243.64C185.67 246.22 182.68 250.61 182.56 255.14C182.42 260.27 185.41 265.16 191.09 268.45L268.53 313.16C272.94 315.71 278.47 317.1 284.06 317.09C287.46 317.08 290.64 316.54 293.43 315.53C294.59 315.11 295.82 314.54 296.83 313.95L381.53 264.94C385.99 262.36 388.97 257.98 389.09 253.45C389.23 248.32 386.24 243.42 380.56 240.14L303.37 195.58C301.71 194.62 299.62 193.69 297.69 193.08C294.59 192.09 291.22 191.54 287.81 191.52C282.91 191.49 278.45 192.54 274.95 194.56Z"
                        fill="black"
                    />
                    <path
                        opacity="0.1818"
                        d="M275.65 197.67L195.2 244.22C191.18 246.54 188.01 250.85 187.78 254.93C187.51 259.74 190.08 264.42 195.54 267.58L269.51 310.29C273.69 312.7 278.94 314.01 284.22 313.98C287.44 313.96 290.45 313.43 293.08 312.47C294.12 312.09 295.38 311.49 296.29 310.97L376.5 264.56C380.52 262.24 383.66 257.95 383.89 253.87C384.16 249.06 381.59 244.38 376.13 241.22L302.66 198.8C301.16 197.94 299 196.95 297.27 196.39C294.33 195.43 291.13 194.87 287.88 194.83C283.24 194.77 278.98 195.75 275.65 197.67Z"
                        fill="black"
                    />
                    <path
                        opacity="0.2727"
                        d="M276.36 200.79L200.29 244.81C196.72 246.87 193.34 251.11 193.02 254.72C192.61 259.22 194.78 263.68 200.01 266.71L270.52 307.42C274.47 309.7 279.44 310.92 284.41 310.88C287.45 310.86 290.29 310.32 292.76 309.41C293.68 309.07 294.97 308.44 295.77 307.98L371.49 264.16C375.06 262.1 378.38 257.89 378.71 254.28C379.12 249.78 376.95 245.32 371.72 242.29L301.97 202.02C300.64 201.25 298.41 200.21 296.87 199.7C294.09 198.78 291.06 198.2 287.98 198.14C283.57 198.06 279.51 198.97 276.36 200.79Z"
                        fill="black"
                    />
                    <path
                        opacity="0.3636"
                        d="M277.06 203.9L205.36 245.39C202.24 247.19 198.65 251.35 198.24 254.5C197.69 258.71 199.45 262.93 204.46 265.83L271.51 304.54C275.22 306.68 279.92 307.82 284.58 307.77C287.44 307.74 290.11 307.21 292.42 306.34C293.23 306.04 294.54 305.39 295.24 304.98L366.47 263.76C369.59 261.96 373.11 257.84 373.52 254.69C374.07 250.48 372.31 246.26 367.3 243.36L301.27 205.24C300.11 204.57 297.8 203.46 296.46 203.01C293.84 202.12 290.98 201.53 288.07 201.45C283.91 201.35 280.04 202.18 277.06 203.9Z"
                        fill="black"
                    />
                    <path
                        opacity="0.4545"
                        d="M277.77 207.01L210.44 245.97C207.76 247.52 203.94 251.6 203.47 254.28C202.78 258.22 204.14 262.18 208.92 264.95L272.5 301.66C275.98 303.67 280.4 304.73 284.75 304.66C287.43 304.62 289.93 304.1 292.08 303.27C292.77 303.01 294.11 302.33 294.71 301.98L361.45 263.36C364.13 261.81 367.87 257.78 368.34 255.1C369.03 251.16 367.67 247.2 362.89 244.43L300.57 208.45C299.57 207.87 297.2 206.71 296.05 206.31C293.59 205.45 290.9 204.85 288.16 204.75C284.24 204.63 280.56 205.4 277.77 207.01Z"
                        fill="black"
                    />
                    <path
                        opacity="0.5455"
                        d="M278.47 210.13L215.51 246.56C213.28 247.85 208.69 251.8 208.69 254.07C207.07 257.49 208.81 261.44 213.37 264.08L273.49 298.79C276.74 300.67 280.88 301.64 284.92 301.56C287.43 301.51 289.74 301 291.75 300.21C292.32 299.99 293.68 299.28 294.19 298.99L356.45 262.97C358.68 261.68 363.17 257.79 363.17 255.52C364.79 252.1 363.05 248.15 358.49 245.51L299.89 211.68C299.06 211.2 296.61 209.97 295.66 209.63C293.36 208.81 290.84 208.19 288.26 208.08C284.57 207.92 281.09 208.61 278.47 210.13Z"
                        fill="black"
                    />
                    <path
                        opacity="0.6364"
                        d="M279.18 213.24L220.59 247.14C218.8 248.17 213.92 252.04 213.92 253.85C212.03 256.93 213.5 260.69 217.83 263.2L274.48 295.91C277.5 297.65 281.36 298.54 285.09 298.45C287.42 298.39 289.56 297.88 291.41 297.14C291.87 296.96 293.25 296.23 293.66 295.99L351.43 262.56C353.22 261.53 357.98 257.73 357.98 255.92C359.87 252.84 358.4 249.08 354.07 246.57L299.19 214.88C298.52 214.5 296.01 213.2 295.25 212.92C293.11 212.13 290.76 211.5 288.35 211.37C284.91 211.2 281.62 211.83 279.18 213.24Z"
                        fill="black"
                    />
                    <path
                        opacity="0.7273"
                        d="M279.88 216.35L225.66 247.72C224.32 248.49 219.14 252.27 219.14 253.63C216.97 256.37 218.17 259.94 222.28 262.32L275.47 293.03C278.26 294.64 281.83 295.44 285.26 295.34C287.41 295.27 289.38 294.77 291.07 294.08C291.41 293.94 292.82 293.18 293.13 293.01L346.41 262.18C347.75 261.41 352.79 257.71 352.79 256.35C354.96 253.61 353.76 250.04 349.65 247.66L298.49 218.12C297.99 217.83 295.41 216.46 294.84 216.24C292.86 215.48 290.69 214.84 288.44 214.69C285.24 214.49 282.15 215.04 279.88 216.35Z"
                        fill="black"
                    />
                    <path
                        opacity="0.8182"
                        d="M280.59 219.47L230.74 248.31C229.85 248.83 224.37 252.51 224.37 253.42C221.93 255.82 222.86 259.2 226.74 261.45L276.46 290.16C279.01 291.63 282.31 292.36 285.43 292.24C287.4 292.17 289.2 291.67 290.73 291.02C290.96 290.92 292.39 290.13 292.6 290.02L341.39 261.79C342.28 261.27 347.6 257.68 347.6 256.77C350.04 254.37 349.11 250.99 345.23 248.74L297.78 221.35C297.45 221.16 294.79 219.71 294.42 219.56C292.6 218.83 290.6 218.18 288.51 218.01C285.57 217.77 282.68 218.26 280.59 219.47Z"
                        fill="black"
                    />
                    <path
                        opacity="0.9091"
                        d="M281.29 222.58L235.81 248.89C235.36 249.15 229.59 252.75 229.59 253.2C226.88 255.26 227.53 258.45 231.19 260.57L277.45 287.28C279.77 288.62 282.79 289.26 285.6 289.13C287.39 289.05 289.02 288.56 290.39 287.95C290.5 287.9 291.96 287.08 292.07 287.02L336.37 261.39C336.82 261.13 342.42 257.63 342.42 257.18C345.13 255.12 344.48 251.93 340.82 249.81L297.09 224.56C296.92 224.46 294.2 222.94 294.02 222.86C292.35 222.17 290.53 221.5 288.61 221.31C285.9 221.06 283.21 221.47 281.29 222.58Z"
                        fill="black"
                    />
                    <path
                        opacity="0.2"
                        d="M290.06 284.89L337.23 257.59C340.21 255.87 339.83 252.87 336.4 250.88L293.61 226.17C290.17 224.18 284.97 223.97 281.99 225.69L234.82 252.99C231.84 254.71 232.22 257.71 235.65 259.7L278.44 284.41C281.89 286.39 287.09 286.61 290.06 284.89Z"
                        fill="black"
                    />
                </g>
                <path
                    d="M389.81 225.56H387.76C386.72 224.23 385.29 223 383.44 221.93L303.68 175.88C294.24 170.43 277.75 171.11 266.85 177.41L193.09 220C190.19 221.67 188 223.58 186.5 225.57H184.08V231.93H184.14C184.44 235.09 186.51 238.08 190.45 240.36L270.21 286.41C279.65 291.86 296.14 291.18 307.04 284.88L380.8 242.29C385.97 239.3 388.93 235.59 389.63 231.93H389.82V225.56H389.81Z"
                    fill="url(#paint18_linear_984_11217)"
                />
                <path
                    d="M270.21 281.55L190.45 235.5C181.01 230.05 182.19 220.53 193.09 214.24L266.85 171.65C277.75 165.36 294.24 164.67 303.68 170.12L383.44 216.17C392.88 221.62 391.7 231.14 380.8 237.43L307.04 280.02C296.13 286.31 279.65 287 270.21 281.55Z"
                    fill="url(#paint19_linear_984_11217)"
                />
                <path
                    d="M387.24 214.57H385.24C384.22 213.27 382.83 212.07 381.02 211.03L303.13 166.06C293.91 160.74 277.81 161.41 267.17 167.55L195.14 209.14C192.31 210.77 190.17 212.63 188.7 214.58H186.33V225.7H186.39C186.69 228.79 188.7 231.71 192.55 233.93L270.44 278.9C279.66 284.22 295.76 283.55 306.4 277.41L378.43 235.82C383.48 232.9 386.37 229.28 387.05 225.7H387.23V214.57H387.24Z"
                    fill="url(#paint20_linear_984_11217)"
                />
                <path
                    d="M389.65 207.18H387.6C386.56 205.85 385.13 204.62 383.28 203.55L303.52 157.5C294.08 152.05 277.59 152.73 266.69 159.03L192.93 201.62C190.03 203.29 187.84 205.2 186.34 207.19H183.92V220.55H183.98C184.28 223.71 186.35 226.7 190.29 228.98L270.05 275.03C279.49 280.48 295.98 279.8 306.88 273.5L380.64 230.91C385.81 227.92 388.77 224.21 389.47 220.55H389.66V207.18H389.65Z"
                    fill="url(#paint21_linear_984_11217)"
                />
                <path
                    d="M270.04 263.17L190.28 217.12C180.84 211.67 182.02 202.15 192.92 195.86L266.68 153.27C277.58 146.98 294.07 146.29 303.51 151.74L383.27 197.79C392.71 203.24 391.53 212.76 380.63 219.05L306.87 261.64C295.97 267.93 279.48 268.62 270.04 263.17Z"
                    fill="url(#paint22_linear_984_11217)"
                />
                <path
                    d="M380.63 217.41L306.87 260C295.97 266.29 279.48 266.98 270.04 261.53L190.28 215.48C186.49 213.29 184.44 210.45 184.02 207.42C183.44 211.34 185.47 215.17 190.28 217.95L270.04 264C279.48 269.45 295.97 268.77 306.87 262.47L380.63 219.88C387.16 216.11 390.17 211.19 389.54 206.68C388.97 210.46 385.98 214.32 380.63 217.41Z"
                    fill="url(#paint23_radial_984_11217)"
                />

                <g className={classes.chipDots}>
                    <path
                        opacity="0.2"
                        d="M286.19 166.68L289.39 164.83L286.21 163L283.01 164.85L286.19 166.68Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.5"
                        d="M280.18 170.15L283.38 168.3L280.2 166.47L277 168.31L280.18 170.15Z"
                        fill="#E7004C"
                    />
                    <path d="M274.17 173.62L277.37 171.77L274.19 169.94L270.99 171.78L274.17 173.62Z" fill="#E7004C" />
                    <path d="M268.16 177.09L271.36 175.24L268.18 173.4L264.99 175.25L268.16 177.09Z" fill="#E7004C" />
                    <path
                        opacity="0.5"
                        d="M262.16 180.56L265.35 178.71L262.18 176.87L258.98 178.72L262.16 180.56Z"
                        fill="#E7004C"
                    />
                    <path d="M256.15 184.02L259.35 182.18L256.17 180.34L252.97 182.19L256.15 184.02Z" fill="#E7004C" />
                    <path d="M250.14 187.49L253.34 185.65L250.16 183.81L246.96 185.66L250.14 187.49Z" fill="#E7004C" />
                    <path
                        opacity="0.5"
                        d="M244.13 190.96L247.33 189.12L244.15 187.28L240.95 189.13L244.13 190.96Z"
                        fill="#E7004C"
                    />
                    <path d="M238.12 194.43L241.32 192.58L238.14 190.75L234.95 192.6L238.12 194.43Z" fill="#E7004C" />
                    <path d="M232.12 197.9L235.31 196.05L232.14 194.22L228.94 196.06L232.12 197.9Z" fill="#E7004C" />
                    <path
                        opacity="0.5"
                        d="M226.11 201.37L229.31 199.52L226.13 197.69L222.93 199.53L226.11 201.37Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.5"
                        d="M220.1 204.84L223.3 202.99L220.12 201.16L216.92 203L220.1 204.84Z"
                        fill="#E7004C"
                    />
                    <path d="M214.09 208.31L217.29 206.46L214.11 204.62L210.91 206.47L214.09 208.31Z" fill="#E7004C" />
                    <path
                        opacity="0.5"
                        d="M291.87 169.96L295.07 168.11L291.89 166.28L288.69 168.12L291.87 169.96Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.5"
                        d="M285.86 173.43L289.06 171.58L285.88 169.75L282.68 171.59L285.86 173.43Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.5"
                        d="M279.85 176.9L283.05 175.05L279.87 173.21L276.67 175.06L279.85 176.9Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.5"
                        d="M273.84 180.37L277.04 178.52L273.86 176.68L270.66 178.53L273.84 180.37Z"
                        fill="#E7004C"
                    />
                    <path d="M267.84 183.83L271.03 181.99L267.85 180.15L264.66 182L267.84 183.83Z" fill="#E7004C" />
                    <path
                        opacity="0.5"
                        d="M261.83 187.3L265.03 185.46L261.85 183.62L258.65 185.47L261.83 187.3Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M255.82 190.77L259.02 188.93L255.84 187.09L252.64 188.94L255.82 190.77Z"
                        fill="#E7004C"
                    />
                    <path d="M249.81 194.24L253.01 192.39L249.83 190.56L246.63 192.41L249.81 194.24Z" fill="#E7004C" />
                    <path
                        opacity="0.5"
                        d="M243.8 197.71L247 195.86L243.82 194.03L240.62 195.87L243.8 197.71Z"
                        fill="#E7004C"
                    />
                    <path d="M237.79 201.18L240.99 199.33L237.81 197.5L234.62 199.34L237.79 201.18Z" fill="#E7004C" />
                    <path
                        opacity="0.5"
                        d="M231.79 204.65L234.98 202.8L231.81 200.97L228.61 202.81L231.79 204.65Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.5"
                        d="M225.78 208.12L228.98 206.27L225.8 204.43L222.6 206.28L225.78 208.12Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.5"
                        d="M219.77 211.58L222.97 209.74L219.79 207.9L216.59 209.75L219.77 211.58Z"
                        fill="#E7004C"
                    />
                    <path d="M297.55 173.24L300.74 171.39L297.57 169.56L294.37 171.4L297.55 173.24Z" fill="#E7004C" />
                    <path
                        opacity="0.5"
                        d="M291.54 176.71L294.74 174.86L291.56 173.02L288.36 174.87L291.54 176.71Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M285.53 180.17L288.73 178.33L285.55 176.49L282.35 178.34L285.53 180.17Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M279.52 183.64L282.72 181.8L279.54 179.96L276.34 181.81L279.52 183.64Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M273.51 187.11L276.71 185.27L273.53 183.43L270.34 185.28L273.51 187.11Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.5"
                        d="M267.51 190.58L270.7 188.73L267.53 186.9L264.33 188.75L267.51 190.58Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M261.5 194.05L264.7 192.2L261.52 190.37L258.32 192.22L261.5 194.05Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M255.49 197.52L258.69 195.67L255.51 193.84L252.31 195.68L255.49 197.52Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M249.48 200.99L252.68 199.14L249.5 197.31L246.3 199.15L249.48 200.99Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M243.47 204.46L246.67 202.61L243.49 200.77L240.29 202.62L243.47 204.46Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.5"
                        d="M237.46 207.93L240.66 206.08L237.48 204.24L234.29 206.09L237.46 207.93Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.5"
                        d="M231.46 211.39L234.65 209.55L231.48 207.71L228.28 209.56L231.46 211.39Z"
                        fill="#E7004C"
                    />
                    <path d="M225.45 214.86L228.65 213.02L225.47 211.18L222.27 213.03L225.45 214.86Z" fill="#E7004C" />
                    <path
                        opacity="0.5"
                        d="M303.23 176.52L306.42 174.67L303.25 172.83L300.05 174.68L303.23 176.52Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M297.22 179.98L300.42 178.14L297.24 176.3L294.04 178.15L297.22 179.98Z"
                        fill="#E7004C"
                    />
                    <path d="M237.13 214.67L240.33 212.83L237.15 210.99L233.96 212.84L237.13 214.67Z" fill="#E7004C" />
                    <path d="M231.13 218.14L234.32 216.3L231.15 214.46L227.95 216.31L231.13 218.14Z" fill="#E7004C" />
                    <path d="M308.9 179.79L312.1 177.95L308.92 176.11L305.73 177.96L308.9 179.79Z" fill="#E7004C" />
                    <path
                        opacity="0.2"
                        d="M302.9 183.26L306.09 181.42L302.92 179.58L299.72 181.43L302.9 183.26Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M242.81 217.95L246.01 216.1L242.83 214.27L239.64 216.12L242.81 217.95Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.5"
                        d="M236.81 221.42L240 219.57L236.83 217.74L233.63 219.59L236.81 221.42Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.5"
                        d="M314.58 183.07L317.78 181.23L314.6 179.39L311.4 181.24L314.58 183.07Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M308.57 186.54L311.77 184.7L308.59 182.86L305.4 184.71L308.57 186.54Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M248.49 221.23L251.69 219.38L248.51 217.55L245.31 219.39L248.49 221.23Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.5"
                        d="M242.48 224.7L245.68 222.85L242.5 221.02L239.31 222.86L242.48 224.7Z"
                        fill="#E7004C"
                    />
                    <path d="M320.26 186.35L323.46 184.5L320.28 182.67L317.08 184.52L320.26 186.35Z" fill="#E7004C" />
                    <path
                        opacity="0.2"
                        d="M314.25 189.82L317.45 187.97L314.27 186.14L311.07 187.99L314.25 189.82Z"
                        fill="#E7004C"
                    />
                    <path d="M254.17 224.51L257.37 222.66L254.19 220.83L250.99 222.67L254.17 224.51Z" fill="#E7004C" />
                    <path
                        opacity="0.5"
                        d="M248.16 227.98L251.36 226.13L248.18 224.3L244.98 226.14L248.16 227.98Z"
                        fill="#E7004C"
                    />
                    <path d="M325.94 189.63L329.14 187.78L325.96 185.95L322.76 187.79L325.94 189.63Z" fill="#E7004C" />
                    <path
                        opacity="0.2"
                        d="M319.93 193.1L323.13 191.25L319.95 189.42L316.75 191.26L319.93 193.1Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.5"
                        d="M259.85 227.79L263.05 225.94L259.87 224.11L256.67 225.95L259.85 227.79Z"
                        fill="#E7004C"
                    />
                    <path d="M253.84 231.26L257.04 229.41L253.86 227.57L250.66 229.42L253.84 231.26Z" fill="#E7004C" />
                    <path
                        opacity="0.5"
                        d="M331.62 192.91L334.82 191.06L331.64 189.23L328.44 191.07L331.62 192.91Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M325.61 196.38L328.81 194.53L325.63 192.7L322.43 194.54L325.61 196.38Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M265.53 231.07L268.73 229.22L265.55 227.38L262.35 229.23L265.53 231.07Z"
                        fill="#E7004C"
                    />
                    <path d="M259.52 234.53L262.72 232.69L259.54 230.85L256.34 232.7L259.52 234.53Z" fill="#E7004C" />
                    <path
                        opacity="0.5"
                        d="M337.3 196.19L340.5 194.34L337.32 192.51L334.12 194.35L337.3 196.19Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M331.29 199.66L334.49 197.81L331.31 195.97L328.11 197.82L331.29 199.66Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.5"
                        d="M271.21 234.34L274.4 232.5L271.23 230.66L268.03 232.51L271.21 234.34Z"
                        fill="#E7004C"
                    />
                    <path d="M265.2 237.81L268.4 235.97L265.22 234.13L262.02 235.98L265.2 237.81Z" fill="#E7004C" />
                    <path d="M342.98 199.47L346.17 197.62L343 195.78L339.8 197.63L342.98 199.47Z" fill="#E7004C" />
                    <path
                        opacity="0.2"
                        d="M336.97 202.93L340.17 201.09L336.99 199.25L333.79 201.1L336.97 202.93Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M276.89 237.62L280.08 235.78L276.9 233.94L273.71 235.79L276.89 237.62Z"
                        fill="#E7004C"
                    />
                    <path d="M270.88 241.09L274.08 239.24L270.9 237.41L267.7 239.26L270.88 241.09Z" fill="#E7004C" />
                    <path d="M348.65 202.74L351.85 200.9L348.67 199.06L345.48 200.91L348.65 202.74Z" fill="#E7004C" />
                    <path
                        opacity="0.5"
                        d="M342.65 206.21L345.84 204.37L342.67 202.53L339.47 204.38L342.65 206.21Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M336.64 209.68L339.84 207.84L336.66 206L333.46 207.85L336.64 209.68Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M330.63 213.15L333.83 211.3L330.65 209.47L327.45 211.32L330.63 213.15Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M324.62 216.62L327.82 214.77L324.64 212.94L321.44 214.78L324.62 216.62Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M318.61 220.09L321.81 218.24L318.63 216.41L315.43 218.25L318.61 220.09Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M312.6 223.56L315.8 221.71L312.62 219.88L309.43 221.72L312.6 223.56Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M306.6 227.03L309.79 225.18L306.62 223.34L303.42 225.19L306.6 227.03Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M300.59 230.49L303.79 228.65L300.61 226.81L297.41 228.66L300.59 230.49Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M288.57 237.43L291.77 235.59L288.59 233.75L285.39 235.6L288.57 237.43Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.5"
                        d="M282.56 240.9L285.76 239.05L282.58 237.22L279.39 239.07L282.56 240.9Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.5"
                        d="M276.56 244.37L279.75 242.52L276.58 240.69L273.38 242.54L276.56 244.37Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M354.33 206.02L357.53 204.18L354.35 202.34L351.15 204.19L354.33 206.02Z"
                        fill="#E7004C"
                    />
                    <path d="M348.32 209.49L351.52 207.64L348.34 205.81L345.15 207.66L348.32 209.49Z" fill="#E7004C" />
                    <path d="M342.32 212.96L345.51 211.11L342.34 209.28L339.14 211.13L342.32 212.96Z" fill="#E7004C" />
                    <path
                        opacity="0.5"
                        d="M336.31 216.43L339.51 214.58L336.33 212.75L333.13 214.59L336.31 216.43Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.5"
                        d="M330.3 219.9L333.5 218.05L330.32 216.22L327.12 218.06L330.3 219.9Z"
                        fill="#E7004C"
                    />
                    <path d="M324.29 223.37L327.49 221.52L324.31 219.69L321.11 221.53L324.29 223.37Z" fill="#E7004C" />
                    <path d="M318.28 226.84L321.48 224.99L318.3 223.15L315.1 225L318.28 226.84Z" fill="#E7004C" />
                    <path d="M312.28 230.3L315.47 228.46L312.3 226.62L309.1 228.47L312.28 230.3Z" fill="#E7004C" />
                    <path d="M306.27 233.77L309.47 231.93L306.29 230.09L303.09 231.94L306.27 233.77Z" fill="#E7004C" />
                    <path
                        opacity="0.5"
                        d="M300.26 237.24L303.46 235.4L300.28 233.56L297.08 235.41L300.26 237.24Z"
                        fill="#E7004C"
                    />
                    <path d="M294.25 240.71L297.45 238.86L294.27 237.03L291.07 238.88L294.25 240.71Z" fill="#E7004C" />
                    <path
                        opacity="0.5"
                        d="M288.24 244.18L291.44 242.33L288.26 240.5L285.06 242.34L288.24 244.18Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.5"
                        d="M282.23 247.65L285.43 245.8L282.25 243.97L279.06 245.81L282.23 247.65Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M360.01 209.3L363.21 207.45L360.03 205.62L356.83 207.47L360.01 209.3Z"
                        fill="#E7004C"
                    />
                    <path d="M354 212.77L357.2 210.92L354.02 209.09L350.82 210.93L354 212.77Z" fill="#E7004C" />
                    <path
                        opacity="0.5"
                        d="M347.99 216.24L351.19 214.39L348.01 212.56L344.82 214.4L347.99 216.24Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.5"
                        d="M341.99 219.71L345.18 217.86L342.01 216.03L338.81 217.87L341.99 219.71Z"
                        fill="#E7004C"
                    />
                    <path d="M335.98 223.18L339.18 221.33L336 219.49L332.8 221.34L335.98 223.18Z" fill="#E7004C" />
                    <path d="M329.97 226.65L333.17 224.8L329.99 222.96L326.79 224.81L329.97 226.65Z" fill="#E7004C" />
                    <path d="M323.96 230.11L327.16 228.27L323.98 226.43L320.78 228.28L323.96 230.11Z" fill="#E7004C" />
                    <path
                        opacity="0.5"
                        d="M317.95 233.58L321.15 231.74L317.97 229.9L314.78 231.75L317.95 233.58Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.5"
                        d="M311.95 237.05L315.14 235.21L311.97 233.37L308.77 235.22L311.95 237.05Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.5"
                        d="M305.94 240.52L309.14 238.67L305.96 236.84L302.76 238.69L305.94 240.52Z"
                        fill="#E7004C"
                    />
                    <path d="M299.93 243.99L303.13 242.14L299.95 240.31L296.75 242.15L299.93 243.99Z" fill="#E7004C" />
                    <path
                        opacity="0.5"
                        d="M293.92 247.46L297.12 245.61L293.94 243.78L290.74 245.62L293.92 247.46Z"
                        fill="#E7004C"
                    />
                    <path
                        opacity="0.2"
                        d="M287.91 250.93L291.11 249.08L287.93 247.25L284.73 249.09L287.91 250.93Z"
                        fill="#E7004C"
                    />
                </g>
                <path
                    d="M372.14 237.9L379.49 233.57L391.34 240.74C392.21 241.26 392.64 242.29 392.41 243.27L390.97 256.19L386.51 247.14C385.63 246.06 384.57 245.14 383.36 244.44L372.14 237.9Z"
                    fill="url(#paint24_linear_984_11217)"
                />
                <path
                    d="M387.09 246.38C386.21 245.3 385.15 244.39 383.94 243.68L373.08 237.35L372.14 237.9L383.37 244.44C384.57 245.14 385.64 246.05 386.52 247.14L390.98 256.19L391.04 255.94L387.09 246.38Z"
                    fill="url(#paint25_radial_984_11217)"
                />
                <path
                    d="M358.01 246.07L365.36 241.74L377.21 248.91C378.08 249.43 378.51 250.46 378.28 251.44L376.84 264.36L372.38 255.31C371.5 254.23 370.44 253.32 369.23 252.61L358.01 246.07Z"
                    fill="url(#paint26_linear_984_11217)"
                />
                <path
                    d="M372.96 254.54C372.08 253.46 371.02 252.55 369.81 251.84L358.95 245.51L358.01 246.06L369.24 252.6C370.44 253.3 371.51 254.21 372.39 255.3L376.85 264.35L376.91 264.1L372.96 254.54Z"
                    fill="url(#paint27_radial_984_11217)"
                />
                <path
                    d="M343.88 254.23L351.23 249.9L363.08 257.07C363.95 257.59 364.38 258.62 364.15 259.6L362.71 272.52L358.25 263.47C357.37 262.39 356.31 261.48 355.1 260.77L343.88 254.23Z"
                    fill="url(#paint28_linear_984_11217)"
                />
                <path
                    d="M358.82 262.71C357.94 261.63 356.88 260.72 355.67 260.01L344.81 253.68L343.87 254.23L355.1 260.77C356.3 261.47 357.37 262.38 358.25 263.47L362.71 272.52L362.77 272.27L358.82 262.71Z"
                    fill="url(#paint29_radial_984_11217)"
                />
                <path
                    d="M329.74 262.4L337.09 258.07L348.94 265.24C349.81 265.76 350.24 266.79 350.01 267.77L348.57 280.69L344.11 271.64C343.23 270.56 342.17 269.64 340.96 268.94L329.74 262.4Z"
                    fill="url(#paint30_linear_984_11217)"
                />
                <path
                    d="M344.69 270.88C343.81 269.8 342.75 268.89 341.54 268.18L330.68 261.85L329.74 262.4L340.97 268.94C342.17 269.64 343.24 270.55 344.12 271.64L348.58 280.69L348.64 280.44L344.69 270.88Z"
                    fill="url(#paint31_radial_984_11217)"
                />
                <path
                    d="M315.61 270.57L322.96 266.24L334.81 273.41C335.68 273.93 336.11 274.96 335.88 275.94L334.44 288.86L329.98 279.81C329.1 278.73 328.04 277.81 326.83 277.11L315.61 270.57Z"
                    fill="url(#paint32_linear_984_11217)"
                />
                <path
                    d="M330.56 279.05C329.68 277.97 328.62 277.05 327.41 276.35L316.55 270.02L315.61 270.57L326.84 277.11C328.04 277.81 329.11 278.72 329.99 279.81L334.45 288.86L334.51 288.61L330.56 279.05Z"
                    fill="url(#paint33_radial_984_11217)"
                />
                <path
                    d="M301.48 278.73L308.83 274.4L320.68 281.57C321.55 282.09 321.98 283.12 321.75 284.1L320.31 297.02L315.85 287.97C314.97 286.89 313.91 285.98 312.7 285.27L301.48 278.73Z"
                    fill="url(#paint34_linear_984_11217)"
                />
                <path
                    d="M316.42 287.21C315.54 286.13 314.48 285.22 313.27 284.51L302.41 278.18L301.47 278.73L312.7 285.27C313.9 285.97 314.97 286.88 315.85 287.97L320.31 297.02L320.37 296.77L316.42 287.21Z"
                    fill="url(#paint35_radial_984_11217)"
                />
                <path
                    d="M201.81 237.9L194.46 233.57L182.61 240.74C181.74 241.26 181.31 242.29 181.54 243.27L182.98 256.19L187.44 247.14C188.32 246.06 189.38 245.14 190.59 244.44L201.81 237.9Z"
                    fill="url(#paint36_linear_984_11217)"
                />
                <path
                    d="M186.86 246.38C187.74 245.3 188.8 244.39 190.01 243.68L200.87 237.35L201.81 237.9L190.58 244.44C189.38 245.14 188.31 246.05 187.43 247.14L182.97 256.19L182.91 255.94L186.86 246.38Z"
                    fill="url(#paint37_radial_984_11217)"
                />
                <path
                    d="M215.94 246.07L208.59 241.74L196.74 248.91C195.87 249.43 195.44 250.46 195.67 251.44L197.11 264.36L201.57 255.31C202.45 254.23 203.51 253.32 204.72 252.61L215.94 246.07Z"
                    fill="url(#paint38_linear_984_11217)"
                />
                <path
                    d="M201 254.54C201.88 253.46 202.94 252.55 204.15 251.84L215.01 245.51L215.95 246.06L204.72 252.6C203.52 253.3 202.45 254.21 201.57 255.3L197.11 264.35L197.05 264.1L201 254.54Z"
                    fill="url(#paint39_radial_984_11217)"
                />
                <path
                    d="M230.08 254.23L222.73 249.9L210.88 257.07C210.01 257.59 209.58 258.62 209.81 259.6L211.25 272.52L215.71 263.47C216.59 262.39 217.65 261.48 218.85 260.77L230.08 254.23Z"
                    fill="url(#paint40_linear_984_11217)"
                />
                <path
                    d="M215.13 262.71C216.01 261.63 217.07 260.72 218.28 260.01L229.14 253.68L230.08 254.23L218.85 260.77C217.65 261.47 216.58 262.38 215.7 263.47L211.24 272.52L211.18 272.27L215.13 262.71Z"
                    fill="url(#paint41_radial_984_11217)"
                />
                <path
                    d="M244.21 262.4L236.86 258.07L225.01 265.24C224.14 265.76 223.71 266.79 223.94 267.77L225.38 280.69L229.84 271.64C230.72 270.56 231.78 269.64 232.99 268.94L244.21 262.4Z"
                    fill="url(#paint42_linear_984_11217)"
                />
                <path
                    d="M229.26 270.88C230.14 269.8 231.2 268.89 232.41 268.18L243.27 261.85L244.21 262.4L232.98 268.94C231.78 269.64 230.71 270.55 229.83 271.64L225.37 280.69L225.31 280.44L229.26 270.88Z"
                    fill="url(#paint43_radial_984_11217)"
                />
                <path
                    d="M258.34 270.57L250.99 266.24L239.14 273.41C238.27 273.93 237.84 274.96 238.07 275.94L239.51 288.86L243.97 279.81C244.85 278.73 245.91 277.81 247.12 277.11L258.34 270.57Z"
                    fill="url(#paint44_linear_984_11217)"
                />
                <path
                    d="M243.4 279.05C244.28 277.97 245.34 277.05 246.55 276.35L257.41 270.02L258.35 270.57L247.12 277.11C245.92 277.81 244.85 278.72 243.97 279.81L239.51 288.86L239.45 288.61L243.4 279.05Z"
                    fill="url(#paint45_radial_984_11217)"
                />
                <path
                    d="M272.48 278.73L265.13 274.4L253.28 281.57C252.41 282.09 251.98 283.12 252.21 284.1L253.65 297.02L258.11 287.97C258.99 286.89 260.05 285.98 261.25 285.27L272.48 278.73Z"
                    fill="url(#paint46_linear_984_11217)"
                />
                <path
                    d="M257.53 287.21C258.41 286.13 259.47 285.22 260.68 284.51L271.54 278.18L272.48 278.73L261.25 285.27C260.05 285.97 258.98 286.88 258.1 287.97L253.64 297.02L253.58 296.77L257.53 287.21Z"
                    fill="url(#paint47_radial_984_11217)"
                />
                <g opacity="0.2">
                    <path
                        opacity="0.0909"
                        d="M394.19 358.46C395.68 357.6 397.56 357.14 399.44 357.16C400.2 357.17 400.92 357.27 401.59 357.42C402.31 357.59 403.15 357.93 403.73 358.26L449.46 384.66C451.03 385.57 451.85 387.01 451.76 388.57C451.73 389.01 451.63 389.44 451.48 389.86C451.08 390.97 449.95 392.15 448.67 392.89L422.99 407.72C422.67 407.91 422.24 408.12 421.89 408.27C420.65 408.78 419.24 409.07 417.82 409.08C416.19 409.09 414.71 408.74 413.55 408.07L367.65 381.57C366.07 380.66 365.26 379.22 365.36 377.65C365.38 377.27 365.47 376.9 365.58 376.54C365.95 375.36 367.12 374.11 368.46 373.33L394.19 358.46Z"
                        fill="black"
                    />
                    <path
                        opacity="0.1818"
                        d="M394.31 358.66C395.8 357.8 397.68 357.35 399.54 357.4C400.3 357.42 401.01 357.54 401.67 357.7C402.32 357.86 403.27 358.27 403.79 358.57L449.34 384.87C450.9 385.77 451.64 387.2 451.45 388.73C451.4 389.15 451.26 389.55 451.1 389.96C450.71 390.95 449.41 392.2 448.26 392.86L422.95 407.48C422.66 407.65 422.19 407.89 421.87 408.02C420.65 408.53 419.27 408.83 417.86 408.84C416.26 408.86 414.79 408.52 413.65 407.86L367.75 381.36C366.18 380.45 365.45 379.01 365.66 377.49C365.71 377.13 365.82 376.78 365.94 376.43C366.31 375.38 367.66 374.04 368.87 373.35L394.31 358.66Z"
                        fill="black"
                    />
                    <path
                        opacity="0.2727"
                        d="M394.42 358.86C395.9 358 397.8 357.57 399.64 357.63C400.39 357.66 401.1 357.8 401.76 357.97C402.33 358.12 403.39 358.6 403.86 358.87L449.24 385.07C450.8 385.97 451.45 387.39 451.16 388.88C451.08 389.28 450.92 389.66 450.75 390.05C450.37 390.91 448.9 392.24 447.88 392.83L422.93 407.23C422.67 407.38 422.15 407.65 421.86 407.77C420.67 408.28 419.3 408.59 417.92 408.61C416.35 408.64 414.89 408.31 413.77 407.66L367.87 381.16C366.3 380.26 365.66 378.82 365.97 377.33C366.04 376.99 366.18 376.66 366.32 376.32C366.68 375.4 368.23 373.98 369.3 373.36L394.42 358.86Z"
                        fill="black"
                    />
                    <path
                        opacity="0.3636"
                        d="M394.53 359.05C396.01 358.2 397.91 357.78 399.73 357.86C400.48 357.9 401.18 358.06 401.83 358.23C402.33 358.37 403.5 358.92 403.9 359.15L449.11 385.25C450.66 386.14 451.24 387.56 450.85 389C450.75 389.38 450.55 389.73 450.37 390.11C450.02 390.86 448.36 392.25 447.47 392.77L422.89 406.96C422.66 407.09 422.09 407.39 421.84 407.5C420.67 408.01 419.33 408.33 417.97 408.36C416.42 408.39 414.98 408.08 413.88 407.45L367.98 380.95C366.42 380.05 365.86 378.62 366.28 377.16C366.37 376.83 366.54 376.53 366.69 376.2C367.03 375.41 368.78 373.91 369.72 373.37L394.53 359.05Z"
                        fill="black"
                    />
                    <path
                        opacity="0.4545"
                        d="M394.65 359.25C396.13 358.4 398.04 357.99 399.84 358.1C400.59 358.15 401.28 358.33 401.92 358.51C402.35 358.63 403.62 359.26 403.97 359.46L449 385.46C450.54 386.35 451.04 387.75 450.55 389.16C450.42 389.52 450.2 389.84 450.01 390.21C449.68 390.84 447.84 392.31 447.07 392.75L422.86 406.73C422.67 406.84 422.04 407.17 421.83 407.27C420.68 407.78 419.36 408.11 418.03 408.15C416.51 408.19 415.08 407.89 414 407.27L368.1 380.77C366.54 379.87 366.06 378.44 366.59 377.03C366.71 376.72 366.91 376.45 367.06 376.12C367.38 375.45 369.34 373.88 370.14 373.41L394.65 359.25Z"
                        fill="black"
                    />
                    <path
                        opacity="0.5455"
                        d="M394.76 359.45C396.23 358.6 398.15 358.21 399.93 358.34C400.68 358.4 401.36 358.6 401.99 358.79C402.34 358.9 403.72 359.6 404.02 359.76L448.88 385.66C450.41 386.54 450.84 387.94 450.24 389.31C450.09 389.65 449.9 389.99 449.63 390.3C449.44 390.86 447.3 392.35 446.66 392.72L422.81 406.49C422.65 406.58 421.98 406.95 421.8 407.03C420.67 407.53 419.38 407.88 418.07 407.92C416.57 407.97 415.16 407.69 414.09 407.07L368.19 380.57C366.64 379.67 366.23 378.25 366.88 376.87C367.02 376.58 367.18 376.29 367.41 376.01C367.58 375.42 369.87 373.82 370.54 373.43L394.76 359.45Z"
                        fill="black"
                    />
                    <path
                        opacity="0.6364"
                        d="M394.88 359.65C396.35 358.8 398.28 358.43 400.04 358.57C400.79 358.64 401.46 358.85 402.09 359.05C402.37 359.14 403.86 359.91 404.09 360.05L448.78 385.85C450.3 386.73 450.67 388.12 449.96 389.45C449.79 389.77 449.57 390.09 449.29 390.38C449.14 390.83 446.8 392.38 446.29 392.67L422.81 406.22C422.68 406.29 421.96 406.69 421.82 406.75C420.72 407.25 419.44 407.61 418.15 407.66C416.68 407.72 415.28 407.45 414.23 406.84L368.33 380.34C366.78 379.45 366.44 378.03 367.22 376.68C367.38 376.41 367.57 376.13 367.81 375.88C367.94 375.4 370.45 373.74 370.99 373.43L394.88 359.65Z"
                        fill="black"
                    />
                    <path
                        opacity="0.7273"
                        d="M394.99 359.85C396.45 359 398.4 358.64 400.13 358.81C400.87 358.88 401.54 359.12 402.16 359.33C402.37 359.4 403.96 360.25 404.14 360.35L448.65 386.05C450.17 386.93 450.46 388.31 449.64 389.6C449.45 389.9 449.21 390.2 448.9 390.47C448.79 390.81 446.25 392.42 445.87 392.64L422.76 405.98C422.66 406.04 421.9 406.46 421.79 406.51C420.71 407.01 419.46 407.38 418.19 407.44C416.75 407.51 415.36 407.25 414.33 406.66L368.43 380.16C366.88 379.27 366.62 377.85 367.51 376.55C367.69 376.29 367.9 376.04 368.16 375.8C368.26 375.44 370.99 373.7 371.39 373.47L394.99 359.85Z"
                        fill="black"
                    />
                    <path
                        opacity="0.8182"
                        d="M395.11 360.05C396.57 359.21 398.52 358.86 400.24 359.05C400.98 359.13 401.64 359.39 402.25 359.61C402.39 359.66 404.09 360.59 404.2 360.66L448.54 386.26C450.05 387.13 450.28 388.51 449.34 389.75C449.13 390.03 448.86 390.31 448.54 390.56C448.47 390.78 445.73 392.46 445.48 392.61L422.74 405.74C422.68 405.78 421.86 406.24 421.79 406.27C420.73 406.77 419.51 407.15 418.26 407.21C416.84 407.29 415.47 407.04 414.46 406.46L368.56 379.96C367.02 379.07 366.82 377.65 367.84 376.39C368.04 376.15 368.27 375.91 368.55 375.69C368.62 375.45 371.56 373.64 371.83 373.49L395.11 360.05Z"
                        fill="black"
                    />
                    <path
                        opacity="0.9091"
                        d="M395.22 360.25C396.68 359.41 398.64 359.08 400.33 359.29C401.07 359.38 401.72 359.66 402.32 359.89C402.39 359.92 404.19 360.93 404.25 360.97L448.42 386.47C449.92 387.34 450.09 388.72 449.03 389.91C448.8 390.17 448.51 390.43 448.16 390.66C448.12 390.77 445.19 392.51 445.06 392.59L422.7 405.5C422.67 405.52 421.8 406.01 421.77 406.03C420.73 406.53 419.53 406.92 418.31 406.99C416.92 407.08 415.56 406.84 414.57 406.27L368.67 379.77C367.13 378.88 367 377.45 368.15 376.24C368.36 376.01 368.62 375.79 368.92 375.59C368.95 375.47 372.11 373.59 372.25 373.51L395.22 360.25Z"
                        fill="black"
                    />
                    <path
                        opacity="0.2"
                        d="M414.68 406.07L368.78 379.57C366.97 378.52 367.19 376.7 369.29 375.49L395.34 360.45C397.43 359.24 400.6 359.11 402.41 360.16L448.31 386.66C450.12 387.71 449.9 389.53 447.8 390.74L421.75 405.78C419.66 406.98 416.49 407.12 414.68 406.07Z"
                        fill="black"
                    />
                </g>
                <g className={classes.moveUpAnimation}>
                    <path
                        d="M414.68 406.03L368.78 379.53C367.97 379.06 367.57 378.44 367.56 377.79C367.56 377.77 367.56 375.54 367.56 375.52C367.57 374.73 368.16 376.1 369.29 375.45L395.34 360.41C397.43 359.2 400.6 359.07 402.41 360.12L448.31 386.62C448.92 386.97 449.35 385.49 449.51 385.96C449.56 386.12 449.53 388.2 449.53 388.36C449.55 389.17 448.96 390.03 447.8 390.7L421.75 405.74C419.66 406.94 416.49 407.07 414.68 406.03Z"
                        fill="url(#paint48_linear_984_11217)"
                    />
                    <path
                        d="M414.68 403.8L368.78 377.3C366.97 376.25 367.19 374.43 369.29 373.22L395.34 358.18C397.43 356.97 400.6 356.84 402.41 357.89L448.31 384.39C450.12 385.44 449.9 387.26 447.8 388.47L421.75 403.51C419.66 404.71 416.49 404.84 414.68 403.8Z"
                        fill="url(#paint49_linear_984_11217)"
                    />
                    <path
                        opacity="0.2"
                        d="M449.53 389.57C449.53 390.37 448.95 391.22 447.8 391.88L421.75 406.92C419.66 408.13 416.49 408.26 414.68 407.21L368.78 380.71C367.9 380.2 367.51 379.52 367.57 378.8C367.56 378.83 367.56 378.88 367.56 378.93C367.56 378.95 367.56 381.18 367.56 381.2C367.57 381.85 367.98 382.47 368.78 382.94L414.68 409.44C416.49 410.49 419.66 410.36 421.75 409.15L447.8 394.11C448.96 393.44 449.55 392.58 449.53 391.77C449.53 391.63 449.55 390.13 449.53 389.57Z"
                        fill="url(#paint50_linear_984_11217)"
                    />
                    <path
                        d="M417.75 403.58C416.72 403.58 415.79 403.37 415.14 403L369.24 376.5C368.95 376.33 368.47 375.99 368.47 375.52C368.47 375.03 368.95 374.46 369.74 374L395.79 358.96C396.75 358.4 398.05 358.08 399.33 358.08C400.36 358.08 401.29 358.29 401.94 358.66L447.84 385.16C448.13 385.33 448.61 385.67 448.61 386.14C448.61 386.63 448.13 387.2 447.34 387.66L421.29 402.7C420.33 403.27 419.04 403.58 417.75 403.58Z"
                        fill="url(#paint51_linear_984_11217)"
                    />
                    <path
                        d="M447.8 388.08L421.75 403.12C419.66 404.33 416.49 404.46 414.68 403.41L368.78 376.91C368.03 376.48 367.63 375.91 367.57 375.3C367.48 376.04 367.87 376.76 368.78 377.29L414.68 403.79C416.49 404.84 419.66 404.71 421.75 403.5L447.8 388.46C449.02 387.75 449.61 386.83 449.52 385.98C449.43 386.72 448.85 387.48 447.8 388.08Z"
                        fill="white"
                    />
                    <path
                        d="M422.84 394.03L385.57 372.51C384.82 372.08 384.92 371.33 385.78 370.83L399.77 362.75C400.63 362.25 401.94 362.2 402.68 362.63L439.95 384.15C440.7 384.58 440.6 385.33 439.74 385.83L425.75 393.91C424.89 394.41 423.58 394.46 422.84 394.03Z"
                        fill="url(#paint52_linear_984_11217)"
                    />
                    <path
                        opacity="0.3"
                        d="M400.58 364.33L402.97 365.71C403.27 365.89 403.76 365.89 404.07 365.71C404.37 365.54 404.37 365.25 404.07 365.08L401.68 363.7C401.38 363.52 400.89 363.52 400.58 363.7C400.28 363.87 400.28 364.15 400.58 364.33ZM404.67 366.69L405.8 367.34C406.1 367.52 406.59 367.52 406.9 367.34C407.2 367.17 407.2 366.88 406.9 366.71L405.77 366.06C405.47 365.88 404.98 365.88 404.67 366.06C404.37 366.23 404.37 366.51 404.67 366.69ZM407.51 368.32L408.64 368.97C408.94 369.15 409.43 369.15 409.74 368.97C410.04 368.8 410.04 368.51 409.74 368.34L408.61 367.69C408.31 367.51 407.82 367.51 407.51 367.69C407.2 367.86 407.2 368.15 407.51 368.32ZM410.34 369.96L411.47 370.61C411.77 370.79 412.26 370.79 412.57 370.61C412.87 370.44 412.87 370.15 412.57 369.98L411.44 369.33C411.14 369.15 410.65 369.15 410.34 369.33C410.03 369.5 410.03 369.78 410.34 369.96ZM413.17 371.59L414.3 372.24C414.6 372.42 415.09 372.42 415.4 372.24C415.7 372.07 415.7 371.78 415.4 371.61L414.27 370.96C413.97 370.78 413.48 370.78 413.17 370.96C412.87 371.13 412.87 371.42 413.17 371.59ZM416 373.23L417.13 373.88C417.43 374.06 417.92 374.06 418.23 373.88C418.53 373.71 418.53 373.42 418.23 373.25L417.1 372.6C416.8 372.42 416.31 372.42 416 372.6C415.7 372.77 415.7 373.05 416 373.23ZM418.84 374.86L419.97 375.51C420.27 375.69 420.76 375.69 421.07 375.51C421.37 375.34 421.37 375.05 421.07 374.88L419.94 374.23C419.64 374.05 419.15 374.05 418.84 374.23C418.53 374.4 418.53 374.69 418.84 374.86ZM421.67 376.5L422.8 377.15C423.1 377.33 423.59 377.33 423.9 377.15C424.2 376.98 424.2 376.69 423.9 376.52L422.77 375.87C422.47 375.69 421.98 375.69 421.67 375.87C421.36 376.04 421.36 376.32 421.67 376.5ZM424.5 378.13L425.63 378.78C425.93 378.96 426.42 378.96 426.73 378.78C427.03 378.61 427.03 378.32 426.73 378.15L425.6 377.5C425.3 377.32 424.81 377.32 424.5 377.5C424.19 377.68 424.2 377.96 424.5 378.13ZM427.33 379.77L428.46 380.42C428.76 380.6 429.25 380.6 429.56 380.42C429.86 380.25 429.86 379.96 429.56 379.79L428.43 379.14C428.13 378.96 427.64 378.96 427.33 379.14C427.03 379.31 427.03 379.59 427.33 379.77ZM430.16 381.4L431.29 382.05C431.59 382.23 432.08 382.23 432.39 382.05C432.69 381.88 432.69 381.59 432.39 381.42L431.26 380.77C430.96 380.59 430.47 380.59 430.16 380.77C429.86 380.95 429.86 381.23 430.16 381.4ZM433 383.04L434.13 383.69C434.43 383.87 434.92 383.87 435.23 383.69C435.53 383.52 435.53 383.23 435.23 383.06L434.1 382.41C433.8 382.23 433.31 382.23 433 382.41C432.69 382.58 432.69 382.86 433 383.04ZM435.89 384.71L437.02 385.36C437.32 385.54 437.81 385.54 438.12 385.36C438.42 385.19 438.42 384.9 438.12 384.73L436.99 384.08C436.69 383.9 436.2 383.9 435.89 384.08C435.58 384.25 435.58 384.53 435.89 384.71ZM398.04 365.88L399.02 366.45C399.37 366.65 399.92 366.65 400.27 366.45L401.24 365.89C401.58 365.69 401.58 365.37 401.24 365.17L400.26 364.6C399.91 364.4 399.36 364.4 399.01 364.6L398.04 365.16C397.69 365.36 397.69 365.69 398.04 365.88ZM403.1 368.09L404.07 367.53C404.41 367.33 404.41 367.01 404.07 366.81L403.09 366.24C402.74 366.04 402.19 366.04 401.84 366.24L400.87 366.8C400.53 367 400.53 367.32 400.87 367.52L401.85 368.09C402.19 368.29 402.75 368.29 403.1 368.09ZM403.7 369.16L404.68 369.73C405.03 369.93 405.58 369.93 405.93 369.73L406.9 369.17C407.24 368.97 407.24 368.65 406.9 368.45L405.92 367.88C405.57 367.68 405.02 367.68 404.67 367.88L403.7 368.44C403.35 368.63 403.36 368.96 403.7 369.16ZM406.53 370.79L407.51 371.36C407.86 371.56 408.41 371.56 408.76 371.36L409.73 370.8C410.07 370.6 410.07 370.28 409.73 370.08L408.75 369.51C408.4 369.31 407.85 369.31 407.5 369.51L406.53 370.07C406.19 370.27 406.19 370.59 406.53 370.79ZM412.56 371.71L411.58 371.14C411.23 370.94 410.68 370.94 410.33 371.14L409.36 371.7C409.02 371.9 409.02 372.22 409.36 372.42L410.34 372.99C410.69 373.19 411.24 373.19 411.59 372.99L412.56 372.43C412.91 372.23 412.91 371.91 412.56 371.71ZM415.4 373.35L414.42 372.78C414.07 372.58 413.52 372.58 413.17 372.78L412.2 373.34C411.86 373.54 411.86 373.86 412.2 374.06L413.18 374.63C413.53 374.83 414.08 374.83 414.43 374.63L415.4 374.07C415.74 373.87 415.74 373.55 415.4 373.35ZM418.23 374.98L417.25 374.41C416.9 374.21 416.35 374.21 416 374.41L415.03 374.97C414.69 375.17 414.69 375.49 415.03 375.69L416.01 376.26C416.36 376.46 416.91 376.46 417.26 376.26L418.23 375.7C418.58 375.5 418.57 375.18 418.23 374.98ZM421.06 376.62L420.08 376.05C419.73 375.85 419.18 375.85 418.83 376.05L417.86 376.61C417.52 376.81 417.52 377.13 417.86 377.33L418.84 377.9C419.19 378.1 419.74 378.1 420.09 377.9L421.06 377.34C421.41 377.14 421.41 376.82 421.06 376.62ZM423.89 378.25L422.91 377.68C422.56 377.48 422.01 377.48 421.66 377.68L420.69 378.24C420.35 378.44 420.35 378.76 420.69 378.96L421.67 379.53C422.02 379.73 422.57 379.73 422.92 379.53L423.89 378.97C424.24 378.77 424.24 378.45 423.89 378.25ZM426.72 379.89L425.74 379.32C425.39 379.12 424.84 379.12 424.49 379.32L423.52 379.88C423.18 380.08 423.18 380.4 423.52 380.6L424.5 381.17C424.85 381.37 425.4 381.37 425.75 381.17L426.72 380.61C427.07 380.41 427.07 380.09 426.72 379.89ZM426.36 382.24L427.34 382.81C427.69 383.01 428.24 383.01 428.59 382.81L429.56 382.25C429.9 382.05 429.9 381.73 429.56 381.53L428.58 380.96C428.23 380.76 427.68 380.76 427.33 380.96L426.36 381.52C426.01 381.72 426.01 382.04 426.36 382.24ZM432.39 383.16L431.41 382.59C431.06 382.39 430.51 382.39 430.16 382.59L429.19 383.15C428.85 383.35 428.85 383.67 429.19 383.87L430.17 384.44C430.52 384.64 431.07 384.64 431.42 384.44L432.39 383.88C432.74 383.68 432.74 383.36 432.39 383.16ZM436.54 385.55L434.3 384.26C433.95 384.06 433.4 384.06 433.05 384.26L432.08 384.82C431.74 385.02 431.74 385.34 432.08 385.54L434.32 386.83C434.67 387.03 435.22 387.03 435.57 386.83L436.54 386.27C436.89 386.08 436.88 385.75 436.54 385.55ZM395.41 367.4L397.65 368.69C398 368.89 398.55 368.89 398.9 368.69L399.87 368.13C400.21 367.93 400.21 367.61 399.87 367.41L397.63 366.12C397.28 365.92 396.73 365.92 396.38 366.12L395.41 366.68C395.07 366.88 395.07 367.2 395.41 367.4ZM399.5 369.76L400.48 370.33C400.83 370.53 401.38 370.53 401.73 370.33L402.7 369.77C403.04 369.57 403.04 369.25 402.7 369.05L401.72 368.48C401.37 368.28 400.82 368.28 400.47 368.48L399.5 369.04C399.16 369.24 399.16 369.56 399.5 369.76ZM403.31 371.96C403.66 372.16 404.21 372.16 404.56 371.96L405.53 371.4C405.87 371.2 405.87 370.88 405.53 370.68L404.55 370.11C404.2 369.91 403.65 369.91 403.3 370.11L402.33 370.67C401.99 370.87 401.99 371.19 402.33 371.39L403.31 371.96ZM406.15 373.6C406.5 373.8 407.05 373.8 407.4 373.6L408.37 373.04C408.71 372.84 408.71 372.52 408.37 372.32L407.39 371.75C407.04 371.55 406.49 371.55 406.14 371.75L405.17 372.31C404.83 372.51 404.83 372.83 405.17 373.03L406.15 373.6ZM408.97 373.38L408 373.94C407.66 374.14 407.66 374.46 408 374.66L408.98 375.23C409.33 375.43 409.88 375.43 410.23 375.23L411.2 374.67C411.54 374.47 411.54 374.15 411.2 373.95L410.22 373.38C409.87 373.19 409.31 373.19 408.97 373.38ZM411.86 374.98L410.77 375.61C410.46 375.79 410.46 376.08 410.77 376.26L411.87 376.9C412.18 377.08 412.69 377.08 413 376.9L414.09 376.27C414.4 376.09 414.4 375.8 414.09 375.62L412.99 374.98C412.68 374.81 412.17 374.81 411.86 374.98ZM414.69 376.62L413.6 377.25C413.29 377.43 413.29 377.72 413.6 377.9L414.7 378.53C415.01 378.71 415.52 378.71 415.83 378.53L416.92 377.9C417.23 377.72 417.23 377.43 416.92 377.25L415.82 376.61C415.51 376.44 415 376.44 414.69 376.62ZM417.53 378.26L416.44 378.89C416.13 379.07 416.13 379.36 416.44 379.54L417.54 380.18C417.85 380.36 418.36 380.36 418.67 380.18L419.76 379.55C420.07 379.37 420.07 379.08 419.76 378.9L418.66 378.26C418.34 378.08 417.84 378.08 417.53 378.26ZM420.36 379.89L419.27 380.52C418.96 380.7 418.96 380.99 419.27 381.17L420.37 381.81C420.68 381.99 421.19 381.99 421.5 381.81L422.59 381.18C422.9 381 422.9 380.71 422.59 380.53L421.49 379.89C421.17 379.71 420.67 379.71 420.36 379.89ZM423.19 381.53L422.1 382.16C421.79 382.34 421.79 382.63 422.1 382.81L423.2 383.45C423.51 383.63 424.02 383.63 424.33 383.45L425.42 382.82C425.73 382.64 425.73 382.35 425.42 382.17L424.32 381.53C424.01 381.35 423.5 381.35 423.19 381.53ZM427.16 385.08L428.25 384.45C428.56 384.27 428.56 383.98 428.25 383.8L427.15 383.16C426.84 382.98 426.33 382.98 426.02 383.16L424.93 383.79C424.62 383.97 424.62 384.26 424.93 384.44L426.03 385.08C426.35 385.26 426.85 385.26 427.16 385.08ZM429.99 386.72L431.08 386.09C431.39 385.91 431.39 385.62 431.08 385.44L429.98 384.8C429.67 384.62 429.16 384.62 428.85 384.8L427.76 385.43C427.45 385.61 427.45 385.9 427.76 386.08L428.86 386.71C429.18 386.89 429.68 386.89 429.99 386.72ZM433.97 387.1L432.87 386.46C432.56 386.28 432.05 386.28 431.74 386.46L430.65 387.09C430.34 387.27 430.34 387.56 430.65 387.74L431.75 388.38C432.06 388.56 432.57 388.56 432.88 388.38L433.97 387.75C434.29 387.57 434.29 387.28 433.97 387.1ZM392.73 368.88L396.28 370.93C396.59 371.11 397.1 371.11 397.41 370.93L398.5 370.3C398.81 370.12 398.81 369.83 398.5 369.65L394.95 367.6C394.64 367.42 394.13 367.42 393.82 367.6L392.73 368.23C392.42 368.41 392.42 368.7 392.73 368.88ZM398.01 371.93L399.11 372.57C399.42 372.75 399.93 372.75 400.24 372.57L401.33 371.94C401.64 371.76 401.64 371.47 401.33 371.29L400.23 370.65C399.92 370.47 399.41 370.47 399.1 370.65L398.01 371.28C397.7 371.46 397.7 371.75 398.01 371.93ZM400.85 373.57L401.95 374.21C402.26 374.39 402.77 374.39 403.08 374.21L404.17 373.58C404.48 373.4 404.48 373.11 404.17 372.93L403.07 372.3C402.76 372.12 402.25 372.12 401.94 372.3L400.85 372.93C400.53 373.09 400.53 373.38 400.85 373.57ZM403.68 375.2L404.78 375.84C405.09 376.02 405.6 376.02 405.91 375.84L407 375.21C407.31 375.03 407.31 374.74 407 374.56L405.9 373.92C405.59 373.74 405.08 373.74 404.77 373.92L403.68 374.55C403.36 374.73 403.37 375.02 403.68 375.2ZM408.74 377.47L409.83 376.84C410.14 376.66 410.14 376.37 409.83 376.19L408.73 375.55C408.42 375.37 407.91 375.37 407.6 375.55L406.51 376.18C406.2 376.36 406.2 376.65 406.51 376.83L407.61 377.47C407.92 377.65 408.43 377.65 408.74 377.47ZM411.57 379.11L412.66 378.48C412.97 378.3 412.97 378.01 412.66 377.83L411.56 377.19C411.25 377.01 410.74 377.01 410.43 377.19L409.34 377.82C409.03 378 409.03 378.29 409.34 378.47L410.44 379.11C410.76 379.29 411.26 379.29 411.57 379.11ZM414.4 380.74L415.49 380.11C415.8 379.93 415.8 379.64 415.49 379.46L414.39 378.82C414.08 378.64 413.57 378.64 413.26 378.82L412.17 379.45C411.86 379.63 411.86 379.92 412.17 380.1L413.27 380.73C413.59 380.92 414.09 380.92 414.4 380.74ZM417.24 382.38L418.33 381.75C418.64 381.57 418.64 381.28 418.33 381.1L417.23 380.46C416.92 380.28 416.41 380.28 416.1 380.46L415.01 381.09C414.7 381.27 414.7 381.56 415.01 381.74L416.11 382.38C416.42 382.56 416.93 382.56 417.24 382.38ZM420.07 384.01L421.16 383.38C421.47 383.2 421.47 382.91 421.16 382.73L420.06 382.09C419.75 381.91 419.24 381.91 418.93 382.09L417.84 382.72C417.53 382.9 417.53 383.19 417.84 383.37L418.94 384.01C419.25 384.19 419.76 384.19 420.07 384.01ZM422.9 385.65L423.99 385.02C424.3 384.84 424.3 384.55 423.99 384.37L422.89 383.73C422.58 383.55 422.07 383.55 421.76 383.73L420.67 384.36C420.36 384.54 420.36 384.83 420.67 385.01L421.77 385.65C422.08 385.83 422.59 385.83 422.9 385.65ZM423.5 386.65L424.6 387.29C424.91 387.47 425.42 387.47 425.73 387.29L426.82 386.66C427.13 386.48 427.13 386.19 426.82 386.01L425.72 385.37C425.41 385.19 424.9 385.19 424.59 385.37L423.5 386C423.19 386.18 423.19 386.47 423.5 386.65ZM431.35 388.62L428.55 387.01C428.24 386.83 427.73 386.83 427.42 387.01L426.33 387.64C426.02 387.82 426.02 388.11 426.33 388.29L429.13 389.9C429.44 390.08 429.95 390.08 430.26 389.9L431.35 389.27C431.67 389.09 431.66 388.8 431.35 388.62ZM390.12 370.47L395.16 373.38C395.51 373.58 396.08 373.58 396.43 373.38L397.38 372.83C397.73 372.63 397.73 372.3 397.38 372.09L392.34 369.18C391.99 368.98 391.42 368.98 391.07 369.18L390.12 369.73C389.76 369.94 389.76 370.27 390.12 370.47ZM397.04 374.47L397.99 375.02C398.34 375.22 398.91 375.22 399.26 375.02L400.21 374.47C400.56 374.27 400.56 373.94 400.21 373.73L399.26 373.18C398.91 372.98 398.34 372.98 397.99 373.18L397.04 373.73C396.68 373.93 396.68 374.26 397.04 374.47ZM399.87 376.1L400.82 376.65C401.17 376.85 401.74 376.85 402.09 376.65L403.04 376.1C403.39 375.9 403.39 375.57 403.04 375.36L402.09 374.81C401.74 374.61 401.17 374.61 400.82 374.81L399.87 375.36C399.51 375.57 399.51 375.9 399.87 376.1ZM402.7 377.74L403.65 378.29C404 378.49 404.57 378.49 404.92 378.29L405.87 377.74C406.22 377.54 406.22 377.21 405.87 377L404.92 376.45C404.57 376.25 404 376.25 403.65 376.45L402.7 377C402.35 377.2 402.35 377.53 402.7 377.74ZM405.53 379.37L406.48 379.92C406.83 380.12 407.4 380.12 407.75 379.92L408.7 379.37C409.05 379.17 409.05 378.84 408.7 378.63L407.75 378.08C407.4 377.88 406.83 377.88 406.48 378.08L405.53 378.63C405.18 378.84 405.18 379.17 405.53 379.37ZM408.36 381.01L409.31 381.56C409.66 381.76 410.23 381.76 410.58 381.56L411.53 381.01C411.88 380.81 411.88 380.48 411.53 380.27L410.58 379.72C410.23 379.52 409.66 379.52 409.31 379.72L408.36 380.27C408.01 380.47 408.01 380.8 408.36 381.01ZM411.2 382.64L412.15 383.19C412.5 383.39 413.07 383.39 413.42 383.19L414.37 382.64C414.72 382.44 414.72 382.11 414.37 381.9L413.42 381.35C413.07 381.15 412.5 381.15 412.15 381.35L411.2 381.9C410.84 382.11 410.84 382.44 411.2 382.64ZM414.03 384.28L414.98 384.83C415.33 385.03 415.9 385.03 416.25 384.83L417.2 384.28C417.55 384.08 417.55 383.75 417.2 383.54L416.25 382.99C415.9 382.79 415.33 382.79 414.98 382.99L414.03 383.54C413.67 383.74 413.68 384.07 414.03 384.28ZM416.86 385.91L417.81 386.46C418.16 386.66 418.73 386.66 419.08 386.46L420.03 385.91C420.38 385.71 420.38 385.38 420.03 385.17L419.08 384.62C418.73 384.42 418.16 384.42 417.81 384.62L416.86 385.17C416.51 385.38 416.51 385.71 416.86 385.91ZM419.69 387.55L420.64 388.1C420.99 388.3 421.56 388.3 421.91 388.1L422.86 387.55C423.21 387.35 423.21 387.02 422.86 386.81L421.91 386.26C421.56 386.06 420.99 386.06 420.64 386.26L419.69 386.81C419.34 387.02 419.34 387.34 419.69 387.55ZM422.53 389.18L423.48 389.73C423.83 389.93 424.4 389.93 424.75 389.73L425.7 389.18C426.05 388.98 426.05 388.65 425.7 388.44L424.75 387.89C424.4 387.69 423.83 387.69 423.48 387.89L422.53 388.44C422.17 388.65 422.17 388.98 422.53 389.18ZM428.59 390.13L427.64 389.58C427.29 389.38 426.72 389.38 426.37 389.58L425.42 390.13C425.07 390.33 425.07 390.66 425.42 390.87L426.37 391.42C426.72 391.62 427.29 391.62 427.64 391.42L428.59 390.87C428.95 390.66 428.95 390.33 428.59 390.13ZM391.92 371.98L389.71 370.7C389.36 370.5 388.79 370.5 388.44 370.7L387.49 371.25C387.14 371.45 387.14 371.78 387.49 371.99L389.7 373.27C390.05 373.47 390.62 373.47 390.97 373.27L391.92 372.72C392.28 372.52 392.27 372.19 391.92 371.98ZM394.75 373.62L393.8 373.07C393.45 372.87 392.88 372.87 392.53 373.07L391.58 373.62C391.23 373.82 391.23 374.15 391.58 374.36L392.53 374.91C392.88 375.11 393.45 375.11 393.8 374.91L394.75 374.36C395.11 374.15 395.11 373.82 394.75 373.62ZM397.59 375.25L396.64 374.7C396.29 374.5 395.72 374.5 395.37 374.7L394.42 375.25C394.07 375.45 394.07 375.78 394.42 375.99L395.37 376.54C395.72 376.74 396.29 376.74 396.64 376.54L397.59 375.99C397.94 375.79 397.94 375.46 397.59 375.25ZM417.41 386.7L399.46 376.34C399.11 376.14 398.54 376.14 398.19 376.34L397.24 376.89C396.89 377.09 396.89 377.42 397.24 377.63L415.19 387.99C415.54 388.19 416.11 388.19 416.46 387.99L417.41 387.44C417.77 387.23 417.77 386.9 417.41 386.7ZM420.25 388.34L419.3 387.79C418.95 387.59 418.38 387.59 418.03 387.79L417.08 388.34C416.73 388.54 416.73 388.87 417.08 389.08L418.03 389.63C418.38 389.83 418.95 389.83 419.3 389.63L420.25 389.08C420.6 388.87 420.6 388.54 420.25 388.34ZM423.08 389.97L422.13 389.42C421.78 389.22 421.21 389.22 420.86 389.42L419.91 389.97C419.56 390.17 419.56 390.5 419.91 390.71L420.86 391.26C421.21 391.46 421.78 391.46 422.13 391.26L423.08 390.71C423.43 390.5 423.43 390.17 423.08 389.97ZM425.97 391.64L425.02 391.09C424.67 390.89 424.1 390.89 423.75 391.09L422.8 391.64C422.45 391.84 422.45 392.17 422.8 392.38L423.75 392.93C424.1 393.13 424.67 393.13 425.02 392.93L425.97 392.38C426.32 392.17 426.32 391.84 425.97 391.64Z"
                        fill="url(#paint53_linear_984_11217)"
                    />
                    <path
                        d="M447.58 384.03L403.36 358.48C401.65 357.49 400.26 354.84 400.26 352.56V317.87C400.26 315.59 401.65 314.54 403.36 315.53L447.58 341.08C449.29 342.07 450.68 344.72 450.68 347V381.69C450.68 383.97 449.29 385.02 447.58 384.03Z"
                        fill="url(#paint54_linear_984_11217)"
                    />
                    <path
                        d="M447.98 382.24L404.23 356.97C402.85 356.09 402 354.34 402 352.55V317.7C402 317.28 402.46 317.01 402.83 317.23C402.87 317.26 402.91 317.27 402.93 317.29L446.72 342.59C448.36 343.54 448.95 345.22 448.95 347.01V381.79C448.95 382.25 448.46 382.53 448.06 382.3C448.02 382.27 448 382.25 447.98 382.24Z"
                        fill="url(#paint55_linear_984_11217)"
                    />
                    <path
                        d="M446.71 342.58L402.92 317.28C402.9 317.27 402.87 317.25 402.82 317.22C402.45 317.01 401.99 317.27 401.99 317.69V352.55C401.99 354.34 402.84 356.09 404.22 356.97L447.97 382.24C447.99 382.25 448.01 382.26 448.04 382.28C448.44 382.51 448.93 382.22 448.93 381.77V346.99C448.94 345.2 448.35 343.52 446.71 342.58ZM448.59 381.77C448.59 381.92 448.46 382.02 448.34 382.02C448.3 382.02 448.26 382.01 448.22 381.99L404.4 356.68C403.16 355.89 402.34 354.27 402.34 352.57V317.7C402.34 317.58 402.45 317.5 402.54 317.5C402.57 317.5 402.61 317.51 402.64 317.53L446.53 342.88C448.23 343.86 448.59 345.66 448.59 346.99V381.77Z"
                        fill="url(#paint56_linear_984_11217)"
                    />
                    <path
                        d="M448.46 340.6L404.24 315.05C403.56 314.66 402.94 314.59 402.43 314.78C402.37 314.81 401.5 315.26 401.44 315.3C401.97 315.04 402.64 315.09 403.37 315.51L447.59 341.06C449.3 342.05 450.69 344.7 450.69 346.98V381.67C450.69 383.09 450.15 384.04 449.33 384.31C449.4 384.31 449.48 384.29 449.6 384.22C449.64 384.2 450.58 383.67 450.61 383.64C451.2 383.23 451.57 382.38 451.57 381.21V346.52C451.56 344.24 450.17 341.59 448.46 340.6Z"
                        fill="url(#paint57_linear_984_11217)"
                    />
                    <path
                        d="M447.73 340.99L403.51 315.44C402.81 315.03 402.16 314.98 401.64 315.2C402.08 315.13 402.59 315.24 403.14 315.55L447.36 341.1C449.07 342.09 450.46 344.74 450.46 347.02V381.71C450.46 383.06 449.97 383.97 449.23 384.29C450.19 384.14 450.83 383.16 450.83 381.6V346.91C450.83 344.63 449.44 341.98 447.73 340.99Z"
                        fill="url(#paint58_radial_984_11217)"
                    />
                </g>
                <g className={classes.moveUpAnimation}>
                    <path
                        d="M538.26 209.7H485.88V217.57C485.88 217.57 485.88 217.71 485.88 217.78C485.88 226.2 497.61 233.03 512.07 233.03C526.53 233.03 538.26 226.2 538.26 217.78C538.26 217.71 538.25 217.64 538.25 217.57H538.26V209.7Z"
                        fill="url(#paint59_linear_984_11217)"
                    />
                    <path
                        d="M512.07 225.05C526.534 225.05 538.26 218.222 538.26 209.8C538.26 201.378 526.534 194.55 512.07 194.55C497.606 194.55 485.88 201.378 485.88 209.8C485.88 218.222 497.606 225.05 512.07 225.05Z"
                        fill="url(#paint60_linear_984_11217)"
                    />
                    <path
                        d="M512.07 224.99C497.76 224.99 486.14 218.31 485.89 210.01C485.89 210.1 485.88 210.19 485.88 210.28C485.88 218.7 497.61 225.53 512.07 225.53C526.53 225.53 538.26 218.7 538.26 210.28C538.26 210.19 538.25 210.1 538.25 210.01C538 218.31 526.38 224.99 512.07 224.99Z"
                        fill="url(#paint61_radial_984_11217)"
                    />
                    <path
                        d="M536.46 201.6H487.68V208.26H487.69C487.69 208.33 487.68 208.39 487.68 208.46C487.68 216.3 498.6 222.66 512.07 222.66C525.54 222.66 536.46 216.3 536.46 208.46C536.46 208.39 536.45 208.33 536.45 208.26H536.46V201.6Z"
                        fill="url(#paint62_linear_984_11217)"
                    />
                    <path
                        d="M536.46 200.44H487.68V207.1H487.69C487.69 207.17 487.68 207.23 487.68 207.3C487.68 215.14 498.6 221.5 512.07 221.5C525.54 221.5 536.46 215.14 536.46 207.3C536.46 207.23 536.45 207.17 536.45 207.1H536.46V200.44Z"
                        fill="url(#paint63_linear_984_11217)"
                    />
                    <path
                        d="M538.26 195.36H485.88V203.23C485.88 203.23 485.88 203.37 485.88 203.44C485.88 211.86 497.61 218.69 512.07 218.69C526.53 218.69 538.26 211.86 538.26 203.44C538.26 203.37 538.25 203.3 538.25 203.23H538.26V195.36Z"
                        fill="url(#paint64_linear_984_11217)"
                    />
                    <path
                        d="M512.07 210.72C526.534 210.72 538.26 203.893 538.26 195.47C538.26 187.048 526.534 180.22 512.07 180.22C497.606 180.22 485.88 187.048 485.88 195.47C485.88 203.893 497.606 210.72 512.07 210.72Z"
                        fill="url(#paint65_linear_984_11217)"
                    />
                    <path
                        d="M512.07 210.66C497.76 210.66 486.14 203.98 485.89 195.68C485.89 195.77 485.88 195.86 485.88 195.95C485.88 204.37 497.61 211.2 512.07 211.2C526.53 211.2 538.26 204.37 538.26 195.95C538.26 195.86 538.25 195.77 538.25 195.68C538 203.98 526.38 210.66 512.07 210.66Z"
                        fill="url(#paint66_radial_984_11217)"
                    />
                    <path
                        d="M536.46 187.27H487.68V193.93H487.69C487.69 194 487.68 194.06 487.68 194.13C487.68 201.97 498.6 208.33 512.07 208.33C525.54 208.33 536.46 201.97 536.46 194.13C536.46 194.06 536.45 194 536.45 193.93H536.46V187.27Z"
                        fill="url(#paint67_linear_984_11217)"
                    />
                    <path
                        d="M536.46 186.11H487.68V192.77H487.69C487.69 192.84 487.68 192.9 487.68 192.97C487.68 200.81 498.6 207.17 512.07 207.17C525.54 207.17 536.46 200.81 536.46 192.97C536.46 192.9 536.45 192.84 536.45 192.77H536.46V186.11Z"
                        fill="url(#paint68_linear_984_11217)"
                    />
                    <path
                        d="M538.26 181.43H485.88V189.3C485.88 189.3 485.88 189.44 485.88 189.51C485.88 197.93 497.61 204.76 512.07 204.76C526.53 204.76 538.26 197.93 538.26 189.51C538.26 189.44 538.25 189.37 538.25 189.3H538.26V181.43Z"
                        fill="url(#paint69_linear_984_11217)"
                    />
                    <path
                        d="M512.07 196.78C526.534 196.78 538.26 189.952 538.26 181.53C538.26 173.108 526.534 166.28 512.07 166.28C497.606 166.28 485.88 173.108 485.88 181.53C485.88 189.952 497.606 196.78 512.07 196.78Z"
                        fill="url(#paint70_linear_984_11217)"
                    />
                    <path
                        d="M512.07 196.73C497.76 196.73 486.14 190.05 485.89 181.75C485.89 181.84 485.88 181.93 485.88 182.02C485.88 190.44 497.61 197.27 512.07 197.27C526.53 197.27 538.26 190.44 538.26 182.02C538.26 181.93 538.25 181.84 538.25 181.75C538 190.04 526.38 196.73 512.07 196.73Z"
                        fill="url(#paint71_radial_984_11217)"
                    />
                    <path
                        d="M536.46 173.33H487.68V180H487.69C487.69 180.07 487.68 180.13 487.68 180.2C487.68 188.04 498.6 194.4 512.07 194.4C525.54 194.4 536.46 188.04 536.46 180.2C536.46 180.13 536.45 180.07 536.45 180H536.46V173.33Z"
                        fill="url(#paint72_linear_984_11217)"
                    />
                    <path
                        d="M536.46 172.18H487.68V178.84H487.69C487.69 178.91 487.68 178.97 487.68 179.04C487.68 186.88 498.6 193.24 512.07 193.24C525.54 193.24 536.46 186.88 536.46 179.04C536.46 178.97 536.45 178.91 536.45 178.84H536.46V172.18Z"
                        fill="url(#paint73_linear_984_11217)"
                    />
                    <path
                        d="M538.26 167.34H485.88V175.21C485.88 175.21 485.88 175.35 485.88 175.42C485.88 183.84 497.61 190.67 512.07 190.67C526.53 190.67 538.26 183.84 538.26 175.42C538.26 175.35 538.25 175.28 538.25 175.21H538.26V167.34Z"
                        fill="url(#paint74_linear_984_11217)"
                    />
                    <path
                        d="M512.07 182.69C526.534 182.69 538.26 175.863 538.26 167.44C538.26 159.018 526.534 152.19 512.07 152.19C497.606 152.19 485.88 159.018 485.88 167.44C485.88 175.863 497.606 182.69 512.07 182.69Z"
                        fill="url(#paint75_linear_984_11217)"
                    />
                    <path
                        d="M512.07 182.64C497.76 182.64 486.14 175.96 485.89 167.66C485.89 167.75 485.88 167.84 485.88 167.93C485.88 176.35 497.61 183.18 512.07 183.18C526.53 183.18 538.26 176.35 538.26 167.93C538.26 167.84 538.25 167.75 538.25 167.66C538 175.95 526.38 182.64 512.07 182.64Z"
                        fill="url(#paint76_radial_984_11217)"
                    />
                    <path
                        d="M536.46 159.24H487.68V165.9H487.69C487.69 165.97 487.68 166.03 487.68 166.1C487.68 173.94 498.6 180.3 512.07 180.3C525.54 180.3 536.46 173.94 536.46 166.1C536.46 166.03 536.45 165.97 536.45 165.9H536.46V159.24Z"
                        fill="url(#paint77_linear_984_11217)"
                    />
                    <path
                        d="M536.46 158.09H487.68V164.75H487.69C487.69 164.82 487.68 164.88 487.68 164.95C487.68 172.79 498.6 179.15 512.07 179.15C525.54 179.15 536.46 172.79 536.46 164.95C536.46 164.88 536.45 164.82 536.45 164.75H536.46V158.09Z"
                        fill="url(#paint78_linear_984_11217)"
                    />
                    <path
                        d="M538.26 153.25H485.88V161.12C485.88 161.12 485.88 161.26 485.88 161.33C485.88 169.75 497.61 176.58 512.07 176.58C526.53 176.58 538.26 169.75 538.26 161.33C538.26 161.26 538.25 161.19 538.25 161.12H538.26V153.25Z"
                        fill="url(#paint79_linear_984_11217)"
                    />
                    <path
                        d="M512.07 168.61C526.534 168.61 538.26 161.782 538.26 153.36C538.26 144.938 526.534 138.11 512.07 138.11C497.606 138.11 485.88 144.938 485.88 153.36C485.88 161.782 497.606 168.61 512.07 168.61Z"
                        fill="url(#paint80_linear_984_11217)"
                    />
                    <path
                        d="M512.07 168.55C497.76 168.55 486.14 161.87 485.89 153.57C485.89 153.66 485.88 153.75 485.88 153.84C485.88 162.26 497.61 169.09 512.07 169.09C526.53 169.09 538.26 162.26 538.26 153.84C538.26 153.75 538.25 153.66 538.25 153.57C538 161.86 526.38 168.55 512.07 168.55Z"
                        fill="url(#paint81_radial_984_11217)"
                    />
                    <path
                        d="M514.06 159.03C521.378 159.03 527.31 156.003 527.31 152.27C527.31 148.537 521.378 145.51 514.06 145.51C506.742 145.51 500.81 148.537 500.81 152.27C500.81 156.003 506.742 159.03 514.06 159.03Z"
                        fill="url(#paint82_radial_984_11217)"
                    />
                    <path
                        d="M522.55 148.3H501.59V152.37C501.59 152.37 501.59 152.43 501.59 152.45C501.59 155.82 506.28 158.55 512.07 158.55C517.86 158.55 522.55 155.82 522.55 152.45C522.55 152.42 522.55 152.39 522.55 152.37V148.3Z"
                        fill="url(#paint83_linear_984_11217)"
                    />
                    <path
                        d="M501.59 148.34C501.59 151.71 506.28 154.44 512.07 154.44C517.86 154.44 522.55 151.71 522.55 148.34C522.55 144.97 517.86 142.24 512.07 142.24C506.28 142.24 501.59 144.97 501.59 148.34Z"
                        fill="url(#paint84_linear_984_11217)"
                    />
                    <path
                        d="M512.07 152.21C515.71 152.21 518.66 150.491 518.66 148.37C518.66 146.249 515.71 144.53 512.07 144.53C508.43 144.53 505.48 146.249 505.48 148.37C505.48 150.491 508.43 152.21 512.07 152.21Z"
                        fill="url(#paint85_linear_984_11217)"
                    />
                    <path
                        d="M512.07 148.17C514.58 148.17 516.76 148.99 517.88 150.19C518.38 149.65 518.67 149.03 518.67 148.37C518.67 146.25 515.72 144.53 512.08 144.53C508.44 144.53 505.49 146.25 505.49 148.37C505.49 149.03 505.78 149.65 506.28 150.19C507.38 148.99 509.56 148.17 512.07 148.17Z"
                        fill="url(#paint86_linear_984_11217)"
                    />
                    <path
                        d="M512.07 154.42C506.34 154.42 501.69 151.75 501.59 148.43C501.59 148.47 501.59 148.5 501.59 148.54C501.59 151.91 506.28 154.64 512.07 154.64C517.86 154.64 522.55 151.91 522.55 148.54C522.55 148.5 522.55 148.47 522.55 148.43C522.45 151.75 517.8 154.42 512.07 154.42Z"
                        fill="url(#paint87_radial_984_11217)"
                    />
                </g>
                <g className={classes.moveUpAnimation}>
                    <path
                        d="M143.07 32.6699L179.7 53.9799L200.76 56.9899L164.11 36.0999L143.07 32.6699Z"
                        fill="url(#paint88_linear_984_11217)"
                    />
                    <path
                        d="M179.69 53.98V89.93L183.48 87.79V87L196.94 79.03L197.76 79.34L200.76 77.56V56.99L179.69 53.98Z"
                        fill="url(#paint89_linear_984_11217)"
                    />
                    <path
                        d="M179.7 53.9799V89.9299L143.07 68.6099V32.6699L179.7 53.9799Z"
                        fill="url(#paint90_linear_984_11217)"
                    />
                    <path
                        d="M182.61 69.35L198.64 59.72V78.82L197.76 79.34L196.94 79.03L183.48 87V87.79L182.61 88.3V69.35Z"
                        fill="#D1B4E3"
                    />
                    <path
                        d="M196.94 79.0298V61.7598L183.48 69.8398V86.9998L196.94 79.0298Z"
                        fill="url(#paint91_linear_984_11217)"
                    />
                    <path d="M196.94 63.0698V61.7598L183.48 69.8398V71.0398L196.94 63.0698Z" fill="#E6E7E8" />
                    <path d="M196.94 63.3199V62.6199L183.48 70.7099V71.2899L196.94 63.3199Z" fill="#E6E7E8" />
                    <path d="M196.94 64.69V63.99L183.48 72.07V72.65L196.94 64.69Z" fill="#E6E7E8" />
                    <path d="M196.94 66.0499V65.3499L183.48 73.4399V74.0199L196.94 66.0499Z" fill="#E6E7E8" />
                    <path d="M196.94 67.41V66.71L183.48 74.8V75.38L196.94 67.41Z" fill="#E6E7E8" />
                    <path d="M196.94 68.7698V68.0698L183.48 76.1598V76.7398L196.94 68.7698Z" fill="#E6E7E8" />
                    <path d="M196.94 70.1399V69.4399L183.48 77.5199V78.0999L196.94 70.1399Z" fill="#E6E7E8" />
                    <path d="M196.94 71.4998V70.7998L183.48 78.8798V79.4698L196.94 71.4998Z" fill="#E6E7E8" />
                    <path d="M196.94 72.8599V72.1599L183.48 80.2499V80.8299L196.94 72.8599Z" fill="#E6E7E8" />
                    <path d="M196.94 74.2198V73.5198L183.48 81.6098V82.1898L196.94 74.2198Z" fill="#E6E7E8" />
                    <path d="M196.94 75.5899V74.8899L183.48 82.9699V83.5499L196.94 75.5899Z" fill="#E6E7E8" />
                    <path d="M196.94 76.9498V76.2498L183.48 84.3298V84.9198L196.94 76.9498Z" fill="#E6E7E8" />
                    <path d="M196.94 78.3099V77.6099L183.48 85.6999V86.2799L196.94 78.3099Z" fill="#E6E7E8" />
                    <path
                        d="M159.51 75.2898V98.1798L122.03 76.7898V53.7698L159.51 75.2898Z"
                        fill="url(#paint92_linear_984_11217)"
                    />
                    <path
                        d="M159.51 75.4999L177.09 45.2699L139.61 23.8799L122.03 53.9799L159.51 75.4999Z"
                        fill="url(#paint93_linear_984_11217)"
                    />
                    <path d="M124.65 78.1799V58.1199L132.65 62.8199V82.8399L124.65 78.1799Z" fill="#F1E8F6" />
                    <path d="M131.79 63.3099V81.3299L125.52 77.6799V59.6399L131.79 63.3099Z" fill="#D1B4E3" />
                    <path
                        d="M159.51 98.1798V75.4998L177.01 45.0398V88.3798L159.51 98.1798Z"
                        fill="url(#paint94_linear_984_11217)"
                    />
                    <path
                        d="M160.37 46.9399L144.18 56.4099V92.6199L146.82 91.0799V68.1599L160.37 46.9399Z"
                        fill="url(#paint95_linear_984_11217)"
                    />
                    <path
                        d="M126.32 77.2899L131.78 80.4699V63.3099L126.32 60.1099V77.2899Z"
                        fill="url(#paint96_linear_984_11217)"
                    />
                    <path
                        opacity="0.5"
                        d="M126.32 77.2899L131.78 63.3099L126.32 60.1099V77.2899Z"
                        fill="url(#paint97_linear_984_11217)"
                    />
                    <path
                        opacity="0.5"
                        d="M126.32 60.1099V77.2899L131.79 80.4699V63.3099L126.32 60.1099ZM131.35 79.7099L126.75 77.0299V60.8699L131.35 63.5699V79.7099Z"
                        fill="url(#paint98_linear_984_11217)"
                    />
                    <path
                        d="M144.18 56.4098V92.6198L131.58 85.2898V49.0198L144.18 56.4098Z"
                        fill="url(#paint99_linear_984_11217)"
                    />
                    <path d="M133.88 86.54V66.49L141.88 71.18V91.2L133.88 86.54Z" fill="#F1E8F6" />
                    <path d="M141.02 71.68V89.69L134.75 86.04V68L141.02 71.68Z" fill="#D1B4E3" />
                    <path d="M149.03 92.05V71.99L157.03 76.68V96.7L149.03 92.05Z" fill="#F1E8F6" />
                    <path d="M156.16 77.18V95.19L149.9 91.55V73.5L156.16 77.18Z" fill="#D1B4E3" />
                    <path d="M133.88 63.8498V53.0198L141.88 57.7098V68.5098L133.88 63.8498Z" fill="#F1E8F6" />
                    <path d="M141.02 58.2098V66.9998L134.75 63.3498V54.5398L141.02 58.2098Z" fill="#D1B4E3" />
                    <path
                        d="M135.55 85.65L141.02 88.83V71.68L135.55 68.47V85.65Z"
                        fill="url(#paint100_linear_984_11217)"
                    />
                    <path d="M135.55 85.65L141.02 71.68L135.55 68.47V85.65Z" fill="url(#paint101_linear_984_11217)" />
                    <path
                        d="M150.69 91.15L156.16 94.33V77.18L150.69 73.97V91.15Z"
                        fill="url(#paint102_linear_984_11217)"
                    />
                    <path
                        opacity="0.5"
                        d="M150.69 91.15L156.16 77.18L150.69 73.97V91.15Z"
                        fill="url(#paint103_linear_984_11217)"
                    />
                    <path
                        d="M135.55 62.95L141.02 66.13V58.21L135.55 55V62.95Z"
                        fill="url(#paint104_linear_984_11217)"
                    />
                    <path
                        opacity="0.5"
                        d="M150.69 73.97V91.15L156.16 94.33V77.18L150.69 73.97ZM155.73 93.58L151.13 90.9V74.73L155.73 77.43V93.58Z"
                        fill="url(#paint105_linear_984_11217)"
                    />
                    <path d="M135.55 62.95L141.02 58.21L135.55 55V62.95Z" fill="url(#paint106_linear_984_11217)" />
                    <path
                        opacity="0.5"
                        d="M135.55 55V62.95L141.02 66.13V58.21L135.55 55ZM140.58 65.38L135.98 62.7V55.76L140.58 58.46V65.38Z"
                        fill="url(#paint107_linear_984_11217)"
                    />
                    <path
                        opacity="0.5"
                        d="M135.55 68.47V85.65L141.02 88.83V71.68L135.55 68.47ZM140.58 88.07L135.98 85.39V69.23L140.58 71.93V88.07Z"
                        fill="url(#paint108_linear_984_11217)"
                    />
                    <path d="M164.2 73.0999L165.58 72.3099L173.64 67.6199V55.8999L164.2 73.0999Z" fill="#D1B4E3" />
                    <path d="M166.51 70.7599L172.78 67.1199V59.3899L166.51 70.7599Z" fill="#F1E8F6" />
                    <path d="M164.35 75.4799L173.64 70.1599V90.2199L164.35 95.4999V75.4799Z" fill="#D1B4E3" />
                    <path d="M165.22 75.9799V93.9899L172.78 89.7199V71.6799L165.22 75.9799Z" fill="#F1E8F6" />
                    <path
                        d="M172.05 89.3199V72.0999L165.22 75.9799V93.1699L172.05 89.3199Z"
                        fill="url(#paint109_linear_984_11217)"
                    />
                    <path
                        d="M165.22 75.9799V93.1699L172.06 89.3199V72.0999L165.22 75.9799ZM171.62 89.0699L165.65 92.4299V76.2299L171.62 72.8499V89.0699Z"
                        fill="#E6E7E8"
                    />
                    <path d="M172.05 60.7L167.17 69.5599L172.05 66.72V60.7Z" fill="url(#paint110_linear_984_11217)" />
                    <path
                        opacity="0.5"
                        d="M167.17 69.5599L172.05 66.72V60.7L167.17 69.5599ZM171.62 66.47L168.31 68.3899L171.62 62.3899V66.47Z"
                        fill="url(#paint111_linear_984_11217)"
                    />
                    <path
                        d="M144.18 56.4099L160.37 46.9399L147.78 39.6099L131.58 49.0199L144.18 56.4099Z"
                        fill="url(#paint112_linear_984_11217)"
                    />
                    <path
                        d="M162.28 98.7599V99.8099L179.72 89.9199V88.8599L162.28 98.7599Z"
                        fill="url(#paint113_linear_984_11217)"
                    />
                    <path
                        d="M162.28 98.7599V99.8099L159.5 98.1799V97.1299L162.28 98.7599Z"
                        fill="url(#paint114_linear_984_11217)"
                    />
                    <path
                        d="M159.5 97.1298L162.28 98.7598L179.72 88.8598L177 87.2798L159.5 97.1298Z"
                        fill="url(#paint115_linear_984_11217)"
                    />
                    <path
                        d="M166.79 82.9698C166.79 83.2498 166.59 83.5998 166.34 83.7398C166.09 83.8798 165.89 83.7698 165.89 83.4898C165.89 83.2098 166.09 82.8598 166.34 82.7198C166.59 82.5698 166.79 82.6798 166.79 82.9698Z"
                        fill="url(#paint116_linear_984_11217)"
                    />
                    <path
                        d="M146.82 68.1599L160.37 46.9399L150.63 70.3499L146.82 68.1599Z"
                        fill="url(#paint117_linear_984_11217)"
                    />
                    <path
                        d="M159.5 97.1298L179.72 88.8598L177 87.2798L159.5 97.1298Z"
                        fill="url(#paint118_linear_984_11217)"
                    />
                    <path d="M196.94 61.7598V79.0298L197.76 79.3398V61.3098L196.94 61.7598Z" fill="#F1E8F6" />
                </g>
                <g opacity="0.2">
                    <path
                        opacity="0.0909"
                        d="M385.05 65.8899L385.83 65.4499C385.9 65.4099 388.68 63.7799 388.77 63.7599C390.5 62.8199 392.63 62.3299 394.75 62.3799C395.03 62.3899 395.31 62.4099 395.58 62.4299C397 62.5499 398.57 63.0499 399.62 63.6599L414.46 72.2299L429.29 80.7999C430.61 81.5599 431.73 82.8599 432.07 84.1299C432.16 84.4699 432.23 84.8199 432.25 85.1699C432.36 87.1299 431.18 89.0099 428.99 90.2699L428.21 90.7099C428.14 90.7499 425.36 92.3799 425.27 92.3999C423.54 93.3399 421.41 93.8299 419.29 93.7799C419.01 93.7699 418.73 93.7499 418.46 93.7299C417.04 93.6099 415.47 93.1099 414.42 92.4999L399.58 83.9299L384.75 75.3599C383.43 74.5999 382.31 73.2999 381.97 72.0299C381.88 71.6899 381.81 71.3399 381.79 70.9899C381.68 69.0299 382.86 67.1499 385.05 65.8899Z"
                        fill="black"
                    />
                    <path
                        opacity="0.1818"
                        d="M385.18 66.1199L385.95 65.6999C386.09 65.6199 388.68 64.1199 388.85 64.0899C390.58 63.2099 392.68 62.7699 394.73 62.8799C395 62.8899 395.27 62.9299 395.54 62.9599C396.82 63.0899 398.53 63.6899 399.48 64.2399L414.05 72.6599L428.59 81.0599C429.78 81.7499 431.06 83.0999 431.4 84.2299C431.5 84.5599 431.59 84.8799 431.63 85.2199C431.84 87.1099 430.74 88.9699 428.57 90.2299L427.8 90.6499C427.66 90.7299 425.07 92.2299 424.9 92.2599C423.17 93.1399 421.07 93.5699 419.02 93.4699C418.75 93.4499 418.48 93.4199 418.21 93.3899C416.93 93.2599 415.22 92.6599 414.27 92.1099L399.7 83.6899L385.16 75.2899C383.97 74.5999 382.69 73.2499 382.35 72.1199C382.25 71.7899 382.16 71.4699 382.12 71.1299C381.9 69.2399 383 67.3799 385.18 66.1199Z"
                        fill="black"
                    />
                    <path
                        opacity="0.2727"
                        d="M385.31 66.3499L386.07 65.9499C386.28 65.8299 388.68 64.4599 388.93 64.4099C390.66 63.5899 392.73 63.2099 394.71 63.3699C394.98 63.3899 395.24 63.4399 395.5 63.4699C396.64 63.6099 398.49 64.3099 399.33 64.7899L413.63 73.0499L427.89 81.2899C428.95 81.8999 430.4 83.3199 430.73 84.3099C430.84 84.6199 430.96 84.9299 431.01 85.2499C431.33 87.0699 430.31 88.9199 428.14 90.1699L427.38 90.5699C427.17 90.6899 424.77 92.0599 424.52 92.1099C422.79 92.9299 420.72 93.2999 418.74 93.1499C418.47 93.1299 418.21 93.0799 417.95 93.0499C416.81 92.9099 414.96 92.2099 414.12 91.7299L399.82 83.4699L385.56 75.2299C384.5 74.6199 383.05 73.1999 382.72 72.2099C382.61 71.8999 382.49 71.5899 382.44 71.2699C382.12 69.4499 383.14 67.5999 385.31 66.3499Z"
                        fill="black"
                    />
                    <path
                        opacity="0.3636"
                        d="M385.45 66.58L386.21 66.21C386.49 66.05 388.7 64.81 389.04 64.74C390.77 63.98 392.82 63.65 394.72 63.87C394.98 63.9 395.23 63.96 395.48 64C396.47 64.14 398.46 64.95 399.2 65.37L413.23 73.47L427.21 81.55C428.14 82.09 429.76 83.56 430.09 84.42C430.2 84.72 430.35 85 430.43 85.31C430.87 87.06 429.92 88.89 427.76 90.14L427 90.51C426.72 90.67 424.51 91.91 424.17 91.98C422.44 92.74 420.39 93.06 418.49 92.85C418.23 92.82 417.98 92.76 417.73 92.72C416.74 92.58 414.75 91.77 414.01 91.35L399.98 83.25L386 75.17C385.07 74.63 383.45 73.16 383.12 72.3C383.01 72 382.86 71.72 382.78 71.41C382.34 69.66 383.29 67.83 385.45 66.58Z"
                        fill="black"
                    />
                    <path
                        opacity="0.4545"
                        d="M385.58 66.8099L386.33 66.4599C386.68 66.2599 388.7 65.1499 389.12 65.0699C390.85 64.3699 392.87 64.0999 394.7 64.3699C394.96 64.4099 395.2 64.4799 395.44 64.5199C396.29 64.6499 398.42 65.5799 399.06 65.9399L412.82 73.8899L426.52 81.7999C427.31 82.2599 429.12 83.7899 429.43 84.5099C429.55 84.7999 429.73 85.0599 429.82 85.3399C430.37 87.0199 429.5 88.8299 427.35 90.0799L426.6 90.4299C426.25 90.6299 424.23 91.7399 423.81 91.8199C422.08 92.5199 420.06 92.7799 418.23 92.5199C417.98 92.4799 417.73 92.4099 417.49 92.3699C416.64 92.2399 414.51 91.3099 413.87 90.9499L400.11 82.9999L386.41 75.0899C385.62 74.6299 383.81 73.0999 383.5 72.3799C383.38 72.0899 383.2 71.8299 383.11 71.5399C382.55 69.8699 383.43 68.0499 385.58 66.8099Z"
                        fill="black"
                    />
                    <path
                        opacity="0.5455"
                        d="M385.71 67.0398L386.45 66.7198C386.87 66.4798 388.7 65.5098 389.2 65.3998C390.93 64.7498 392.92 64.5398 394.68 64.8698C394.93 64.9198 395.16 64.9998 395.4 65.0398C396.1 65.1698 398.38 66.2098 398.91 66.5098L412.4 74.2998L425.81 82.0498C426.47 82.4298 428.6 83.9698 428.75 84.6098C428.94 84.8598 429.08 85.1198 429.19 85.3898C429.85 86.9998 429.05 88.7998 426.91 90.0298L426.17 90.3498C425.75 90.5898 423.92 91.5598 423.42 91.6698C421.69 92.3198 419.7 92.5098 417.94 92.1998C417.69 92.1498 417.46 92.0698 417.22 92.0298C416.52 91.8998 414.24 90.8598 413.71 90.5598L400.22 82.7698L386.81 75.0198C386.15 74.6398 384.02 73.0998 383.87 72.4598C383.68 72.2098 383.54 71.9498 383.43 71.6798C382.77 70.0698 383.57 68.2698 385.71 67.0398Z"
                        fill="black"
                    />
                    <path
                        opacity="0.6364"
                        d="M385.84 67.2698L386.57 66.9698C387.06 66.6898 388.7 65.8498 389.29 65.7298C391.02 65.1398 392.99 64.9898 394.67 65.3698C394.91 65.4198 395.14 65.5198 395.37 65.5698C395.93 65.6798 398.35 66.8498 398.77 67.0898L411.99 74.7298L425.12 82.3198C425.65 82.6298 427.98 84.2198 428.1 84.7298C428.31 84.9598 428.47 85.2098 428.6 85.4598C429.38 86.9998 428.65 88.7798 426.52 90.0098L425.79 90.3098C425.3 90.5898 423.66 91.4298 423.07 91.5498C421.34 92.1398 419.38 92.2798 417.69 91.9098C417.45 91.8498 417.22 91.7598 416.99 91.7098C416.43 91.5998 414.01 90.4298 413.59 90.1898L400.37 82.5498L387.24 74.9598C386.71 74.6498 384.38 73.0598 384.26 72.5498C384.05 72.3198 383.89 72.0698 383.76 71.8198C382.98 70.2798 383.71 68.4998 385.84 67.2698Z"
                        fill="black"
                    />
                    <path
                        opacity="0.7273"
                        d="M385.98 67.5L386.7 67.22C387.25 66.9 388.71 66.19 389.38 66.05C391.11 65.52 393.05 65.43 394.66 65.85C394.9 65.91 395.11 66.02 395.34 66.07C395.76 66.16 398.32 67.46 398.63 67.64L411.58 75.12L424.43 82.54C424.83 82.77 427.35 84.41 427.44 84.79C427.66 85 427.84 85.23 427.99 85.47C428.89 86.93 428.23 88.71 426.1 89.93L425.38 90.21C424.83 90.53 423.37 91.24 422.7 91.38C420.97 91.91 419.03 91.99 417.42 91.58C417.19 91.52 416.97 91.41 416.74 91.36C416.32 91.27 413.76 89.97 413.45 89.79L400.5 82.31L387.65 74.89C387.25 74.66 384.73 73.02 384.64 72.63C384.42 72.42 384.24 72.19 384.09 71.95C383.19 70.49 383.85 68.72 385.98 67.5Z"
                        fill="black"
                    />
                    <path
                        opacity="0.8182"
                        d="M386.11 67.7298L386.82 67.4798C387.44 67.1198 388.71 66.5398 389.46 66.3898C391.19 65.9198 393.1 65.8898 394.64 66.3598C394.87 66.4298 395.09 66.5098 395.29 66.6098C395.58 66.6298 398.27 68.1098 398.48 68.2298L411.16 75.5498L423.73 82.8098C423.99 82.9598 426.71 84.6598 426.77 84.9098C427.01 85.1098 427.21 85.3198 427.37 85.5398C428.4 86.9298 427.79 88.6898 425.68 89.9098L424.97 90.1598C424.35 90.5198 423.08 91.0998 422.33 91.2498C420.6 91.7198 418.69 91.7398 417.15 91.2798C416.92 91.2098 416.7 91.1298 416.5 91.0298C416.21 91.0098 413.52 89.5298 413.31 89.4098L400.63 82.0898L388.06 74.8298C387.8 74.6798 385.08 72.9798 385.02 72.7298C384.78 72.5298 384.58 72.3198 384.42 72.0998C383.39 70.7098 383.99 68.9498 386.11 67.7298Z"
                        fill="black"
                    />
                    <path
                        opacity="0.9091"
                        d="M386.24 67.9599L386.95 67.7299C387.64 67.3299 388.72 66.8799 389.56 66.7099C391.29 66.2999 393.18 66.3299 394.64 66.8499C394.86 66.9299 395.07 67.0199 395.27 67.1199C395.41 67.1299 398.24 68.7299 398.35 68.7899L410.76 75.9599L423.04 83.0599C423.17 83.1399 426.09 84.8799 426.12 85.0099C426.38 85.1899 426.6 85.3799 426.78 85.5899C427.93 86.8999 427.39 88.6499 425.29 89.8699L424.58 90.0999C423.89 90.4999 422.81 90.9499 421.97 91.1199C420.24 91.5299 418.36 91.4999 416.89 90.9799C416.67 90.8999 416.46 90.8099 416.26 90.7099C416.12 90.6999 413.29 89.0999 413.18 89.0399L400.77 81.8699L388.49 74.7699C388.36 74.6899 385.44 72.9499 385.41 72.8199C385.15 72.6399 384.93 72.4499 384.75 72.2399C383.6 70.9199 384.14 69.1699 386.24 67.9599Z"
                        fill="black"
                    />
                    <path
                        opacity="0.2"
                        d="M416.01 90.3599L400.9 81.6299L385.79 72.8999C383.7 71.6899 383.96 69.5799 386.38 68.1899L387.08 67.9799C389.5 66.5899 393.15 66.4299 395.24 67.6399L410.35 76.3699L425.46 85.0999C427.55 86.3099 427.29 88.4199 424.87 89.8099L424.17 90.0199C421.75 91.4099 418.1 91.5599 416.01 90.3599Z"
                        fill="black"
                    />
                </g>
                <g className={classes.moveUpAnimation}>
                    <path
                        d="M419.07 89.4599L391.15 73.2299C388.59 71.7499 386.52 67.7899 386.52 64.3799V3.98993C386.52 2.25993 385.09 1.86993 385.96 1.24993C385.99 1.22993 387.98 0.319934 388.02 0.309934C388.95 -0.0500659 389.94 -0.200066 391.15 0.489934L419.07 16.7199C421.63 18.1999 423.7 22.1599 423.7 25.5699V85.9599C423.7 87.7699 423.11 89.0599 422.18 89.6599C422.12 89.6999 419.73 90.8399 419.66 90.8599C418.84 91.1199 420.19 90.0999 419.07 89.4599Z"
                        fill="url(#paint119_linear_984_11217)"
                    />
                    <path
                        opacity="0.6"
                        d="M417.31 90.26L389.39 74.03C386.83 72.5499 384.76 68.59 384.76 65.18V4.78995C384.76 1.37995 386.83 -0.190046 389.39 1.28995L417.31 17.52C419.87 19 421.94 22.96 421.94 26.37V86.76C421.94 90.17 419.87 91.74 417.31 90.26Z"
                        fill="url(#paint120_radial_984_11217)"
                    />
                    <path
                        d="M416.9 90.4799L388.98 74.2499C386.42 72.7699 384.35 68.8099 384.35 65.3999V5.00992C384.35 1.59992 386.42 0.0299242 388.98 1.50992L416.9 17.7399C419.46 19.2199 421.53 23.1799 421.53 26.5899V86.9799C421.54 90.3899 419.46 91.9599 416.9 90.4799Z"
                        fill="white"
                    />
                    <path
                        d="M384.99 65.7999V5.33986C384.99 2.34986 386.81 0.979863 389.05 2.26986L416.85 18.4299C419.09 19.7199 420.91 23.1999 420.91 26.1899V86.6499C420.91 89.6399 419.09 91.0099 416.85 89.7199L389.05 73.5599C386.8 72.2599 384.99 68.7899 384.99 65.7999Z"
                        fill="url(#paint121_linear_984_11217)"
                    />
                    <path
                        d="M385.89 60.01V6.00995C385.89 3.50995 387.41 2.35995 389.29 3.43995L416.61 19.32C418.49 20.4 420.01 23.31 420.01 25.81V79.81C420.01 82.31 418.49 83.46 416.61 82.38L389.29 66.5C387.41 65.42 385.89 62.52 385.89 60.01Z"
                        fill="url(#paint122_linear_984_11217)"
                    />
                    <path
                        d="M389.54 4.10993C387.77 3.08993 386.34 3.90993 386.34 5.93993V60.6199C386.34 62.6499 387.77 65.1199 389.54 66.1399L416.35 81.7299C418.12 82.7499 419.55 81.9299 419.55 79.8999V25.2199C419.55 23.1899 418.12 20.7199 416.35 19.6999L389.54 4.10993Z"
                        fill="url(#paint123_linear_984_11217)"
                    />
                    <path
                        d="M416.35 19.6999L389.54 4.10993C387.77 3.08993 386.34 3.90993 386.34 5.93993V60.6199C386.34 62.6499 387.77 65.1199 389.54 66.1399L416.35 81.7299C418.12 82.7499 419.55 81.9299 419.55 79.8999V25.2199C419.55 23.1899 418.12 20.7199 416.35 19.6999ZM419.27 79.8999C419.27 80.5299 419.12 81.0499 418.84 81.3999C418.58 81.7199 418.22 81.8899 417.78 81.8899C417.39 81.8899 416.94 81.7499 416.48 81.4899L389.68 65.8999C387.99 64.9199 386.62 62.5499 386.62 60.6199V5.92993C386.62 4.69993 387.19 3.93993 388.11 3.93993C388.5 3.93993 388.95 4.07993 389.41 4.33993L416.22 19.9299C417.91 20.9099 419.28 23.2799 419.28 25.2099V79.8999H419.27Z"
                        fill="#BCBEC0"
                    />
                    <path
                        d="M404.61 79.1299C404.61 80.3199 403.77 80.7999 402.74 80.1999C401.7 79.5999 400.87 78.1499 400.87 76.9699C400.87 75.7799 401.71 75.2999 402.74 75.8999C403.77 76.4899 404.61 77.9399 404.61 79.1299Z"
                        fill="#8969C3"
                    />
                    <path
                        d="M401.89 75.64C402.14 75.64 402.43 75.72 402.73 75.9C403.77 76.5 404.6 77.95 404.6 79.13C404.6 79.97 404.18 80.46 403.57 80.46C403.32 80.46 403.03 80.38 402.73 80.2C401.69 79.6 400.86 78.15 400.86 76.97C400.86 76.12 401.28 75.64 401.89 75.64ZM401.89 75.23C401.03 75.23 400.45 75.93 400.45 76.97C400.45 78.31 401.36 79.89 402.53 80.56C402.89 80.77 403.24 80.87 403.58 80.87C404.44 80.87 405.02 80.17 405.02 79.13C405.02 77.79 404.11 76.21 402.94 75.54C402.58 75.33 402.22 75.23 401.89 75.23Z"
                        fill="white"
                    />
                </g>
                <g opacity="0.2">
                    <path
                        opacity="0.0909"
                        d="M56.53 202.37L39.83 212.16C39.82 212.16 39.66 212.26 39.65 212.27C38.34 213.04 37.75 214.26 37.82 215.57C37.9 216.9 38.89 218.38 40.34 219.21L53.89 232.14C55.18 232.89 56.84 233.26 58.41 233.18C59.66 233.18 61.06 232.75 61.96 232.24L86.79 217.82C88.05 217.09 88.77 215.94 88.77 214.67C88.76 213.28 87.89 211.98 86.37 211.1L64.49 202.68C64.05 202.42 63.42 202.17 62.91 202C62.04 201.72 61.09 201.55 60.13 201.54C58.76 201.52 57.51 201.8 56.53 202.37Z"
                        fill="black"
                    />
                    <path
                        opacity="0.1818"
                        d="M56.63 202.53L39.91 212.32C39.9 212.33 39.74 212.42 39.73 212.43C38.42 213.21 38 214.43 38.15 215.73C38.29 216.92 39.39 218.52 40.68 219.27L53.98 231.96C55.32 232.73 57.07 233.08 58.64 232.92C59.77 232.92 61.31 232.37 62.12 231.9L86.69 217.63C87.9 216.93 88.58 215.84 88.57 214.63C88.56 213.32 87.73 212.08 86.27 211.24L64.52 202.88C64.12 202.65 63.41 202.36 62.95 202.21C62.09 201.92 61.15 201.74 60.2 201.72C58.84 201.7 57.59 201.98 56.63 202.53Z"
                        fill="black"
                    />
                    <path
                        opacity="0.2727"
                        d="M56.7199 202.7L39.9899 212.5C39.9699 212.51 39.8199 212.6 39.8099 212.61C38.4999 213.41 38.0199 214.67 38.4699 215.9C38.4699 216.97 39.8699 218.67 41.0199 219.33L54.0699 231.79C55.4499 232.59 57.2999 232.91 58.8699 232.67C59.8699 232.67 61.5599 232 62.2799 231.58L86.5899 217.46C87.7499 216.79 88.3899 215.76 88.3699 214.62C88.3499 213.38 87.5599 212.21 86.1599 211.41L64.5499 203.1C64.1999 202.9 63.3899 202.58 62.9899 202.44C62.1399 202.15 61.2099 201.94 60.2699 201.92C58.9299 201.88 57.6799 202.15 56.7199 202.7Z"
                        fill="black"
                    />
                    <path
                        opacity="0.3636"
                        d="M56.8199 202.87L40.0699 212.68C40.0399 212.7 39.9099 212.78 39.8799 212.79C38.5699 213.6 38.1799 214.88 38.7899 216.08C38.7899 217.01 40.3499 218.82 41.3599 219.41L54.1699 231.63C55.5999 232.45 57.5499 232.75 59.1099 232.43C59.9899 232.43 61.8199 231.63 62.4499 231.27L86.4999 217.3C87.6099 216.66 88.2099 215.68 88.1899 214.61C88.1699 213.45 87.4099 212.34 86.0799 211.57L64.6099 203.31C64.2999 203.13 63.4099 202.79 63.0599 202.66C62.2199 202.36 61.3099 202.14 60.3699 202.1C59.0199 202.06 57.7599 202.32 56.8199 202.87Z"
                        fill="black"
                    />
                    <path
                        opacity="0.4545"
                        d="M56.9099 203.03L40.1399 212.85C40.1099 212.87 39.9799 212.94 39.9499 212.96C38.6499 213.78 38.3499 215.08 39.0999 216.25C39.0999 217.05 40.8299 218.97 41.6899 219.47L54.2499 231.46C55.7199 232.31 57.7699 232.58 59.3199 232.18C60.0699 232.18 62.0599 231.26 62.5899 230.95L86.3799 217.14C87.4399 216.53 87.9999 215.61 87.9699 214.61C87.9399 213.52 87.2299 212.48 85.9599 211.75L64.6199 203.54C64.3499 203.39 63.3799 203.01 63.0699 202.9C62.2399 202.6 61.3399 202.36 60.3999 202.31C59.1099 202.25 57.8499 202.49 56.9099 203.03Z"
                        fill="black"
                    />
                    <path
                        opacity="0.5455"
                        d="M57.0101 203.2L40.2301 213.03C40.1901 213.05 40.0701 213.12 40.0401 213.15C38.7401 213.98 38.5301 215.31 39.4401 216.44C39.4401 217.11 41.3301 219.14 42.0501 219.55L54.3601 231.3C55.8801 232.18 58.0301 232.42 59.5701 231.94C60.2001 231.94 62.3301 230.89 62.7801 230.64L86.3101 216.98C87.3101 216.4 87.8401 215.54 87.8101 214.6C87.7801 213.59 87.1001 212.62 85.8901 211.92L64.6901 203.77C64.4701 203.64 63.4001 203.24 63.1501 203.14C62.3301 202.83 61.4401 202.57 60.5101 202.52C59.2001 202.43 57.9401 202.66 57.0101 203.2Z"
                        fill="black"
                    />
                    <path
                        opacity="0.6364"
                        d="M57.0999 203.36L40.2999 213.2C40.2499 213.23 40.1499 213.29 40.1099 213.32C38.8099 214.16 38.6999 215.51 39.7599 216.6C39.7599 217.13 41.8099 219.27 42.3899 219.61L54.4599 231.13C56.0199 232.03 58.2699 232.25 59.8099 231.69C60.3099 231.69 62.5899 230.52 62.9499 230.31L86.2099 216.8C87.1599 216.25 87.6499 215.44 87.6099 214.57C87.5699 213.64 86.9299 212.73 85.7899 212.07L64.7299 203.97C64.5499 203.87 63.3999 203.43 63.1999 203.35C62.3899 203.04 61.5099 202.76 60.5899 202.7C59.2799 202.61 58.0199 202.83 57.0999 203.36Z"
                        fill="black"
                    />
                    <path
                        opacity="0.7273"
                        d="M57.2 203.53L40.39 213.38C40.34 213.41 40.24 213.47 40.19 213.5C38.9 214.35 38.87 215.72 40.08 216.78C40.08 217.18 42.3 219.43 42.73 219.68L54.55 230.96C56.16 231.89 58.5 232.08 60.03 231.44C60.41 231.44 62.83 230.15 63.1 229.99L86.1 216.63C87 216.11 87.44 215.36 87.4 214.56C87.36 213.7 86.75 212.86 85.67 212.24L64.74 204.19C64.61 204.11 63.36 203.64 63.22 203.58C62.42 203.26 61.55 202.97 60.64 202.89C59.37 202.8 58.11 203 57.2 203.53Z"
                        fill="black"
                    />
                    <path
                        opacity="0.8182"
                        d="M57.3 203.7L40.47 213.56C40.41 213.59 40.32 213.65 40.27 213.68C38.98 214.54 39.05 215.93 40.41 216.96C40.41 217.23 42.79 219.59 43.08 219.76L54.66 230.81C56.31 231.76 58.76 231.93 60.28 231.21C60.53 231.21 63.1 229.79 63.28 229.69L86.02 216.48C86.86 215.99 87.27 215.3 87.23 214.56C87.18 213.78 86.62 213 85.6 212.41L64.81 204.41C64.72 204.36 63.39 203.85 63.29 203.81C62.5 203.48 61.64 203.17 60.73 203.09C59.46 202.98 58.2 203.18 57.3 203.7Z"
                        fill="black"
                    />
                    <path
                        opacity="0.9091"
                        d="M57.39 203.86L40.54 213.73C40.47 213.77 40.4 213.82 40.34 213.86C39.05 214.74 39.21 216.14 40.72 217.14C40.72 217.27 43.26 219.75 43.41 219.83L54.74 230.64C56.44 231.62 58.98 231.76 60.5 230.96C60.63 230.96 63.35 229.42 63.44 229.37L85.92 216.31C86.71 215.85 87.08 215.21 87.03 214.54C86.97 213.84 86.45 213.12 85.5 212.57L64.85 204.63C64.81 204.6 63.39 204.06 63.34 204.04C62.56 203.71 61.71 203.38 60.81 203.29C59.55 203.16 58.28 203.35 57.39 203.86Z"
                        fill="black"
                    />
                    <path
                        opacity="0.2"
                        d="M60.7301 230.72L85.8201 216.15C87.3301 215.28 87.1401 213.75 85.4001 212.75L63.3801 204.28C61.6401 203.27 59.0001 203.16 57.4901 204.04L40.6301 213.92C39.1201 214.79 39.3101 216.32 41.0501 217.32L54.8401 230.48C56.5801 231.48 59.2201 231.59 60.7301 230.72Z"
                        fill="black"
                    />
                </g>
                <g className={classes.moveUpAnimation}>
                    <path
                        d="M60.73 230.68L85.82 216.11C86.49 215.72 86.83 215.2 86.84 214.66C86.84 214.64 86.84 212.78 86.84 212.76C86.83 212.1 86.34 213.25 85.4 212.7L63.38 204.23C61.64 203.22 59 203.11 57.49 203.99L40.63 213.87C40.13 214.16 39.76 212.93 39.63 213.32C39.59 213.45 39.61 215.18 39.61 215.32C39.6 216 40.08 216.72 41.05 217.27L54.84 230.43C56.58 231.44 59.22 231.55 60.73 230.68Z"
                        fill="url(#paint124_linear_984_11217)"
                    />
                    <path
                        d="M60.7301 228.82L85.8201 214.25C87.3301 213.38 87.1401 211.85 85.4001 210.85L63.3801 202.38C61.6401 201.37 59.0001 201.26 57.4901 202.14L40.6301 212.02C39.1201 212.89 39.3101 214.42 41.0501 215.42L54.8401 228.58C56.5801 229.58 59.2201 229.69 60.7301 228.82Z"
                        fill="url(#paint125_linear_984_11217)"
                    />
                    <path
                        opacity="0.8182"
                        d="M40.6201 212.01L57.4801 202.13C58.9901 201.26 61.6301 201.37 63.3701 202.37L74.4601 206.64C74.3601 206.72 74.2401 206.8 74.1201 206.88L49.0301 221.45C48.6801 221.65 48.2701 221.8 47.8301 221.89L41.0401 215.41C39.3001 214.41 39.1101 212.88 40.6201 212.01Z"
                        fill="url(#paint126_linear_984_11217)"
                    />
                    <path
                        d="M41.05 215.1L54.84 228.26C56.58 229.27 59.22 229.38 60.73 228.5L85.82 213.93C86.45 213.57 86.78 213.09 86.83 212.59C86.91 213.21 86.58 213.81 85.82 214.24L60.73 228.81C59.22 229.68 56.58 229.57 54.84 228.57L41.05 215.41C40.03 214.82 39.55 214.05 39.62 213.35C39.69 213.96 40.18 214.6 41.05 215.1Z"
                        fill="white"
                    />
                    <path
                        d="M27.95 228.9L89.57 193.3C92.72 191.48 95.27 186.6 95.27 182.4V135.27C95.27 131.07 92.72 129.14 89.57 130.96L27.95 166.56C24.8 168.38 22.25 173.26 22.25 177.46V224.59C22.25 228.79 24.8 230.72 27.95 228.9Z"
                        fill="url(#paint127_linear_984_11217)"
                    />
                    <path
                        d="M27.22 225.62L87.97 190.52C90.51 188.91 92.07 185.69 92.07 182.4V134.97C92.07 134.19 91.22 133.7 90.55 134.1C90.47 134.15 90.41 134.18 90.37 134.2L29.56 169.34C26.54 171.08 25.46 174.17 25.46 177.47V224.76C25.46 225.6 26.37 226.12 27.09 225.71C27.14 225.66 27.19 225.64 27.22 225.62Z"
                        fill="url(#paint128_linear_984_11217)"
                    />
                    <path
                        d="M25.45 177.46V224.75C25.45 225.59 26.36 226.11 27.08 225.7C27.14 225.67 27.1799 225.64 27.2099 225.62L87.9599 190.52C90.49 188.91 92.06 185.69 92.06 182.4V134.97C92.06 134.19 91.2099 133.7 90.5399 134.1C90.4599 134.15 90.4 134.18 90.36 134.2L29.5499 169.34C26.5399 171.08 25.45 174.17 25.45 177.46ZM26.1 177.46C26.1 175 26.7599 171.69 29.8799 169.89L90.8799 134.64C90.9399 134.61 90.9999 134.59 91.0699 134.59C91.2499 134.59 91.44 134.73 91.44 134.96V182.39C91.44 185.53 89.95 188.5 87.66 189.96L26.78 225.13C26.71 225.17 26.6299 225.19 26.5599 225.19C26.3399 225.19 26.11 225.02 26.11 224.74V177.46H26.1Z"
                        fill="#BCBEC0"
                    />
                    <path
                        d="M26.3399 165.71L87.9599 130.11C89.2099 129.39 90.3599 129.26 91.2999 129.62C91.4199 129.67 93.0099 130.51 93.1199 130.57H93.1299C92.1599 130.1 90.9299 130.19 89.5799 130.96L27.9599 166.56C24.8099 168.38 22.2599 173.26 22.2599 177.46V224.59C22.2599 227.21 23.2499 228.95 24.7699 229.44C24.6499 229.45 24.4899 229.4 24.2699 229.27C24.1999 229.23 22.4699 228.25 22.3999 228.21C21.3199 227.45 20.6399 225.89 20.6399 223.73V176.6C20.6299 172.4 23.1899 167.53 26.3399 165.71Z"
                        fill="url(#paint129_linear_984_11217)"
                    />
                    <path
                        d="M27.68 166.43L89.3 130.83C90.59 130.08 91.78 129.98 92.74 130.39C91.92 130.26 90.99 130.46 89.99 131.03L28.37 166.63C25.22 168.45 22.67 173.33 22.67 177.53V224.66C22.67 227.14 23.56 228.82 24.94 229.41C23.18 229.13 21.99 227.32 21.99 224.45V177.32C21.98 173.13 24.53 168.25 27.68 166.43Z"
                        fill="url(#paint130_radial_984_11217)"
                    />
                </g>
                <g className={classes.moveUpAnimation}>
                    <path
                        d="M162.27 400.39C176.215 400.39 187.52 394.767 187.52 387.83C187.52 380.893 176.215 375.27 162.27 375.27C148.325 375.27 137.02 380.893 137.02 387.83C137.02 394.767 148.325 400.39 162.27 400.39Z"
                        fill="url(#paint131_radial_984_11217)"
                    />
                    <path
                        d="M138.81 382.89H172.85V386.52H172.84C172.84 386.57 172.85 386.61 172.85 386.66C172.85 392.13 165.23 396.57 155.83 396.57C146.43 396.57 138.81 392.13 138.81 386.66C138.81 386.61 138.81 386.57 138.82 386.52H138.81V382.89Z"
                        fill="url(#paint132_linear_984_11217)"
                    />
                    <path
                        d="M155.82 393.22C165.22 393.22 172.84 388.783 172.84 383.31C172.84 377.837 165.22 373.4 155.82 373.4C146.42 373.4 138.8 377.837 138.8 383.31C138.8 388.783 146.42 393.22 155.82 393.22Z"
                        fill="url(#paint133_linear_984_11217)"
                    />
                    <path
                        d="M140.24 360.49H171.41V381.99H171.4C171.4 382.03 171.41 382.07 171.41 382.12C171.41 387.13 164.43 391.19 155.83 391.19C147.22 391.19 140.25 387.13 140.25 382.12C140.25 382.08 140.25 382.04 140.26 381.99H140.25V360.49H140.24Z"
                        fill="url(#paint134_linear_984_11217)"
                    />
                    <path
                        d="M155.82 370.05C164.425 370.05 171.4 365.989 171.4 360.98C171.4 355.971 164.425 351.91 155.82 351.91C147.215 351.91 140.24 355.971 140.24 360.98C140.24 365.989 147.215 370.05 155.82 370.05Z"
                        fill="url(#paint135_radial_984_11217)"
                    />
                    <path
                        d="M155.82 369.62C164.425 369.62 171.4 365.559 171.4 360.55C171.4 355.541 164.425 351.48 155.82 351.48C147.215 351.48 140.24 355.541 140.24 360.55C140.24 365.559 147.215 369.62 155.82 369.62Z"
                        fill="url(#paint136_linear_984_11217)"
                    />
                    <path
                        d="M120.87 305.74C120.87 306.48 121.12 307 121.54 307.25C121.55 307.26 125.05 309.32 125.06 309.33C125.49 309.57 125.22 309.02 125.87 308.65C127.18 307.89 128.25 306.05 128.25 304.55C128.25 303.8 128.94 303.8 128.52 303.55C128.51 303.54 124.93 301.47 124.91 301.46C124.48 301.23 123.9 301.27 123.25 301.64C121.94 302.4 120.87 304.23 120.87 305.74Z"
                        fill="url(#paint137_linear_984_11217)"
                    />
                    <path
                        d="M122.7 307.67C122.7 308.68 123.05 309.39 123.61 309.73C123.63 309.74 128.41 312.56 128.42 312.57C129.01 312.9 128.63 312.15 129.52 311.64C131.32 310.6 132.77 308.09 132.77 306.03C132.77 305.01 133.71 305 133.13 304.66C133.11 304.65 128.22 301.82 128.2 301.81C127.61 301.49 126.81 301.55 125.93 302.06C124.15 303.1 122.7 305.61 122.7 307.67Z"
                        fill="url(#paint138_linear_984_11217)"
                    />
                    <path
                        d="M145.88 304.22L145.74 303.87L146.63 303.42C146.85 303.27 147.08 303.14 147.34 303.06L147.48 302.99L147.49 303.01C147.8 302.93 148.13 302.89 148.5 302.91C151.31 303.06 154.63 306.41 155.91 310.37L168.61 353.91C169.64 357.11 169.03 359.74 167.28 360.56L166.42 361.06L166.32 360.81C166.17 360.82 166.01 360.83 165.84 360.82C163.03 360.67 159.71 357.32 158.43 353.36L145.73 309.82C144.97 307.49 145.09 305.46 145.88 304.22Z"
                        fill="url(#paint139_linear_984_11217)"
                    />
                    <path
                        d="M164.77 361.39C167.58 361.54 168.82 358.45 167.54 354.49L154.84 310.95C153.56 306.98 150.24 303.64 147.43 303.49C144.62 303.34 143.38 306.43 144.66 310.39L157.36 353.93C158.64 357.9 161.96 361.24 164.77 361.39Z"
                        fill="url(#paint140_linear_984_11217)"
                    />
                    <path
                        d="M164.77 361.39C167.58 361.54 168.82 358.45 167.54 354.49L154.84 310.95C153.56 306.98 150.24 303.64 147.43 303.49C144.62 303.34 143.38 306.43 144.66 310.39L157.36 353.93C158.64 357.9 161.96 361.24 164.77 361.39Z"
                        fill="url(#paint141_linear_984_11217)"
                    />
                    <path
                        d="M167.42 354.65L154.72 311.11C153.44 307.14 150.12 303.8 147.31 303.65C146.6 303.61 145.99 303.78 145.49 304.12C146.03 303.62 146.75 303.35 147.62 303.4C150.43 303.55 153.75 306.9 155.03 310.86L167.73 354.4C168.69 357.36 168.24 359.84 166.77 360.83C167.98 359.7 168.3 357.38 167.42 354.65Z"
                        fill="url(#paint142_radial_984_11217)"
                    />
                    <path
                        d="M155.56 357.47V366.8L146.37 361.48V352.07L155.56 357.47Z"
                        fill="url(#paint143_linear_984_11217)"
                    />
                    <path
                        d="M155.55 357.47V366.8L164.7 361.5V352.09L155.55 357.47Z"
                        fill="url(#paint144_linear_984_11217)"
                    />
                    <path
                        d="M164.7 352.09L155.55 357.47L146.37 352.07L155.54 346.71L164.7 352.09Z"
                        fill="url(#paint145_linear_984_11217)"
                    />
                    <path
                        d="M198.65 336.51L162.41 315.46C161.25 314.79 160.31 315.5 160.31 317.05V317.77C160.31 319.32 161.25 321.12 162.41 321.79L198.65 342.84C199.81 343.51 200.75 342.8 200.75 341.25V340.53C200.75 338.97 199.81 337.18 198.65 336.51Z"
                        fill="url(#paint146_linear_984_11217)"
                    />
                    <path
                        d="M199.74 335.87L163.5 314.82C163 314.53 162.55 314.5 162.19 314.68L162.18 314.67L161.03 315.34V315.35C161.4 315.13 161.88 315.14 162.42 315.45L198.66 336.5C199.82 337.17 200.76 338.97 200.76 340.52V341.24C200.76 341.99 200.54 342.54 200.17 342.84L200.81 342.42C201.35 342.11 201.84 341.63 201.84 340.61V339.89C201.84 338.34 200.9 336.54 199.74 335.87Z"
                        fill="url(#paint147_linear_984_11217)"
                    />
                    <path
                        d="M198.77 336.41L162.53 315.36C161.95 315.03 161.43 315.04 161.05 315.32C161.39 315.19 161.82 315.24 162.27 315.5L198.51 336.55C199.67 337.22 200.61 339.02 200.61 340.57V341.29C200.61 342.07 200.37 342.64 199.99 342.92C200.52 342.72 200.87 342.09 200.87 341.15V340.43C200.87 338.88 199.93 337.08 198.77 336.41Z"
                        fill="url(#paint148_radial_984_11217)"
                    />
                    <path
                        d="M195.29 337.7L195.22 337.52L195.68 337.29C195.79 337.21 196.39 336.97 196.52 336.93L196.59 336.89V336.9C196.75 336.86 196.92 336.84 197.1 336.85C198.54 336.93 200.24 338.64 200.9 340.67L204.26 351.01C204.79 352.65 204.48 354 203.58 354.42L202.66 354.85L202.61 354.72C202.53 354.73 202.45 354.73 202.36 354.72C200.92 354.64 199.22 352.93 198.56 350.9L195.2 340.56C194.82 339.38 194.88 338.34 195.29 337.7Z"
                        fill="url(#paint149_linear_984_11217)"
                    />
                    <path
                        d="M201.82 355.03C203.26 355.11 203.9 353.53 203.24 351.49L199.88 341.15C199.22 339.12 197.52 337.41 196.08 337.33C194.64 337.25 194 338.83 194.66 340.87L198.02 351.21C198.68 353.24 200.38 354.95 201.82 355.03Z"
                        fill="url(#paint150_linear_984_11217)"
                    />
                    <path
                        d="M203.18 351.58L199.82 341.24C199.16 339.21 197.46 337.5 196.02 337.42C195.66 337.4 195.34 337.49 195.09 337.66C195.37 337.4 195.74 337.27 196.18 337.29C197.62 337.37 199.32 339.08 199.98 341.11L203.34 351.45C203.83 352.97 203.6 354.23 202.85 354.75C203.47 354.17 203.63 352.98 203.18 351.58Z"
                        fill="url(#paint151_radial_984_11217)"
                    />
                    <path
                        d="M198.56 365.02H197.51V376.83C197.51 377 197.74 377.13 198.03 377.13C198.32 377.13 198.55 376.99 198.55 376.83V365.02H198.56Z"
                        fill="url(#paint152_linear_984_11217)"
                    />
                    <path
                        d="M196.05 360.64H200.03V366.77C200.03 366.78 200.03 366.78 200.03 366.78C200.03 367.43 199.14 367.94 198.04 367.94C196.94 367.94 196.05 367.42 196.05 366.78C196.05 366.78 196.05 366.77 196.05 366.76V360.64Z"
                        fill="url(#paint153_linear_984_11217)"
                    />
                    <path
                        d="M194.46 351.97H201.61V360.12C201.61 360.13 201.61 360.14 201.61 360.15C201.61 361.3 200.01 362.23 198.03 362.23C196.05 362.23 194.45 361.3 194.45 360.15C194.45 360.14 194.45 360.13 194.45 360.12V351.97H194.46Z"
                        fill="url(#paint154_linear_984_11217)"
                    />
                    <path
                        d="M201.61 351.99C201.61 353.14 200.01 354.07 198.03 354.07C196.05 354.07 194.45 353.14 194.45 351.99C194.45 350.84 196.05 349.91 198.03 349.91C200.01 349.91 201.61 350.84 201.61 351.99Z"
                        fill="url(#paint155_linear_984_11217)"
                    />
                    <path
                        d="M200.6 351.96C200.6 352.78 199.45 353.45 198.04 353.45C196.63 353.45 195.48 352.78 195.48 351.96C195.48 351.14 196.63 350.47 198.04 350.47C199.45 350.47 200.6 351.13 200.6 351.96Z"
                        fill="url(#paint156_linear_984_11217)"
                    />
                    <path
                        d="M200.6 351.96C200.6 352.78 199.45 353.45 198.04 353.45C196.63 353.45 195.48 352.78 195.48 351.96C195.48 351.14 196.63 350.47 198.04 350.47C199.45 350.47 200.6 351.13 200.6 351.96Z"
                        fill="url(#paint157_linear_984_11217)"
                    />
                    <path
                        d="M195.47 357.02C195.47 358.14 194.68 358.6 193.7 358.03C192.72 357.46 191.93 356.09 191.93 354.97C191.93 353.85 192.72 353.39 193.7 353.96C194.68 354.53 195.47 355.9 195.47 357.02Z"
                        fill="url(#paint158_linear_984_11217)"
                    />
                    <path
                        d="M193.79 353.92C193.32 353.65 192.89 353.61 192.58 353.77C192.88 353.69 193.24 353.75 193.64 353.98C194.62 354.55 195.41 355.92 195.41 357.04C195.41 357.63 195.19 358.03 194.85 358.2C195.28 358.08 195.56 357.65 195.56 356.98C195.56 355.85 194.77 354.48 193.79 353.92Z"
                        fill="#E6E7E8"
                    />
                    <path
                        d="M148.96 316.42V328.91L126.76 316.08V303.79L148.96 316.42Z"
                        fill="url(#paint159_linear_984_11217)"
                    />
                    <path
                        d="M148.94 316.42V328.91L159.44 323.24V310.62L148.94 316.42Z"
                        fill="url(#paint160_linear_984_11217)"
                    />
                    <path
                        d="M159.44 310.62L148.94 316.42L126.76 303.79L137.3 298.03L159.44 310.62Z"
                        fill="url(#paint161_linear_984_11217)"
                    />
                    <path
                        d="M160.08 322.8V332.86L149.89 326.91V317L160.08 322.8Z"
                        fill="url(#paint162_linear_984_11217)"
                    />
                    <path
                        d="M160.06 322.8V332.86L168.53 328.29V318.11L160.06 322.8Z"
                        fill="url(#paint163_linear_984_11217)"
                    />
                    <path
                        d="M168.53 318.11L160.06 322.8L149.89 317L158.38 312.36L168.53 318.11Z"
                        fill="url(#paint164_linear_984_11217)"
                    />
                    <path
                        d="M160.69 327.87C160.69 330.24 162.36 331.19 164.42 330C166.48 328.81 168.15 325.93 168.15 323.56C168.15 321.19 166.48 320.24 164.42 321.43C162.36 322.62 160.69 325.51 160.69 327.87Z"
                        fill="url(#paint165_linear_984_11217)"
                    />
                    <path
                        d="M161.4 327.52C161.4 328.5 161.74 329.19 162.29 329.53C162.31 329.54 191.65 346.3 191.66 346.31C192.23 346.63 191.87 345.9 192.73 345.4C194.48 344.39 195.89 341.95 195.89 339.95C195.89 338.96 196.81 338.95 196.24 338.62C196.22 338.61 166.77 321.84 166.76 321.83C166.19 321.52 165.41 321.58 164.55 322.07C162.82 323.08 161.4 325.52 161.4 327.52Z"
                        fill="url(#paint166_linear_984_11217)"
                    />
                    <path
                        d="M161.4 327.52C161.4 328.5 161.74 329.19 162.29 329.53C162.31 329.54 191.65 346.3 191.66 346.31C192.23 346.63 191.87 345.9 192.73 345.4C194.48 344.39 195.89 341.95 195.89 339.95C195.89 338.96 196.81 338.95 196.24 338.62C196.22 338.61 166.77 321.84 166.76 321.83C166.19 321.52 165.41 321.58 164.55 322.07C162.82 323.08 161.4 325.52 161.4 327.52Z"
                        fill="url(#paint167_linear_984_11217)"
                    />
                    <path
                        d="M190.86 344.32C190.86 346.32 192.28 347.13 194.02 346.12C195.77 345.11 197.18 342.67 197.18 340.67C197.18 338.67 195.76 337.86 194.02 338.87C192.27 339.88 190.86 342.32 190.86 344.32Z"
                        fill="url(#paint168_linear_984_11217)"
                    />
                    <path
                        d="M191.86 343.72C191.86 345.08 192.82 345.63 194 344.94C195.18 344.26 196.14 342.6 196.14 341.24C196.14 339.88 195.18 339.33 194 340.02C192.82 340.71 191.86 342.37 191.86 343.72Z"
                        fill="url(#paint169_linear_984_11217)"
                    />
                    <path
                        d="M191.86 343.72C191.86 345.08 192.82 345.63 194 344.94C195.18 344.26 196.14 342.6 196.14 341.24C196.14 339.88 195.18 339.33 194 340.02C192.82 340.71 191.86 342.37 191.86 343.72Z"
                        fill="url(#paint170_linear_984_11217)"
                    />
                    <path
                        d="M193.87 338.79C194.71 338.31 195.47 338.24 196.03 338.52C195.5 338.37 194.85 338.48 194.14 338.89C192.39 339.9 190.98 342.34 190.98 344.34C190.98 345.38 191.36 346.1 191.98 346.41C191.21 346.19 190.71 345.43 190.71 344.24C190.71 342.24 192.12 339.8 193.87 338.79Z"
                        fill="url(#paint171_radial_984_11217)"
                    />
                    <path
                        d="M133.57 310.93L133.43 310.58L134.32 310.13C134.54 309.98 134.77 309.85 135.03 309.77L135.17 309.7L135.18 309.72C135.49 309.64 135.82 309.6 136.19 309.62C139 309.77 142.32 313.12 143.6 317.08L156.3 360.62C157.33 363.82 156.72 366.45 154.97 367.27L154.11 367.77L154.01 367.52C153.86 367.53 153.7 367.54 153.53 367.53C150.72 367.38 147.4 364.03 146.12 360.07L133.42 316.53C132.66 314.2 132.78 312.18 133.57 310.93Z"
                        fill="url(#paint172_linear_984_11217)"
                    />
                    <path
                        d="M152.46 368.11C155.27 368.26 156.51 365.17 155.23 361.21L142.53 317.67C141.25 313.7 137.93 310.36 135.12 310.21C132.31 310.06 131.07 313.15 132.35 317.11L145.05 360.65C146.33 364.61 149.65 367.95 152.46 368.11Z"
                        fill="url(#paint173_linear_984_11217)"
                    />
                    <path
                        d="M155.11 361.36L142.41 317.82C141.13 313.85 137.81 310.51 135 310.36C134.29 310.32 133.68 310.49 133.18 310.83C133.72 310.33 134.44 310.06 135.31 310.11C138.12 310.26 141.44 313.61 142.72 317.57L155.42 361.11C156.38 364.07 155.93 366.55 154.46 367.54C155.67 366.42 155.99 364.1 155.11 361.36Z"
                        fill="url(#paint174_radial_984_11217)"
                    />
                    <path
                        d="M153.17 363.51C153.17 365.21 151.97 365.89 150.49 365.04C149.01 364.18 147.81 362.11 147.81 360.41C147.81 358.71 149.01 358.03 150.49 358.88C151.97 359.74 153.17 361.81 153.17 363.51Z"
                        fill="#B086CC"
                    />
                    <path
                        d="M139.53 318.35C139.53 320.05 138.33 320.73 136.85 319.88C135.37 319.02 134.17 316.95 134.17 315.25C134.17 313.55 135.37 312.87 136.85 313.72C138.33 314.58 139.53 316.65 139.53 318.35Z"
                        fill="#B086CC"
                    />
                    <path
                        d="M138.83 318.23C138.83 318.91 138.59 319.4 138.21 319.63C138.2 319.64 137.1 320.28 137.09 320.29C136.69 320.51 136.95 320.01 136.34 319.66C135.12 318.96 134.13 317.25 134.13 315.85C134.13 315.16 133.49 315.15 133.88 314.92C133.89 314.91 135.06 314.26 135.08 314.25C135.48 314.03 136.02 314.07 136.62 314.42C137.84 315.13 138.83 316.83 138.83 318.23Z"
                        fill="url(#paint175_linear_984_11217)"
                    />
                    <path
                        d="M137.65 318.91C137.65 320.31 136.66 320.87 135.44 320.17C134.22 319.47 133.23 317.76 133.23 316.36C133.23 314.96 134.22 314.4 135.44 315.1C136.66 315.8 137.65 317.51 137.65 318.91Z"
                        fill="url(#paint176_linear_984_11217)"
                    />
                    <path
                        d="M135.55 315.05C134.97 314.71 134.43 314.67 134.04 314.86C134.41 314.76 134.86 314.83 135.36 315.12C136.58 315.82 137.57 317.53 137.57 318.93C137.57 319.66 137.3 320.16 136.87 320.37C137.41 320.22 137.76 319.68 137.76 318.85C137.76 317.46 136.77 315.75 135.55 315.05Z"
                        fill="url(#paint177_radial_984_11217)"
                    />
                    <path
                        d="M152.42 363.44C152.42 364.12 152.18 364.61 151.8 364.84C151.79 364.85 150.69 365.49 150.68 365.5C150.28 365.72 150.54 365.22 149.93 364.87C148.71 364.17 147.72 362.46 147.72 361.06C147.72 360.37 147.08 360.36 147.47 360.13C147.48 360.12 148.65 359.47 148.67 359.46C149.07 359.24 149.61 359.28 150.21 359.63C151.44 360.33 152.42 362.04 152.42 363.44Z"
                        fill="url(#paint178_linear_984_11217)"
                    />
                    <path
                        d="M151.25 364.11C151.25 365.51 150.26 366.07 149.04 365.37C147.82 364.67 146.83 362.96 146.83 361.56C146.83 360.16 147.82 359.6 149.04 360.3C150.26 361.01 151.25 362.71 151.25 364.11Z"
                        fill="url(#paint179_linear_984_11217)"
                    />
                    <path
                        d="M149.15 360.25C148.57 359.91 148.03 359.87 147.64 360.06C148.01 359.96 148.46 360.03 148.96 360.32C150.18 361.02 151.17 362.73 151.17 364.13C151.17 364.86 150.9 365.36 150.47 365.57C151.01 365.42 151.36 364.88 151.36 364.05C151.35 362.66 150.37 360.95 149.15 360.25Z"
                        fill="url(#paint180_radial_984_11217)"
                    />
                    <path
                        d="M191.72 345.43C191.72 346.55 190.93 347.01 189.95 346.44C188.97 345.87 188.18 344.5 188.18 343.38C188.18 342.26 188.97 341.8 189.95 342.37C190.93 342.93 191.72 344.3 191.72 345.43Z"
                        fill="url(#paint181_linear_984_11217)"
                    />
                    <path
                        d="M190.03 342.33C189.56 342.06 189.13 342.02 188.82 342.18C189.12 342.1 189.48 342.16 189.88 342.39C190.86 342.96 191.65 344.33 191.65 345.45C191.65 346.04 191.43 346.44 191.09 346.61C191.52 346.49 191.8 346.06 191.8 345.39C191.81 344.26 191.01 342.89 190.03 342.33Z"
                        fill="#E6E7E8"
                    />
                    <path
                        d="M187.4 342.12L187.33 341.94L187.79 341.71C187.9 341.63 188.5 341.39 188.63 341.35L188.7 341.31V341.32C188.86 341.28 189.03 341.26 189.21 341.27C190.65 341.35 192.35 343.06 193.01 345.09L196.37 355.43C196.9 357.07 196.59 358.42 195.69 358.84L194.77 359.27L194.72 359.14C194.64 359.15 194.56 359.15 194.47 359.14C193.03 359.06 191.33 357.35 190.67 355.32L187.31 344.98C186.93 343.8 187 342.76 187.4 342.12Z"
                        fill="url(#paint182_linear_984_11217)"
                    />
                    <path
                        d="M193.94 359.45C195.38 359.53 196.02 357.95 195.36 355.91L192 345.57C191.34 343.54 189.64 341.83 188.2 341.75C186.76 341.67 186.12 343.25 186.78 345.29L190.14 355.63C190.79 357.66 192.49 359.37 193.94 359.45Z"
                        fill="url(#paint183_linear_984_11217)"
                    />
                    <path
                        d="M195.29 355.99L191.93 345.65C191.27 343.62 189.57 341.91 188.13 341.83C187.77 341.81 187.45 341.9 187.2 342.07C187.48 341.81 187.85 341.68 188.29 341.7C189.73 341.78 191.43 343.49 192.09 345.52L195.45 355.86C195.94 357.38 195.71 358.64 194.96 359.16C195.58 358.59 195.75 357.4 195.29 355.99Z"
                        fill="url(#paint184_radial_984_11217)"
                    />
                    <path
                        d="M189.02 342.06L152.78 321.01C151.62 320.34 150.68 321.05 150.68 322.6V323.32C150.68 324.87 151.62 326.67 152.78 327.34L189.02 348.39C190.18 349.06 191.12 348.35 191.12 346.8V346.08C191.12 344.52 190.18 342.73 189.02 342.06Z"
                        fill="url(#paint185_linear_984_11217)"
                    />
                    <path
                        d="M190.1 341.42L153.86 320.37C153.36 320.08 152.91 320.05 152.55 320.23L152.54 320.22L151.39 320.89V320.9C151.76 320.68 152.24 320.69 152.78 321L189.02 342.05C190.18 342.72 191.12 344.52 191.12 346.07V346.79C191.12 347.54 190.9 348.09 190.53 348.39L191.17 347.97C191.71 347.66 192.2 347.18 192.2 346.16V345.44C192.2 343.89 191.26 342.09 190.1 341.42Z"
                        fill="url(#paint186_linear_984_11217)"
                    />
                    <path
                        d="M189.14 341.96L152.9 320.91C152.32 320.58 151.8 320.59 151.42 320.87C151.76 320.74 152.19 320.79 152.64 321.05L188.88 342.1C190.04 342.77 190.98 344.57 190.98 346.12V346.84C190.98 347.62 190.74 348.19 190.36 348.47C190.89 348.27 191.24 347.64 191.24 346.7V345.98C191.24 344.43 190.3 342.63 189.14 341.96Z"
                        fill="url(#paint187_radial_984_11217)"
                    />
                    <path
                        d="M189.63 345.7C189.63 346.64 188.96 347.03 188.14 346.55C187.32 346.07 186.65 344.92 186.65 343.98C186.65 343.04 187.32 342.65 188.14 343.13C188.96 343.6 189.63 344.75 189.63 345.7Z"
                        fill="#B086CC"
                    />
                    <path
                        d="M196.98 353.31H199C199 350.48 200.93 348.84 202.79 347.25C204.76 345.58 207.2 343.49 205.03 340.23C204.22 339.02 203.28 338.34 202.22 338.21C200.41 337.97 198.85 339.38 197.48 340.62C196.96 341.09 195.72 342.2 195.44 342.08C193.53 341.37 193.08 341.03 193.06 341.01L191.69 342.5C192.04 342.85 193.12 343.37 194.73 343.98C196.18 344.52 197.53 343.31 198.84 342.13C199.89 341.19 201.06 340.11 201.97 340.23C202.42 340.29 202.88 340.67 203.34 341.36C204.43 342.99 203.77 343.76 201.48 345.72C199.48 347.42 196.98 349.54 196.98 353.31Z"
                        fill="#45108A"
                    />
                    <path
                        d="M189.13 345.61C189.13 345.99 189 346.27 188.78 346.4C188.78 346.4 188.16 346.77 188.15 346.77C187.93 346.9 188.07 346.61 187.73 346.41C187.04 346.01 186.49 345.05 186.49 344.27C186.49 343.88 186.13 343.88 186.35 343.75C186.36 343.75 187.02 343.38 187.02 343.37C187.24 343.25 187.55 343.27 187.89 343.47C188.58 343.87 189.13 344.83 189.13 345.61Z"
                        fill="url(#paint188_linear_984_11217)"
                    />
                    <path
                        d="M188.47 345.99C188.47 346.78 187.91 347.09 187.23 346.7C186.54 346.3 185.99 345.34 185.99 344.56C185.99 343.77 186.55 343.46 187.23 343.85C187.92 344.25 188.47 345.21 188.47 345.99Z"
                        fill="url(#paint189_linear_984_11217)"
                    />
                    <path
                        d="M187.29 343.82C186.96 343.63 186.66 343.6 186.44 343.72C186.65 343.66 186.9 343.71 187.18 343.87C187.87 344.27 188.42 345.23 188.42 346.01C188.42 346.42 188.27 346.7 188.03 346.82C188.33 346.74 188.53 346.43 188.53 345.97C188.53 345.18 187.98 344.22 187.29 343.82Z"
                        fill="url(#paint190_radial_984_11217)"
                    />
                    <path
                        d="M194.56 357.52C194.56 358.46 193.89 358.85 193.07 358.37C192.25 357.89 191.58 356.74 191.58 355.8C191.58 354.86 192.25 354.47 193.07 354.95C193.89 355.43 194.56 356.58 194.56 357.52Z"
                        fill="#B086CC"
                    />
                    <path
                        d="M194.07 357.44C194.07 357.82 193.94 358.1 193.72 358.23L193.1 358.6C192.87 358.73 193.01 358.44 192.67 358.25C191.98 357.85 191.43 356.89 191.43 356.11C191.43 355.72 191.07 355.72 191.29 355.59C191.3 355.59 191.96 355.22 191.96 355.22C192.19 355.1 192.5 355.12 192.83 355.31C193.51 355.69 194.07 356.65 194.07 357.44Z"
                        fill="url(#paint191_linear_984_11217)"
                    />
                    <path
                        d="M193.4 357.82C193.4 358.61 192.84 358.92 192.16 358.53C191.47 358.13 190.92 357.17 190.92 356.39C190.92 355.61 191.48 355.29 192.16 355.68C192.85 356.07 193.4 357.03 193.4 357.82Z"
                        fill="url(#paint192_linear_984_11217)"
                    />
                    <path
                        d="M192.22 355.65C191.89 355.46 191.59 355.43 191.37 355.55C191.58 355.49 191.83 355.54 192.11 355.7C192.8 356.1 193.35 357.06 193.35 357.84C193.35 358.25 193.2 358.53 192.96 358.65C193.26 358.57 193.46 358.26 193.46 357.8C193.46 357 192.91 356.04 192.22 355.65Z"
                        fill="url(#paint193_radial_984_11217)"
                    />
                    <path
                        d="M155.19 325.52C155.19 326.46 154.52 326.85 153.7 326.37C152.88 325.89 152.21 324.74 152.21 323.8C152.21 322.86 152.88 322.47 153.7 322.95C154.53 323.43 155.19 324.58 155.19 325.52Z"
                        fill="#B086CC"
                    />
                    <path
                        d="M154.7 325.44C154.7 325.82 154.57 326.1 154.35 326.23C154.34 326.23 153.73 326.6 153.73 326.6C153.5 326.73 153.64 326.44 153.3 326.25C152.61 325.85 152.06 324.89 152.06 324.11C152.06 323.72 151.7 323.72 151.92 323.59C151.93 323.59 152.59 323.22 152.59 323.21C152.81 323.09 153.12 323.11 153.46 323.31C154.14 323.69 154.7 324.65 154.7 325.44Z"
                        fill="url(#paint194_linear_984_11217)"
                    />
                    <path
                        d="M154.04 325.82C154.04 326.61 153.48 326.92 152.8 326.53C152.11 326.13 151.56 325.17 151.56 324.39C151.56 323.6 152.12 323.29 152.8 323.68C153.48 324.07 154.04 325.03 154.04 325.82Z"
                        fill="url(#paint195_linear_984_11217)"
                    />
                    <path
                        d="M152.85 323.65C152.52 323.46 152.22 323.43 152 323.55C152.21 323.49 152.46 323.54 152.74 323.7C153.43 324.1 153.98 325.06 153.98 325.84C153.98 326.25 153.83 326.53 153.59 326.65C153.89 326.57 154.09 326.26 154.09 325.8C154.1 325 153.54 324.04 152.85 323.65Z"
                        fill="url(#paint196_radial_984_11217)"
                    />
                </g>
                <g className={classes.logo}>
                    <path
                        d="M313.46 221.295C298.857 229.725 275.244 229.876 260.96 221.63C257.047 219.371 254.148 216.671 252.322 213.637C252.019 213.096 252.47 212.477 253.479 212.253C254.424 212.065 255.487 212.312 255.853 212.89C257.433 215.635 260.087 218.047 263.627 220.09C276.545 227.548 297.771 227.412 310.977 219.788C324.184 212.164 324.418 199.91 311.5 192.453C298.582 184.995 277.293 185.167 264.086 192.791C259.261 195.577 255.992 199.042 254.726 202.856C254.527 203.401 253.578 203.806 252.512 203.704C251.572 203.601 250.892 203.062 251.092 202.444C252.616 198.266 256.207 194.4 261.54 191.321C276.143 182.891 299.756 182.74 314.04 190.987C328.324 199.233 328.063 212.864 313.46 221.295Z"
                        fill="#DEC9EB"
                    />
                    <path
                        d="M307.933 218.104C296.441 224.738 277.914 224.893 266.611 218.367C255.308 211.842 255.576 201.147 267.068 194.512C278.56 187.878 297.086 187.723 308.39 194.249C309.073 194.643 309.122 195.331 308.36 195.771C307.662 196.174 306.468 196.218 305.723 195.788C295.91 190.123 279.708 190.227 269.676 196.018C259.644 201.809 259.465 211.163 269.278 216.828C279.091 222.493 295.293 222.389 305.325 216.598C311.42 213.079 314.152 208.132 312.549 203.321C312.371 202.778 313.01 202.194 314.017 202.043C314.961 201.928 315.959 202.284 316.199 202.862C317.976 208.433 314.854 214.108 307.933 218.104Z"
                        fill="#DEC9EB"
                    />
                    <path
                        d="M302.467 214.949C298.404 217.295 292.978 218.635 287.264 218.635C275.458 218.71 265.956 213.224 266.086 206.409C266.149 203.146 268.407 199.978 272.47 197.632C276.534 195.286 281.96 193.946 287.674 193.946C288.679 193.94 289.486 194.406 289.475 194.986C289.464 195.566 288.638 196.043 287.634 196.049C282.861 196.079 278.444 197.195 275.079 199.138C271.714 201.08 269.843 203.666 269.728 206.386C269.62 212.041 277.446 216.559 287.242 216.496C292.015 216.466 296.432 215.35 299.797 213.407C303.162 211.465 305.032 208.879 305.147 206.16C305.212 202.752 302.321 199.616 297.522 197.726C296.712 197.405 296.474 196.754 297.048 196.279C297.622 195.804 298.755 195.652 299.565 195.973C305.424 198.255 308.931 202.039 308.79 206.136C308.851 209.471 306.531 212.603 302.467 214.949Z"
                        fill="#DEC9EB"
                    />
                    <path
                        d="M296.318 211.399C294.033 212.719 290.814 213.573 287.423 213.595C280.515 213.639 274.925 210.412 275.002 206.424C275.013 205.844 275.838 205.368 276.843 205.361C277.848 205.355 278.655 205.821 278.644 206.401C278.59 209.229 282.565 211.523 287.463 211.492C292.361 211.461 296.425 209.115 296.479 206.287C296.533 203.459 292.558 201.165 287.66 201.196C284.646 201.215 281.929 202.066 280.207 203.491C279.633 203.966 278.499 204.118 277.689 203.797C276.879 203.476 276.64 202.825 277.215 202.35C279.576 200.341 283.556 199.12 287.7 199.093C294.608 199.049 300.198 202.276 300.121 206.264C300.084 208.222 298.604 210.08 296.318 211.399Z"
                        fill="#DEC9EB"
                    />
                </g>
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_984_11217"
                    x1="356.359"
                    y1="404.396"
                    x2="461.559"
                    y2="404.396"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#310964" />
                    <stop offset="0.2929" stopColor="#45108A" />
                    <stop offset="0.6212" stopColor="#25054D" />
                    <stop offset="0.759" stopColor="#2B0758" />
                    <stop offset="1" stopColor="#3B0C76" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_984_11217"
                    x1="472.059"
                    y1="316.849"
                    x2="387.382"
                    y2="407.643"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#25054D" />
                    <stop offset="1" stopColor="#45108A" />
                </linearGradient>
                <radialGradient
                    id="paint2_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(392.143 410.974) scale(39.417)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint3_linear_984_11217"
                    x1="109.359"
                    y1="404.396"
                    x2="214.559"
                    y2="404.396"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#310964" />
                    <stop offset="0.2929" stopColor="#45108A" />
                    <stop offset="0.6212" stopColor="#25054D" />
                    <stop offset="0.759" stopColor="#2B0758" />
                    <stop offset="1" stopColor="#3B0C76" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_984_11217"
                    x1="225.059"
                    y1="316.849"
                    x2="140.382"
                    y2="407.643"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#25054D" />
                    <stop offset="1" stopColor="#45108A" />
                </linearGradient>
                <radialGradient
                    id="paint5_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(145.143 410.974) scale(39.4169)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint6_linear_984_11217"
                    x1="460.526"
                    y1="238.396"
                    x2="565.726"
                    y2="238.396"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#310964" />
                    <stop offset="0.2929" stopColor="#45108A" />
                    <stop offset="0.6212" stopColor="#25054D" />
                    <stop offset="0.759" stopColor="#2B0758" />
                    <stop offset="1" stopColor="#3B0C76" />
                </linearGradient>
                <linearGradient
                    id="paint7_linear_984_11217"
                    x1="576.225"
                    y1="150.849"
                    x2="491.548"
                    y2="241.643"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#25054D" />
                    <stop offset="1" stopColor="#45108A" />
                </linearGradient>
                <radialGradient
                    id="paint8_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(496.31 244.974) scale(39.4169)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint9_linear_984_11217"
                    x1="5.19263"
                    y1="238.396"
                    x2="110.392"
                    y2="238.396"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#310964" />
                    <stop offset="0.2929" stopColor="#45108A" />
                    <stop offset="0.6212" stopColor="#25054D" />
                    <stop offset="0.759" stopColor="#2B0758" />
                    <stop offset="1" stopColor="#3B0C76" />
                </linearGradient>
                <linearGradient
                    id="paint10_linear_984_11217"
                    x1="120.892"
                    y1="150.849"
                    x2="36.2148"
                    y2="241.643"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#25054D" />
                    <stop offset="1" stopColor="#45108A" />
                </linearGradient>
                <radialGradient
                    id="paint11_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(40.976 244.974) scale(39.417)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint12_linear_984_11217"
                    x1="109.359"
                    y1="97.7298"
                    x2="214.559"
                    y2="97.7298"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#310964" />
                    <stop offset="0.2929" stopColor="#45108A" />
                    <stop offset="0.6212" stopColor="#25054D" />
                    <stop offset="0.759" stopColor="#2B0758" />
                    <stop offset="1" stopColor="#3B0C76" />
                </linearGradient>
                <linearGradient
                    id="paint13_linear_984_11217"
                    x1="225.059"
                    y1="10.182"
                    x2="140.382"
                    y2="100.976"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#25054D" />
                    <stop offset="1" stopColor="#45108A" />
                </linearGradient>
                <radialGradient
                    id="paint14_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(145.143 104.307) scale(39.4169)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint15_linear_984_11217"
                    x1="356.359"
                    y1="97.7298"
                    x2="461.559"
                    y2="97.7298"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#310964" />
                    <stop offset="0.2929" stopColor="#45108A" />
                    <stop offset="0.6212" stopColor="#25054D" />
                    <stop offset="0.759" stopColor="#2B0758" />
                    <stop offset="1" stopColor="#3B0C76" />
                </linearGradient>
                <linearGradient
                    id="paint16_linear_984_11217"
                    x1="472.059"
                    y1="10.182"
                    x2="387.382"
                    y2="100.976"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#25054D" />
                    <stop offset="1" stopColor="#45108A" />
                </linearGradient>
                <radialGradient
                    id="paint17_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(392.143 104.307) scale(39.4169)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint18_linear_984_11217"
                    x1="184.075"
                    y1="231.137"
                    x2="389.811"
                    y2="231.137"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0404" stopColor="#25054D" />
                    <stop offset="0.1425" stopColor="#260550" />
                    <stop offset="0.2097" stopColor="#2B0759" />
                    <stop offset="0.2669" stopColor="#330A67" />
                    <stop offset="0.3182" stopColor="#3E0E7D" />
                    <stop offset="0.3434" stopColor="#45108A" />
                    <stop offset="0.3809" stopColor="#4E1294" />
                    <stop offset="0.4447" stopColor="#6518AF" />
                    <stop offset="0.4949" stopColor="#7C1DC9" />
                    <stop offset="0.5279" stopColor="#6B19B5" />
                    <stop offset="0.5859" stopColor="#45108A" />
                    <stop offset="0.6584" stopColor="#3C0D79" />
                    <stop offset="0.7851" stopColor="#2F0961" />
                    <stop offset="0.9023" stopColor="#280652" />
                    <stop offset="1" stopColor="#25054D" />
                </linearGradient>
                <linearGradient
                    id="paint19_linear_984_11217"
                    x1="363.325"
                    y1="28.664"
                    x2="278.671"
                    y2="247.189"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#25054D" />
                    <stop offset="1" stopColor="#45108A" />
                </linearGradient>
                <linearGradient
                    id="paint20_linear_984_11217"
                    x1="188.775"
                    y1="222.471"
                    x2="385.055"
                    y2="222.471"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0354" stopColor="#B086CC" />
                    <stop offset="0.2121" stopColor="#C1A1D5" />
                    <stop offset="0.2864" stopColor="#C8ABDA" />
                    <stop offset="0.4129" stopColor="#DBC6E7" />
                    <stop offset="0.5051" stopColor="#EBDEF3" />
                    <stop offset="0.5628" stopColor="#E4D2EE" />
                    <stop offset="0.6936" stopColor="#D6BCE6" />
                    <stop offset="0.7778" stopColor="#D1B4E3" />
                    <stop offset="0.7841" stopColor="#CFB2E2" />
                    <stop offset="0.8642" stopColor="#BE9AD6" />
                    <stop offset="0.9383" stopColor="#B48BCF" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <linearGradient
                    id="paint21_linear_984_11217"
                    x1="183.91"
                    y1="216.257"
                    x2="389.647"
                    y2="216.257"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0404" stopColor="#25054D" />
                    <stop offset="0.1425" stopColor="#260550" />
                    <stop offset="0.2097" stopColor="#2B0759" />
                    <stop offset="0.2669" stopColor="#330A67" />
                    <stop offset="0.3182" stopColor="#3E0E7D" />
                    <stop offset="0.3434" stopColor="#45108A" />
                    <stop offset="0.3809" stopColor="#4E1294" />
                    <stop offset="0.4447" stopColor="#6518AF" />
                    <stop offset="0.4949" stopColor="#7C1DC9" />
                    <stop offset="0.5279" stopColor="#6B19B5" />
                    <stop offset="0.5859" stopColor="#45108A" />
                    <stop offset="0.6584" stopColor="#3C0D79" />
                    <stop offset="0.7851" stopColor="#2F0961" />
                    <stop offset="0.9023" stopColor="#280652" />
                    <stop offset="1" stopColor="#25054D" />
                </linearGradient>
                <linearGradient
                    id="paint22_linear_984_11217"
                    x1="363.16"
                    y1="10.2848"
                    x2="278.506"
                    y2="228.81"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#25054D" />
                    <stop offset="1" stopColor="#45108A" />
                </linearGradient>
                <radialGradient
                    id="paint23_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(286.771 237.173) scale(75.8536)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint24_linear_984_11217"
                    x1="379.206"
                    y1="234.977"
                    x2="393.421"
                    y2="257.932"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00505051" stopColor="#9874C6" />
                    <stop offset="0.3586" stopColor="#C1A1D5" />
                    <stop offset="0.3779" stopColor="#C8ABDA" />
                    <stop offset="0.411" stopColor="#DAC6E6" />
                    <stop offset="0.4535" stopColor="#F7F2F9" />
                    <stop offset="0.4646" stopColor="white" />
                    <stop offset="0.4913" stopColor="#F1E9F7" />
                    <stop offset="0.5332" stopColor="#E0CCEC" />
                    <stop offset="0.5695" stopColor="#D5BAE5" />
                    <stop offset="0.596" stopColor="#D1B4E3" />
                    <stop offset="0.6556" stopColor="#B395D6" />
                    <stop offset="0.7159" stopColor="#9C7DCB" />
                    <stop offset="0.7717" stopColor="#8E6EC5" />
                    <stop offset="0.8182" stopColor="#8969C3" />
                    <stop offset="0.8855" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <radialGradient
                    id="paint25_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(381.591 246.772) scale(9.4317)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint26_linear_984_11217"
                    x1="365.073"
                    y1="243.144"
                    x2="379.287"
                    y2="266.099"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00505051" stopColor="#9874C6" />
                    <stop offset="0.3586" stopColor="#C1A1D5" />
                    <stop offset="0.3779" stopColor="#C8ABDA" />
                    <stop offset="0.411" stopColor="#DAC6E6" />
                    <stop offset="0.4535" stopColor="#F7F2F9" />
                    <stop offset="0.4646" stopColor="white" />
                    <stop offset="0.4913" stopColor="#F1E9F7" />
                    <stop offset="0.5332" stopColor="#E0CCEC" />
                    <stop offset="0.5695" stopColor="#D5BAE5" />
                    <stop offset="0.596" stopColor="#D1B4E3" />
                    <stop offset="0.6556" stopColor="#B395D6" />
                    <stop offset="0.7159" stopColor="#9C7DCB" />
                    <stop offset="0.7717" stopColor="#8E6EC5" />
                    <stop offset="0.8182" stopColor="#8969C3" />
                    <stop offset="0.8855" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <radialGradient
                    id="paint27_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(367.457 254.939) scale(9.4316)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint28_linear_984_11217"
                    x1="350.94"
                    y1="251.311"
                    x2="365.154"
                    y2="274.265"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00505051" stopColor="#9874C6" />
                    <stop offset="0.3586" stopColor="#C1A1D5" />
                    <stop offset="0.3779" stopColor="#C8ABDA" />
                    <stop offset="0.411" stopColor="#DAC6E6" />
                    <stop offset="0.4535" stopColor="#F7F2F9" />
                    <stop offset="0.4646" stopColor="white" />
                    <stop offset="0.4913" stopColor="#F1E9F7" />
                    <stop offset="0.5332" stopColor="#E0CCEC" />
                    <stop offset="0.5695" stopColor="#D5BAE5" />
                    <stop offset="0.596" stopColor="#D1B4E3" />
                    <stop offset="0.6556" stopColor="#B395D6" />
                    <stop offset="0.7159" stopColor="#9C7DCB" />
                    <stop offset="0.7717" stopColor="#8E6EC5" />
                    <stop offset="0.8182" stopColor="#8969C3" />
                    <stop offset="0.8855" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <radialGradient
                    id="paint29_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(353.324 263.106) scale(9.4316)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint30_linear_984_11217"
                    x1="336.806"
                    y1="259.477"
                    x2="351.021"
                    y2="282.432"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00505051" stopColor="#9874C6" />
                    <stop offset="0.3586" stopColor="#C1A1D5" />
                    <stop offset="0.3779" stopColor="#C8ABDA" />
                    <stop offset="0.411" stopColor="#DAC6E6" />
                    <stop offset="0.4535" stopColor="#F7F2F9" />
                    <stop offset="0.4646" stopColor="white" />
                    <stop offset="0.4913" stopColor="#F1E9F7" />
                    <stop offset="0.5332" stopColor="#E0CCEC" />
                    <stop offset="0.5695" stopColor="#D5BAE5" />
                    <stop offset="0.596" stopColor="#D1B4E3" />
                    <stop offset="0.6556" stopColor="#B395D6" />
                    <stop offset="0.7159" stopColor="#9C7DCB" />
                    <stop offset="0.7717" stopColor="#8E6EC5" />
                    <stop offset="0.8182" stopColor="#8969C3" />
                    <stop offset="0.8855" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <radialGradient
                    id="paint31_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(339.191 271.272) scale(9.43171)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint32_linear_984_11217"
                    x1="322.673"
                    y1="267.644"
                    x2="336.887"
                    y2="290.599"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00505051" stopColor="#9874C6" />
                    <stop offset="0.3586" stopColor="#C1A1D5" />
                    <stop offset="0.3779" stopColor="#C8ABDA" />
                    <stop offset="0.411" stopColor="#DAC6E6" />
                    <stop offset="0.4535" stopColor="#F7F2F9" />
                    <stop offset="0.4646" stopColor="white" />
                    <stop offset="0.4913" stopColor="#F1E9F7" />
                    <stop offset="0.5332" stopColor="#E0CCEC" />
                    <stop offset="0.5695" stopColor="#D5BAE5" />
                    <stop offset="0.596" stopColor="#D1B4E3" />
                    <stop offset="0.6556" stopColor="#B395D6" />
                    <stop offset="0.7159" stopColor="#9C7DCB" />
                    <stop offset="0.7717" stopColor="#8E6EC5" />
                    <stop offset="0.8182" stopColor="#8969C3" />
                    <stop offset="0.8855" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <radialGradient
                    id="paint33_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(325.058 279.439) scale(9.43161)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint34_linear_984_11217"
                    x1="308.54"
                    y1="275.811"
                    x2="322.754"
                    y2="298.765"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00505051" stopColor="#9874C6" />
                    <stop offset="0.3586" stopColor="#C1A1D5" />
                    <stop offset="0.3779" stopColor="#C8ABDA" />
                    <stop offset="0.411" stopColor="#DAC6E6" />
                    <stop offset="0.4535" stopColor="#F7F2F9" />
                    <stop offset="0.4646" stopColor="white" />
                    <stop offset="0.4913" stopColor="#F1E9F7" />
                    <stop offset="0.5332" stopColor="#E0CCEC" />
                    <stop offset="0.5695" stopColor="#D5BAE5" />
                    <stop offset="0.596" stopColor="#D1B4E3" />
                    <stop offset="0.6556" stopColor="#B395D6" />
                    <stop offset="0.7159" stopColor="#9C7DCB" />
                    <stop offset="0.7717" stopColor="#8E6EC5" />
                    <stop offset="0.8182" stopColor="#8969C3" />
                    <stop offset="0.8855" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <radialGradient
                    id="paint35_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(310.924 287.606) scale(9.4316)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint36_linear_984_11217"
                    x1="194.747"
                    y1="234.977"
                    x2="180.533"
                    y2="257.932"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00505051" stopColor="#9874C6" />
                    <stop offset="0.3586" stopColor="#C1A1D5" />
                    <stop offset="0.3779" stopColor="#C8ABDA" />
                    <stop offset="0.411" stopColor="#DAC6E6" />
                    <stop offset="0.4535" stopColor="#F7F2F9" />
                    <stop offset="0.4646" stopColor="white" />
                    <stop offset="0.4913" stopColor="#F1E9F7" />
                    <stop offset="0.5332" stopColor="#E0CCEC" />
                    <stop offset="0.5695" stopColor="#D5BAE5" />
                    <stop offset="0.596" stopColor="#D1B4E3" />
                    <stop offset="0.6556" stopColor="#B395D6" />
                    <stop offset="0.7159" stopColor="#9C7DCB" />
                    <stop offset="0.7717" stopColor="#8E6EC5" />
                    <stop offset="0.8182" stopColor="#8969C3" />
                    <stop offset="0.8855" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <radialGradient
                    id="paint37_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(192.363 246.772) rotate(180) scale(9.4317)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint38_linear_984_11217"
                    x1="208.881"
                    y1="243.144"
                    x2="194.667"
                    y2="266.099"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00505051" stopColor="#9874C6" />
                    <stop offset="0.3586" stopColor="#C1A1D5" />
                    <stop offset="0.3779" stopColor="#C8ABDA" />
                    <stop offset="0.411" stopColor="#DAC6E6" />
                    <stop offset="0.4535" stopColor="#F7F2F9" />
                    <stop offset="0.4646" stopColor="white" />
                    <stop offset="0.4913" stopColor="#F1E9F7" />
                    <stop offset="0.5332" stopColor="#E0CCEC" />
                    <stop offset="0.5695" stopColor="#D5BAE5" />
                    <stop offset="0.596" stopColor="#D1B4E3" />
                    <stop offset="0.6556" stopColor="#B395D6" />
                    <stop offset="0.7159" stopColor="#9C7DCB" />
                    <stop offset="0.7717" stopColor="#8E6EC5" />
                    <stop offset="0.8182" stopColor="#8969C3" />
                    <stop offset="0.8855" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <radialGradient
                    id="paint39_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(206.496 254.939) rotate(180) scale(9.4316)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint40_linear_984_11217"
                    x1="223.014"
                    y1="251.311"
                    x2="208.8"
                    y2="274.265"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00505051" stopColor="#9874C6" />
                    <stop offset="0.3586" stopColor="#C1A1D5" />
                    <stop offset="0.3779" stopColor="#C8ABDA" />
                    <stop offset="0.411" stopColor="#DAC6E6" />
                    <stop offset="0.4535" stopColor="#F7F2F9" />
                    <stop offset="0.4646" stopColor="white" />
                    <stop offset="0.4913" stopColor="#F1E9F7" />
                    <stop offset="0.5332" stopColor="#E0CCEC" />
                    <stop offset="0.5695" stopColor="#D5BAE5" />
                    <stop offset="0.596" stopColor="#D1B4E3" />
                    <stop offset="0.6556" stopColor="#B395D6" />
                    <stop offset="0.7159" stopColor="#9C7DCB" />
                    <stop offset="0.7717" stopColor="#8E6EC5" />
                    <stop offset="0.8182" stopColor="#8969C3" />
                    <stop offset="0.8855" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <radialGradient
                    id="paint41_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(220.63 263.106) rotate(180) scale(9.4317)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint42_linear_984_11217"
                    x1="237.147"
                    y1="259.477"
                    x2="222.933"
                    y2="282.432"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00505051" stopColor="#9874C6" />
                    <stop offset="0.3586" stopColor="#C1A1D5" />
                    <stop offset="0.3779" stopColor="#C8ABDA" />
                    <stop offset="0.411" stopColor="#DAC6E6" />
                    <stop offset="0.4535" stopColor="#F7F2F9" />
                    <stop offset="0.4646" stopColor="white" />
                    <stop offset="0.4913" stopColor="#F1E9F7" />
                    <stop offset="0.5332" stopColor="#E0CCEC" />
                    <stop offset="0.5695" stopColor="#D5BAE5" />
                    <stop offset="0.596" stopColor="#D1B4E3" />
                    <stop offset="0.6556" stopColor="#B395D6" />
                    <stop offset="0.7159" stopColor="#9C7DCB" />
                    <stop offset="0.7717" stopColor="#8E6EC5" />
                    <stop offset="0.8182" stopColor="#8969C3" />
                    <stop offset="0.8855" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <radialGradient
                    id="paint43_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(234.763 271.272) rotate(180) scale(9.4317)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint44_linear_984_11217"
                    x1="251.281"
                    y1="267.644"
                    x2="237.067"
                    y2="290.599"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00505051" stopColor="#9874C6" />
                    <stop offset="0.3586" stopColor="#C1A1D5" />
                    <stop offset="0.3779" stopColor="#C8ABDA" />
                    <stop offset="0.411" stopColor="#DAC6E6" />
                    <stop offset="0.4535" stopColor="#F7F2F9" />
                    <stop offset="0.4646" stopColor="white" />
                    <stop offset="0.4913" stopColor="#F1E9F7" />
                    <stop offset="0.5332" stopColor="#E0CCEC" />
                    <stop offset="0.5695" stopColor="#D5BAE5" />
                    <stop offset="0.596" stopColor="#D1B4E3" />
                    <stop offset="0.6556" stopColor="#B395D6" />
                    <stop offset="0.7159" stopColor="#9C7DCB" />
                    <stop offset="0.7717" stopColor="#8E6EC5" />
                    <stop offset="0.8182" stopColor="#8969C3" />
                    <stop offset="0.8855" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <radialGradient
                    id="paint45_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(248.896 279.439) rotate(180) scale(9.4316)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint46_linear_984_11217"
                    x1="265.414"
                    y1="275.811"
                    x2="251.2"
                    y2="298.765"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.00505051" stopColor="#9874C6" />
                    <stop offset="0.3586" stopColor="#C1A1D5" />
                    <stop offset="0.3779" stopColor="#C8ABDA" />
                    <stop offset="0.411" stopColor="#DAC6E6" />
                    <stop offset="0.4535" stopColor="#F7F2F9" />
                    <stop offset="0.4646" stopColor="white" />
                    <stop offset="0.4913" stopColor="#F1E9F7" />
                    <stop offset="0.5332" stopColor="#E0CCEC" />
                    <stop offset="0.5695" stopColor="#D5BAE5" />
                    <stop offset="0.596" stopColor="#D1B4E3" />
                    <stop offset="0.6556" stopColor="#B395D6" />
                    <stop offset="0.7159" stopColor="#9C7DCB" />
                    <stop offset="0.7717" stopColor="#8E6EC5" />
                    <stop offset="0.8182" stopColor="#8969C3" />
                    <stop offset="0.8855" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <radialGradient
                    id="paint47_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(263.03 287.606) rotate(180) scale(9.4317)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint48_linear_984_11217"
                    x1="369.371"
                    y1="383.069"
                    x2="454.579"
                    y2="383.069"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0556" stopColor="#9F79B8" />
                    <stop offset="0.2575" stopColor="#A17BBA" />
                    <stop offset="0.3569" stopColor="#A783BF" />
                    <stop offset="0.4338" stopColor="#B290C9" />
                    <stop offset="0.4949" stopColor="#C1A1D5" />
                    <stop offset="0.5067" stopColor="#C4A5D7" />
                    <stop offset="0.5196" stopColor="#CDB3DD" />
                    <stop offset="0.5329" stopColor="#DBC8E7" />
                    <stop offset="0.5466" stopColor="#EFE7F4" />
                    <stop offset="0.5556" stopColor="white" />
                    <stop offset="0.5678" stopColor="#ECE0F3" />
                    <stop offset="0.5801" stopColor="#DDC8EA" />
                    <stop offset="0.5915" stopColor="#D4B9E5" />
                    <stop offset="0.601" stopColor="#D1B4E3" />
                    <stop offset="0.658" stopColor="#B395D6" />
                    <stop offset="0.7155" stopColor="#9C7DCB" />
                    <stop offset="0.7687" stopColor="#8E6EC5" />
                    <stop offset="0.8131" stopColor="#8969C3" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <linearGradient
                    id="paint49_linear_984_11217"
                    x1="367.559"
                    y1="380.838"
                    x2="449.533"
                    y2="380.838"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint50_linear_984_11217"
                    x1="369.371"
                    y1="394.478"
                    x2="454.579"
                    y2="394.478"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0556" stopColor="#9F79B8" />
                    <stop offset="0.2575" stopColor="#A17BBA" />
                    <stop offset="0.3569" stopColor="#A783BF" />
                    <stop offset="0.4338" stopColor="#B290C9" />
                    <stop offset="0.4949" stopColor="#C1A1D5" />
                    <stop offset="0.5067" stopColor="#C4A5D7" />
                    <stop offset="0.5196" stopColor="#CDB3DD" />
                    <stop offset="0.5329" stopColor="#DBC8E7" />
                    <stop offset="0.5466" stopColor="#EFE7F4" />
                    <stop offset="0.5556" stopColor="white" />
                    <stop offset="0.5678" stopColor="#ECE0F3" />
                    <stop offset="0.5801" stopColor="#DDC8EA" />
                    <stop offset="0.5915" stopColor="#D4B9E5" />
                    <stop offset="0.601" stopColor="#D1B4E3" />
                    <stop offset="0.658" stopColor="#B395D6" />
                    <stop offset="0.7155" stopColor="#9C7DCB" />
                    <stop offset="0.7687" stopColor="#8E6EC5" />
                    <stop offset="0.8131" stopColor="#8969C3" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <linearGradient
                    id="paint51_linear_984_11217"
                    x1="368.475"
                    y1="380.838"
                    x2="448.616"
                    y2="380.838"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#3D065F" />
                    <stop offset="1" stopColor="#5F27BD" />
                </linearGradient>
                <linearGradient
                    id="paint52_linear_984_11217"
                    x1="408.241"
                    y1="390.446"
                    x2="409.368"
                    y2="363.242"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#3D065F" />
                    <stop offset="1" stopColor="#10054D" />
                </linearGradient>
                <linearGradient
                    id="paint53_linear_984_11217"
                    x1="402.374"
                    y1="362.001"
                    x2="423.305"
                    y2="394.85"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0556" stopColor="#9F79B8" />
                    <stop offset="0.2502" stopColor="#A17BBA" />
                    <stop offset="0.3461" stopColor="#A883C0" />
                    <stop offset="0.4204" stopColor="#B490CC" />
                    <stop offset="0.4836" stopColor="#C5A3DC" />
                    <stop offset="0.5392" stopColor="#DBBBF0" />
                    <stop offset="0.5606" stopColor="#E6C6FA" />
                    <stop offset="0.5967" stopColor="#D6B6F1" />
                    <stop offset="0.6872" stopColor="#B595DD" />
                    <stop offset="0.7735" stopColor="#9D7DCF" />
                    <stop offset="0.8529" stopColor="#8E6EC6" />
                    <stop offset="0.9192" stopColor="#8969C3" />
                </linearGradient>
                <linearGradient
                    id="paint54_linear_984_11217"
                    x1="371.837"
                    y1="303.189"
                    x2="457.117"
                    y2="377.263"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1409" stopColor="#A27DCA" />
                    <stop offset="0.2725" stopColor="#AC88CF" />
                    <stop offset="0.4" stopColor="#BC9BD7" />
                    <stop offset="0.5202" stopColor="#D1B4E3" />
                    <stop offset="0.6493" stopColor="#DBC4E9" />
                    <stop offset="0.8997" stopColor="#F4EDF8" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient
                    id="paint55_linear_984_11217"
                    x1="444.714"
                    y1="376.284"
                    x2="402.714"
                    y2="318.284"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2A0C5C" />
                    <stop offset="0.6869" stopColor="#5F27BD" />
                    <stop offset="1" stopColor="#B4299A" />
                </linearGradient>
                <linearGradient
                    id="paint56_linear_984_11217"
                    x1="394.195"
                    y1="312.85"
                    x2="453.305"
                    y2="382.54"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#7C1DC9" />
                    <stop offset="0.03" stopColor="#741BBD" />
                    <stop offset="0.162" stopColor="#56148B" />
                    <stop offset="0.2971" stopColor="#3B0E60" />
                    <stop offset="0.4332" stopColor="#26093E" />
                    <stop offset="0.5704" stopColor="#150523" />
                    <stop offset="0.7095" stopColor="#09020F" />
                    <stop offset="0.8512" stopColor="#020104" />
                    <stop offset="1" />
                </linearGradient>
                <linearGradient
                    id="paint57_linear_984_11217"
                    x1="461.573"
                    y1="385.945"
                    x2="419.652"
                    y2="318.962"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0556" stopColor="#9F79B8" />
                    <stop offset="0.2575" stopColor="#A17BBA" />
                    <stop offset="0.3569" stopColor="#A783BF" />
                    <stop offset="0.4338" stopColor="#B290C9" />
                    <stop offset="0.4949" stopColor="#C1A1D5" />
                    <stop offset="0.5067" stopColor="#C4A5D7" />
                    <stop offset="0.5196" stopColor="#CDB3DD" />
                    <stop offset="0.5329" stopColor="#DBC8E7" />
                    <stop offset="0.5466" stopColor="#EFE7F4" />
                    <stop offset="0.5556" stopColor="white" />
                    <stop offset="0.5678" stopColor="#ECE0F3" />
                    <stop offset="0.5801" stopColor="#DDC8EA" />
                    <stop offset="0.5915" stopColor="#D4B9E5" />
                    <stop offset="0.601" stopColor="#D1B4E3" />
                    <stop offset="0.658" stopColor="#B395D6" />
                    <stop offset="0.7155" stopColor="#9C7DCB" />
                    <stop offset="0.7687" stopColor="#8E6EC5" />
                    <stop offset="0.8131" stopColor="#8969C3" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <radialGradient
                    id="paint58_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(449.612 344.792) scale(7.1243)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint59_linear_984_11217"
                    x1="486.13"
                    y1="221.363"
                    x2="537.682"
                    y2="221.363"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.0488" stopColor="#C8ABDA" />
                    <stop offset="0.1149" stopColor="#DAC6E6" />
                    <stop offset="0.1998" stopColor="#F7F2F9" />
                    <stop offset="0.2222" stopColor="white" />
                    <stop offset="0.2513" stopColor="#F9F5FB" />
                    <stop offset="0.3001" stopColor="#E9DBF2" />
                    <stop offset="0.3586" stopColor="#D1B4E3" />
                    <stop offset="0.4264" stopColor="#B395D6" />
                    <stop offset="0.4949" stopColor="#9C7DCB" />
                    <stop offset="0.5583" stopColor="#8E6EC5" />
                    <stop offset="0.6111" stopColor="#8969C3" />
                    <stop offset="0.755" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <linearGradient
                    id="paint60_linear_984_11217"
                    x1="542.827"
                    y1="176.824"
                    x2="501.332"
                    y2="221.317"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <radialGradient
                    id="paint61_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(503.665 222.95) scale(19.3159)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint62_linear_984_11217"
                    x1="487.914"
                    y1="212.131"
                    x2="535.92"
                    y2="212.131"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#25054D" />
                    <stop offset="0.2172" stopColor="#45108A" />
                    <stop offset="0.4192" stopColor="#25054D" />
                    <stop offset="0.5555" stopColor="#270651" />
                    <stop offset="0.6984" stopColor="#2E085E" />
                    <stop offset="0.8438" stopColor="#390C73" />
                    <stop offset="0.9646" stopColor="#45108A" />
                </linearGradient>
                <linearGradient
                    id="paint63_linear_984_11217"
                    x1="487.914"
                    y1="210.977"
                    x2="535.92"
                    y2="210.977"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#7C1DC9" />
                    <stop offset="0.0487" stopColor="#6E41D2" />
                    <stop offset="0.1562" stopColor="#4C9BE8" />
                    <stop offset="0.2576" stopColor="#2AF6FF" />
                    <stop offset="0.3345" stopColor="#37D3F6" />
                    <stop offset="0.4865" stopColor="#5093E6" />
                    <stop offset="0.6249" stopColor="#6360DA" />
                    <stop offset="0.745" stopColor="#703BD1" />
                    <stop offset="0.8421" stopColor="#7925CB" />
                    <stop offset="0.904" stopColor="#7C1DC9" />
                </linearGradient>
                <linearGradient
                    id="paint64_linear_984_11217"
                    x1="486.13"
                    y1="207.03"
                    x2="537.682"
                    y2="207.03"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.0488" stopColor="#C8ABDA" />
                    <stop offset="0.1149" stopColor="#DAC6E6" />
                    <stop offset="0.1998" stopColor="#F7F2F9" />
                    <stop offset="0.2222" stopColor="white" />
                    <stop offset="0.2513" stopColor="#F9F5FB" />
                    <stop offset="0.3001" stopColor="#E9DBF2" />
                    <stop offset="0.3586" stopColor="#D1B4E3" />
                    <stop offset="0.4264" stopColor="#B395D6" />
                    <stop offset="0.4949" stopColor="#9C7DCB" />
                    <stop offset="0.5583" stopColor="#8E6EC5" />
                    <stop offset="0.6111" stopColor="#8969C3" />
                    <stop offset="0.755" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <linearGradient
                    id="paint65_linear_984_11217"
                    x1="542.827"
                    y1="162.491"
                    x2="501.332"
                    y2="206.984"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <radialGradient
                    id="paint66_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(503.665 208.616) scale(19.3159)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint67_linear_984_11217"
                    x1="487.914"
                    y1="197.798"
                    x2="535.92"
                    y2="197.798"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#25054D" />
                    <stop offset="0.2172" stopColor="#45108A" />
                    <stop offset="0.4192" stopColor="#25054D" />
                    <stop offset="0.5555" stopColor="#270651" />
                    <stop offset="0.6984" stopColor="#2E085E" />
                    <stop offset="0.8438" stopColor="#390C73" />
                    <stop offset="0.9646" stopColor="#45108A" />
                </linearGradient>
                <linearGradient
                    id="paint68_linear_984_11217"
                    x1="487.914"
                    y1="196.643"
                    x2="535.92"
                    y2="196.643"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#7C1DC9" />
                    <stop offset="0.0487" stopColor="#6E41D2" />
                    <stop offset="0.1562" stopColor="#4C9BE8" />
                    <stop offset="0.2576" stopColor="#2AF6FF" />
                    <stop offset="0.3345" stopColor="#37D3F6" />
                    <stop offset="0.4865" stopColor="#5093E6" />
                    <stop offset="0.6249" stopColor="#6360DA" />
                    <stop offset="0.745" stopColor="#703BD1" />
                    <stop offset="0.8421" stopColor="#7925CB" />
                    <stop offset="0.904" stopColor="#7C1DC9" />
                </linearGradient>
                <linearGradient
                    id="paint69_linear_984_11217"
                    x1="486.13"
                    y1="193.095"
                    x2="537.682"
                    y2="193.095"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.0488" stopColor="#C8ABDA" />
                    <stop offset="0.1149" stopColor="#DAC6E6" />
                    <stop offset="0.1998" stopColor="#F7F2F9" />
                    <stop offset="0.2222" stopColor="white" />
                    <stop offset="0.2513" stopColor="#F9F5FB" />
                    <stop offset="0.3001" stopColor="#E9DBF2" />
                    <stop offset="0.3586" stopColor="#D1B4E3" />
                    <stop offset="0.4264" stopColor="#B395D6" />
                    <stop offset="0.4949" stopColor="#9C7DCB" />
                    <stop offset="0.5583" stopColor="#8E6EC5" />
                    <stop offset="0.6111" stopColor="#8969C3" />
                    <stop offset="0.755" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <linearGradient
                    id="paint70_linear_984_11217"
                    x1="542.827"
                    y1="148.556"
                    x2="501.332"
                    y2="193.049"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <radialGradient
                    id="paint71_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(503.665 194.681) scale(19.3159)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint72_linear_984_11217"
                    x1="487.914"
                    y1="183.863"
                    x2="535.92"
                    y2="183.863"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#25054D" />
                    <stop offset="0.2172" stopColor="#45108A" />
                    <stop offset="0.4192" stopColor="#25054D" />
                    <stop offset="0.5555" stopColor="#270651" />
                    <stop offset="0.6984" stopColor="#2E085E" />
                    <stop offset="0.8438" stopColor="#390C73" />
                    <stop offset="0.9646" stopColor="#45108A" />
                </linearGradient>
                <linearGradient
                    id="paint73_linear_984_11217"
                    x1="487.914"
                    y1="182.708"
                    x2="535.92"
                    y2="182.708"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#7C1DC9" />
                    <stop offset="0.0487" stopColor="#6E41D2" />
                    <stop offset="0.1562" stopColor="#4C9BE8" />
                    <stop offset="0.2576" stopColor="#2AF6FF" />
                    <stop offset="0.3345" stopColor="#37D3F6" />
                    <stop offset="0.4865" stopColor="#5093E6" />
                    <stop offset="0.6249" stopColor="#6360DA" />
                    <stop offset="0.745" stopColor="#703BD1" />
                    <stop offset="0.8421" stopColor="#7925CB" />
                    <stop offset="0.904" stopColor="#7C1DC9" />
                </linearGradient>
                <linearGradient
                    id="paint74_linear_984_11217"
                    x1="486.13"
                    y1="179.006"
                    x2="537.682"
                    y2="179.006"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.0488" stopColor="#C8ABDA" />
                    <stop offset="0.1149" stopColor="#DAC6E6" />
                    <stop offset="0.1998" stopColor="#F7F2F9" />
                    <stop offset="0.2222" stopColor="white" />
                    <stop offset="0.2513" stopColor="#F9F5FB" />
                    <stop offset="0.3001" stopColor="#E9DBF2" />
                    <stop offset="0.3586" stopColor="#D1B4E3" />
                    <stop offset="0.4264" stopColor="#B395D6" />
                    <stop offset="0.4949" stopColor="#9C7DCB" />
                    <stop offset="0.5583" stopColor="#8E6EC5" />
                    <stop offset="0.6111" stopColor="#8969C3" />
                    <stop offset="0.755" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <linearGradient
                    id="paint75_linear_984_11217"
                    x1="542.827"
                    y1="134.467"
                    x2="501.332"
                    y2="178.96"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <radialGradient
                    id="paint76_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(503.665 180.592) scale(19.3159)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint77_linear_984_11217"
                    x1="487.914"
                    y1="169.774"
                    x2="535.92"
                    y2="169.774"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#25054D" />
                    <stop offset="0.2172" stopColor="#45108A" />
                    <stop offset="0.4192" stopColor="#25054D" />
                    <stop offset="0.5555" stopColor="#270651" />
                    <stop offset="0.6984" stopColor="#2E085E" />
                    <stop offset="0.8438" stopColor="#390C73" />
                    <stop offset="0.9646" stopColor="#45108A" />
                </linearGradient>
                <linearGradient
                    id="paint78_linear_984_11217"
                    x1="487.914"
                    y1="168.619"
                    x2="535.92"
                    y2="168.619"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#7C1DC9" />
                    <stop offset="0.0487" stopColor="#6E41D2" />
                    <stop offset="0.1562" stopColor="#4C9BE8" />
                    <stop offset="0.2576" stopColor="#2AF6FF" />
                    <stop offset="0.3345" stopColor="#37D3F6" />
                    <stop offset="0.4865" stopColor="#5093E6" />
                    <stop offset="0.6249" stopColor="#6360DA" />
                    <stop offset="0.745" stopColor="#703BD1" />
                    <stop offset="0.8421" stopColor="#7925CB" />
                    <stop offset="0.904" stopColor="#7C1DC9" />
                </linearGradient>
                <linearGradient
                    id="paint79_linear_984_11217"
                    x1="486.13"
                    y1="164.917"
                    x2="537.682"
                    y2="164.917"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.0488" stopColor="#C8ABDA" />
                    <stop offset="0.1149" stopColor="#DAC6E6" />
                    <stop offset="0.1998" stopColor="#F7F2F9" />
                    <stop offset="0.2222" stopColor="white" />
                    <stop offset="0.2513" stopColor="#F9F5FB" />
                    <stop offset="0.3001" stopColor="#E9DBF2" />
                    <stop offset="0.3586" stopColor="#D1B4E3" />
                    <stop offset="0.4264" stopColor="#B395D6" />
                    <stop offset="0.4949" stopColor="#9C7DCB" />
                    <stop offset="0.5583" stopColor="#8E6EC5" />
                    <stop offset="0.6111" stopColor="#8969C3" />
                    <stop offset="0.755" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <linearGradient
                    id="paint80_linear_984_11217"
                    x1="542.827"
                    y1="120.378"
                    x2="501.332"
                    y2="164.87"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <radialGradient
                    id="paint81_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(503.665 166.503) scale(19.3159)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <radialGradient
                    id="paint82_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(514.063 152.269) scale(13.2492 6.75584)"
                >
                    <stop offset="0.1919" stopColor="#5F5C5D" />
                    <stop offset="1" stopColor="white" />
                </radialGradient>
                <linearGradient
                    id="paint83_linear_984_11217"
                    x1="501.69"
                    y1="153.433"
                    x2="522.319"
                    y2="153.433"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.0488" stopColor="#C8ABDA" />
                    <stop offset="0.1149" stopColor="#DAC6E6" />
                    <stop offset="0.1998" stopColor="#F7F2F9" />
                    <stop offset="0.2222" stopColor="white" />
                    <stop offset="0.2513" stopColor="#F9F5FB" />
                    <stop offset="0.3001" stopColor="#E9DBF2" />
                    <stop offset="0.3586" stopColor="#D1B4E3" />
                    <stop offset="0.4264" stopColor="#B395D6" />
                    <stop offset="0.4949" stopColor="#9C7DCB" />
                    <stop offset="0.5583" stopColor="#8E6EC5" />
                    <stop offset="0.6111" stopColor="#8969C3" />
                    <stop offset="0.755" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <linearGradient
                    id="paint84_linear_984_11217"
                    x1="524.378"
                    y1="135.147"
                    x2="507.773"
                    y2="152.952"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint85_linear_984_11217"
                    x1="519.731"
                    y1="148.371"
                    x2="503.536"
                    y2="148.371"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#25054D" />
                    <stop offset="0.2172" stopColor="#45108A" />
                    <stop offset="0.4192" stopColor="#25054D" />
                    <stop offset="0.5555" stopColor="#270651" />
                    <stop offset="0.6984" stopColor="#2E085E" />
                    <stop offset="0.8438" stopColor="#390C73" />
                    <stop offset="0.9646" stopColor="#45108A" />
                </linearGradient>
                <linearGradient
                    id="paint86_linear_984_11217"
                    x1="519.731"
                    y1="147.361"
                    x2="503.536"
                    y2="147.361"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.0488" stopColor="#C8ABDA" />
                    <stop offset="0.1149" stopColor="#DAC6E6" />
                    <stop offset="0.1998" stopColor="#F7F2F9" />
                    <stop offset="0.2222" stopColor="white" />
                    <stop offset="0.2513" stopColor="#F9F5FB" />
                    <stop offset="0.3001" stopColor="#E9DBF2" />
                    <stop offset="0.3586" stopColor="#D1B4E3" />
                    <stop offset="0.4264" stopColor="#B395D6" />
                    <stop offset="0.4949" stopColor="#9C7DCB" />
                    <stop offset="0.5583" stopColor="#8E6EC5" />
                    <stop offset="0.6111" stopColor="#8969C3" />
                    <stop offset="0.755" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <radialGradient
                    id="paint87_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(508.707 153.605) scale(7.7297)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint88_linear_984_11217"
                    x1="169.992"
                    y1="47.2043"
                    x2="183.302"
                    y2="30.8102"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.096" stopColor="#45108A" />
                    <stop offset="1" stopColor="#7C1DC9" />
                </linearGradient>
                <linearGradient
                    id="paint89_linear_984_11217"
                    x1="193.368"
                    y1="80.5069"
                    x2="216.087"
                    y2="131.487"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint90_linear_984_11217"
                    x1="149.81"
                    y1="54.9555"
                    x2="178.794"
                    y2="70.8406"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint91_linear_984_11217"
                    x1="181.295"
                    y1="78.8164"
                    x2="225.023"
                    y2="57.055"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.096" stopColor="#45108A" />
                    <stop offset="1" stopColor="#7C1DC9" />
                </linearGradient>
                <linearGradient
                    id="paint92_linear_984_11217"
                    x1="134.991"
                    y1="45.5841"
                    x2="145.922"
                    y2="103.21"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint93_linear_984_11217"
                    x1="141.788"
                    y1="103.59"
                    x2="152.502"
                    y2="29.1689"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.096" stopColor="#45108A" />
                    <stop offset="1" stopColor="#7C1DC9" />
                </linearGradient>
                <linearGradient
                    id="paint94_linear_984_11217"
                    x1="157.681"
                    y1="77.9378"
                    x2="204.1"
                    y2="50.9805"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint95_linear_984_11217"
                    x1="145.658"
                    y1="73.5841"
                    x2="176.281"
                    y2="43.0699"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint96_linear_984_11217"
                    x1="115.928"
                    y1="73.2291"
                    x2="142.75"
                    y2="67.2164"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#703ED1" />
                    <stop offset="0.6209" stopColor="#5A78E0" />
                    <stop offset="1" stopColor="#4C9DE9" />
                </linearGradient>
                <linearGradient
                    id="paint97_linear_984_11217"
                    x1="137.872"
                    y1="54.0872"
                    x2="126.361"
                    y2="68.6385"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#703ED1" />
                    <stop offset="0.6209" stopColor="#5A78E0" />
                    <stop offset="1" stopColor="#4C9DE9" />
                </linearGradient>
                <linearGradient
                    id="paint98_linear_984_11217"
                    x1="115.928"
                    y1="73.2291"
                    x2="142.75"
                    y2="67.2164"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.096" stopColor="#45108A" />
                    <stop offset="1" stopColor="#7C1DC9" />
                </linearGradient>
                <linearGradient
                    id="paint99_linear_984_11217"
                    x1="123.372"
                    y1="67.7951"
                    x2="151.575"
                    y2="73.6803"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint100_linear_984_11217"
                    x1="125.158"
                    y1="81.5908"
                    x2="151.98"
                    y2="75.578"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#703ED1" />
                    <stop offset="0.6209" stopColor="#5A78E0" />
                    <stop offset="1" stopColor="#4C9DE9" />
                </linearGradient>
                <linearGradient
                    id="paint101_linear_984_11217"
                    x1="128.488"
                    y1="66.2081"
                    x2="141.012"
                    y2="82.1348"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#703ED1" />
                    <stop offset="0.6209" stopColor="#5A78E0" />
                    <stop offset="1" stopColor="#4C9DE9" />
                </linearGradient>
                <linearGradient
                    id="paint102_linear_984_11217"
                    x1="140.306"
                    y1="87.0928"
                    x2="167.129"
                    y2="81.08"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#703ED1" />
                    <stop offset="0.6209" stopColor="#5A78E0" />
                    <stop offset="1" stopColor="#4C9DE9" />
                </linearGradient>
                <linearGradient
                    id="paint103_linear_984_11217"
                    x1="162.058"
                    y1="59.7717"
                    x2="148.376"
                    y2="87.2093"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#703ED1" />
                    <stop offset="0.6209" stopColor="#5A78E0" />
                    <stop offset="1" stopColor="#4C9DE9" />
                </linearGradient>
                <linearGradient
                    id="paint104_linear_984_11217"
                    x1="128.313"
                    y1="62.8036"
                    x2="148.685"
                    y2="58.237"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#703ED1" />
                    <stop offset="0.6209" stopColor="#5A78E0" />
                    <stop offset="1" stopColor="#4C9DE9" />
                </linearGradient>
                <linearGradient
                    id="paint105_linear_984_11217"
                    x1="140.306"
                    y1="87.0928"
                    x2="167.129"
                    y2="81.08"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.096" stopColor="#45108A" />
                    <stop offset="1" stopColor="#7C1DC9" />
                </linearGradient>
                <linearGradient
                    id="paint106_linear_984_11217"
                    x1="130.388"
                    y1="60.7312"
                    x2="141.464"
                    y2="56.9667"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#703ED1" />
                    <stop offset="0.6209" stopColor="#5A78E0" />
                    <stop offset="1" stopColor="#4C9DE9" />
                </linearGradient>
                <linearGradient
                    id="paint107_linear_984_11217"
                    x1="128.313"
                    y1="62.8036"
                    x2="148.685"
                    y2="58.237"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.096" stopColor="#45108A" />
                    <stop offset="1" stopColor="#7C1DC9" />
                </linearGradient>
                <linearGradient
                    id="paint108_linear_984_11217"
                    x1="125.158"
                    y1="81.5908"
                    x2="151.98"
                    y2="75.578"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.096" stopColor="#45108A" />
                    <stop offset="1" stopColor="#7C1DC9" />
                </linearGradient>
                <linearGradient
                    id="paint109_linear_984_11217"
                    x1="165.211"
                    y1="83.6631"
                    x2="188.363"
                    y2="76.7305"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.096" stopColor="#45108A" />
                    <stop offset="1" stopColor="#7C1DC9" />
                </linearGradient>
                <linearGradient
                    id="paint110_linear_984_11217"
                    x1="167.653"
                    y1="65.716"
                    x2="180.912"
                    y2="61.7457"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#703ED1" />
                    <stop offset="0.6209" stopColor="#5A78E0" />
                    <stop offset="1" stopColor="#4C9DE9" />
                </linearGradient>
                <linearGradient
                    id="paint111_linear_984_11217"
                    x1="167.653"
                    y1="65.716"
                    x2="180.912"
                    y2="61.7457"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.096" stopColor="#45108A" />
                    <stop offset="1" stopColor="#7C1DC9" />
                </linearGradient>
                <linearGradient
                    id="paint112_linear_984_11217"
                    x1="149.68"
                    y1="91.007"
                    x2="145.046"
                    y2="37.1459"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.096" stopColor="#45108A" />
                    <stop offset="1" stopColor="#7C1DC9" />
                </linearGradient>
                <linearGradient
                    id="paint113_linear_984_11217"
                    x1="171.48"
                    y1="95.4164"
                    x2="173.489"
                    y2="99.9256"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint114_linear_984_11217"
                    x1="151.874"
                    y1="58.5561"
                    x2="161.575"
                    y2="101.486"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint115_linear_984_11217"
                    x1="185.049"
                    y1="63.5701"
                    x2="166.577"
                    y2="98.7741"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint116_linear_984_11217"
                    x1="172.572"
                    y1="79.4253"
                    x2="166.166"
                    y2="83.3346"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0202" stopColor="#45108A" />
                    <stop offset="0.2929" stopColor="#3D065F" />
                    <stop offset="1" stopColor="#10054D" />
                </linearGradient>
                <linearGradient
                    id="paint117_linear_984_11217"
                    x1="157.927"
                    y1="60.985"
                    x2="149.891"
                    y2="54.6144"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#BCBEC0" />
                </linearGradient>
                <linearGradient
                    id="paint118_linear_984_11217"
                    x1="169.97"
                    y1="78.0608"
                    x2="169.463"
                    y2="99.0552"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint119_linear_984_11217"
                    x1="380.254"
                    y1="1.92043"
                    x2="411.645"
                    y2="56.2914"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0556" stopColor="#9F79B8" />
                    <stop offset="0.2575" stopColor="#A17BBA" />
                    <stop offset="0.3569" stopColor="#A783BF" />
                    <stop offset="0.4338" stopColor="#B290C9" />
                    <stop offset="0.4949" stopColor="#C1A1D5" />
                    <stop offset="0.5067" stopColor="#C4A5D7" />
                    <stop offset="0.5196" stopColor="#CDB3DD" />
                    <stop offset="0.5329" stopColor="#DBC8E7" />
                    <stop offset="0.5466" stopColor="#EFE7F4" />
                    <stop offset="0.5556" stopColor="white" />
                    <stop offset="0.5678" stopColor="#ECE0F3" />
                    <stop offset="0.5801" stopColor="#DDC8EA" />
                    <stop offset="0.5915" stopColor="#D4B9E5" />
                    <stop offset="0.601" stopColor="#D1B4E3" />
                    <stop offset="0.658" stopColor="#B395D6" />
                    <stop offset="0.7155" stopColor="#9C7DCB" />
                    <stop offset="0.7687" stopColor="#8E6EC5" />
                    <stop offset="0.8131" stopColor="#8969C3" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <radialGradient
                    id="paint120_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(420.853 20.3292) scale(33.9312)"
                >
                    <stop stopColor="#AF8AFC" />
                    <stop offset="1" stopColor="#10054D" />
                </radialGradient>
                <linearGradient
                    id="paint121_linear_984_11217"
                    x1="356.746"
                    y1="70.6352"
                    x2="424.465"
                    y2="34.5179"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1409" stopColor="#A27DCA" />
                    <stop offset="0.2725" stopColor="#AC88CF" />
                    <stop offset="0.4" stopColor="#BC9BD7" />
                    <stop offset="0.5202" stopColor="#D1B4E3" />
                    <stop offset="0.6493" stopColor="#DBC4E9" />
                    <stop offset="0.8997" stopColor="#F4EDF8" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient
                    id="paint122_linear_984_11217"
                    x1="385.888"
                    y1="42.9174"
                    x2="420.002"
                    y2="42.9174"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#25054D" />
                    <stop offset="1" stopColor="#45108A" />
                </linearGradient>
                <linearGradient
                    id="paint123_linear_984_11217"
                    x1="385.296"
                    y1="9.26464"
                    x2="429.099"
                    y2="92.7891"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#9F19AB" />
                    <stop offset="0.4293" stopColor="#5F27BD" />
                    <stop offset="0.904" stopColor="#3D065F" />
                </linearGradient>
                <linearGradient
                    id="paint124_linear_984_11217"
                    x1="85.7988"
                    y1="217.336"
                    x2="35.9741"
                    y2="217.336"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0556" stopColor="#9F79B8" />
                    <stop offset="0.2575" stopColor="#A17BBA" />
                    <stop offset="0.3569" stopColor="#A783BF" />
                    <stop offset="0.4338" stopColor="#B290C9" />
                    <stop offset="0.4949" stopColor="#C1A1D5" />
                    <stop offset="0.5067" stopColor="#C4A5D7" />
                    <stop offset="0.5196" stopColor="#CDB3DD" />
                    <stop offset="0.5329" stopColor="#DBC8E7" />
                    <stop offset="0.5466" stopColor="#EFE7F4" />
                    <stop offset="0.5556" stopColor="white" />
                    <stop offset="0.5678" stopColor="#ECE0F3" />
                    <stop offset="0.5801" stopColor="#DDC8EA" />
                    <stop offset="0.5915" stopColor="#D4B9E5" />
                    <stop offset="0.601" stopColor="#D1B4E3" />
                    <stop offset="0.658" stopColor="#B395D6" />
                    <stop offset="0.7155" stopColor="#9C7DCB" />
                    <stop offset="0.7687" stopColor="#8E6EC5" />
                    <stop offset="0.8131" stopColor="#8969C3" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <linearGradient
                    id="paint125_linear_984_11217"
                    x1="71.6173"
                    y1="220.54"
                    x2="49.0318"
                    y2="208.046"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1409" stopColor="#A27DCA" />
                    <stop offset="0.2725" stopColor="#AC88CF" />
                    <stop offset="0.4" stopColor="#BC9BD7" />
                    <stop offset="0.5202" stopColor="#D1B4E3" />
                    <stop offset="0.6493" stopColor="#DBC4E9" />
                    <stop offset="0.8997" stopColor="#F4EDF8" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient
                    id="paint126_linear_984_11217"
                    x1="59.6393"
                    y1="214.634"
                    x2="55.2057"
                    y2="207.2"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </linearGradient>
                <linearGradient
                    id="paint127_linear_984_11217"
                    x1="135.574"
                    y1="113.214"
                    x2="13.4404"
                    y2="219.3"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1409" stopColor="#A27DCA" />
                    <stop offset="0.2725" stopColor="#AC88CF" />
                    <stop offset="0.4" stopColor="#BC9BD7" />
                    <stop offset="0.5202" stopColor="#D1B4E3" />
                    <stop offset="0.6493" stopColor="#DBC4E9" />
                    <stop offset="0.8997" stopColor="#F4EDF8" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient
                    id="paint128_linear_984_11217"
                    x1="30.2764"
                    y1="223.959"
                    x2="87.6445"
                    y2="135.022"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2A0C5C" />
                    <stop offset="0.6869" stopColor="#5F27BD" />
                    <stop offset="1" stopColor="#B4299A" />
                </linearGradient>
                <linearGradient
                    id="paint129_linear_984_11217"
                    x1="6.87442"
                    y1="231.607"
                    x2="66.8895"
                    y2="135.711"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0556" stopColor="#9F79B8" />
                    <stop offset="0.2575" stopColor="#A17BBA" />
                    <stop offset="0.3569" stopColor="#A783BF" />
                    <stop offset="0.4338" stopColor="#B290C9" />
                    <stop offset="0.4949" stopColor="#C1A1D5" />
                    <stop offset="0.5067" stopColor="#C4A5D7" />
                    <stop offset="0.5196" stopColor="#CDB3DD" />
                    <stop offset="0.5329" stopColor="#DBC8E7" />
                    <stop offset="0.5466" stopColor="#EFE7F4" />
                    <stop offset="0.5556" stopColor="white" />
                    <stop offset="0.5678" stopColor="#ECE0F3" />
                    <stop offset="0.5801" stopColor="#DDC8EA" />
                    <stop offset="0.5915" stopColor="#D4B9E5" />
                    <stop offset="0.601" stopColor="#D1B4E3" />
                    <stop offset="0.658" stopColor="#B395D6" />
                    <stop offset="0.7155" stopColor="#9C7DCB" />
                    <stop offset="0.7687" stopColor="#8E6EC5" />
                    <stop offset="0.8131" stopColor="#8969C3" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <radialGradient
                    id="paint130_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(23.731 172.754) rotate(180) scale(10.2155)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <radialGradient
                    id="paint131_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(162.27 387.834) scale(25.2521 12.5614)"
                >
                    <stop stopColor="#5F5C5D" />
                    <stop offset="1" stopColor="white" />
                </radialGradient>
                <linearGradient
                    id="paint132_linear_984_11217"
                    x1="172.679"
                    y1="389.729"
                    x2="139.182"
                    y2="389.729"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.0488" stopColor="#C8ABDA" />
                    <stop offset="0.1149" stopColor="#DAC6E6" />
                    <stop offset="0.1998" stopColor="#F7F2F9" />
                    <stop offset="0.2222" stopColor="white" />
                    <stop offset="0.2513" stopColor="#F9F5FB" />
                    <stop offset="0.3001" stopColor="#E9DBF2" />
                    <stop offset="0.3586" stopColor="#D1B4E3" />
                    <stop offset="0.4264" stopColor="#B395D6" />
                    <stop offset="0.4949" stopColor="#9C7DCB" />
                    <stop offset="0.5583" stopColor="#8E6EC5" />
                    <stop offset="0.6111" stopColor="#8969C3" />
                    <stop offset="0.755" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <linearGradient
                    id="paint133_linear_984_11217"
                    x1="175.808"
                    y1="361.886"
                    x2="148.845"
                    y2="390.796"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint134_linear_984_11217"
                    x1="171.257"
                    y1="375.837"
                    x2="140.584"
                    y2="375.837"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.0488" stopColor="#C8ABDA" />
                    <stop offset="0.1149" stopColor="#DAC6E6" />
                    <stop offset="0.1998" stopColor="#F7F2F9" />
                    <stop offset="0.2222" stopColor="white" />
                    <stop offset="0.2513" stopColor="#F9F5FB" />
                    <stop offset="0.3001" stopColor="#E9DBF2" />
                    <stop offset="0.3586" stopColor="#D1B4E3" />
                    <stop offset="0.4264" stopColor="#B395D6" />
                    <stop offset="0.4949" stopColor="#9C7DCB" />
                    <stop offset="0.5583" stopColor="#8E6EC5" />
                    <stop offset="0.6111" stopColor="#8969C3" />
                    <stop offset="0.755" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <radialGradient
                    id="paint135_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(155.823 360.98) rotate(180) scale(12.7511)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint136_linear_984_11217"
                    x1="174.123"
                    y1="340.93"
                    x2="149.434"
                    y2="367.402"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint137_linear_984_11217"
                    x1="126.338"
                    y1="302.193"
                    x2="122.185"
                    y2="309.094"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.0488" stopColor="#C8ABDA" />
                    <stop offset="0.1149" stopColor="#DAC6E6" />
                    <stop offset="0.1998" stopColor="#F7F2F9" />
                    <stop offset="0.2222" stopColor="white" />
                    <stop offset="0.2513" stopColor="#F9F5FB" />
                    <stop offset="0.3001" stopColor="#E9DBF2" />
                    <stop offset="0.3586" stopColor="#D1B4E3" />
                    <stop offset="0.4264" stopColor="#B395D6" />
                    <stop offset="0.4949" stopColor="#9C7DCB" />
                    <stop offset="0.5583" stopColor="#8E6EC5" />
                    <stop offset="0.6111" stopColor="#8969C3" />
                    <stop offset="0.755" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <linearGradient
                    id="paint138_linear_984_11217"
                    x1="130.161"
                    y1="302.823"
                    x2="124.487"
                    y2="312.25"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.0488" stopColor="#C8ABDA" />
                    <stop offset="0.1149" stopColor="#DAC6E6" />
                    <stop offset="0.1998" stopColor="#F7F2F9" />
                    <stop offset="0.2222" stopColor="white" />
                    <stop offset="0.2513" stopColor="#F9F5FB" />
                    <stop offset="0.3001" stopColor="#E9DBF2" />
                    <stop offset="0.3586" stopColor="#D1B4E3" />
                    <stop offset="0.4264" stopColor="#B395D6" />
                    <stop offset="0.4949" stopColor="#9C7DCB" />
                    <stop offset="0.5583" stopColor="#8E6EC5" />
                    <stop offset="0.6111" stopColor="#8969C3" />
                    <stop offset="0.755" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <linearGradient
                    id="paint139_linear_984_11217"
                    x1="174.298"
                    y1="375.116"
                    x2="146.349"
                    y2="304.574"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint140_linear_984_11217"
                    x1="161.739"
                    y1="334.663"
                    x2="125.399"
                    y2="338.19"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint141_linear_984_11217"
                    x1="155.759"
                    y1="328.115"
                    x2="158.004"
                    y2="356.654"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.1298" stopColor="#C8ABDA" />
                    <stop offset="0.3344" stopColor="#DAC6E6" />
                    <stop offset="0.5974" stopColor="#F7F2F9" />
                    <stop offset="0.6667" stopColor="white" />
                </linearGradient>
                <radialGradient
                    id="paint142_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(164.915 303.056) rotate(180) scale(17.3007)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint143_linear_984_11217"
                    x1="152.786"
                    y1="359.982"
                    x2="128.83"
                    y2="352.808"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint144_linear_984_11217"
                    x1="175.465"
                    y1="362.884"
                    x2="144.118"
                    y2="355.857"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint145_linear_984_11217"
                    x1="147.818"
                    y1="337.373"
                    x2="158.174"
                    y2="357.109"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint146_linear_984_11217"
                    x1="171.678"
                    y1="331.799"
                    x2="231.58"
                    y2="313.862"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint147_linear_984_11217"
                    x1="171.313"
                    y1="309.682"
                    x2="193.563"
                    y2="347.692"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1409" stopColor="#A27DCA" />
                    <stop offset="0.2725" stopColor="#AC88CF" />
                    <stop offset="0.4" stopColor="#BC9BD7" />
                    <stop offset="0.5202" stopColor="#D1B4E3" />
                    <stop offset="0.6493" stopColor="#DBC4E9" />
                    <stop offset="0.8997" stopColor="#F4EDF8" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <radialGradient
                    id="paint148_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(185.176 329.071) scale(16.4457)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint149_linear_984_11217"
                    x1="205.063"
                    y1="359.249"
                    x2="196.38"
                    y2="337.333"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint150_linear_984_11217"
                    x1="201.257"
                    y1="347.09"
                    x2="186.407"
                    y2="348.532"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <radialGradient
                    id="paint151_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(202.356 337.179) rotate(180) scale(5.3957)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint152_linear_984_11217"
                    x1="197.521"
                    y1="371.079"
                    x2="198.549"
                    y2="371.079"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#703ED1" />
                    <stop offset="0.6209" stopColor="#5A78E0" />
                    <stop offset="1" stopColor="#4C9DE9" />
                </linearGradient>
                <linearGradient
                    id="paint153_linear_984_11217"
                    x1="200.01"
                    y1="364.291"
                    x2="196.091"
                    y2="364.291"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.0488" stopColor="#C8ABDA" />
                    <stop offset="0.1149" stopColor="#DAC6E6" />
                    <stop offset="0.1998" stopColor="#F7F2F9" />
                    <stop offset="0.2222" stopColor="white" />
                    <stop offset="0.2513" stopColor="#F9F5FB" />
                    <stop offset="0.3001" stopColor="#E9DBF2" />
                    <stop offset="0.3586" stopColor="#D1B4E3" />
                    <stop offset="0.4264" stopColor="#B395D6" />
                    <stop offset="0.4949" stopColor="#9C7DCB" />
                    <stop offset="0.5583" stopColor="#8E6EC5" />
                    <stop offset="0.6111" stopColor="#8969C3" />
                    <stop offset="0.755" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <linearGradient
                    id="paint154_linear_984_11217"
                    x1="201.579"
                    y1="357.101"
                    x2="194.542"
                    y2="357.101"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.0488" stopColor="#C8ABDA" />
                    <stop offset="0.1149" stopColor="#DAC6E6" />
                    <stop offset="0.1998" stopColor="#F7F2F9" />
                    <stop offset="0.2222" stopColor="white" />
                    <stop offset="0.2513" stopColor="#F9F5FB" />
                    <stop offset="0.3001" stopColor="#E9DBF2" />
                    <stop offset="0.3586" stopColor="#D1B4E3" />
                    <stop offset="0.4264" stopColor="#B395D6" />
                    <stop offset="0.4949" stopColor="#9C7DCB" />
                    <stop offset="0.5583" stopColor="#8E6EC5" />
                    <stop offset="0.6111" stopColor="#8969C3" />
                    <stop offset="0.755" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <linearGradient
                    id="paint155_linear_984_11217"
                    x1="193.84"
                    y1="347.484"
                    x2="199.504"
                    y2="353.558"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint156_linear_984_11217"
                    x1="195.664"
                    y1="351.956"
                    x2="200.602"
                    y2="351.956"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.0488" stopColor="#C8ABDA" />
                    <stop offset="0.1149" stopColor="#DAC6E6" />
                    <stop offset="0.1998" stopColor="#F7F2F9" />
                    <stop offset="0.2222" stopColor="white" />
                    <stop offset="0.2513" stopColor="#F9F5FB" />
                    <stop offset="0.3001" stopColor="#E9DBF2" />
                    <stop offset="0.3586" stopColor="#D1B4E3" />
                    <stop offset="0.4264" stopColor="#B395D6" />
                    <stop offset="0.4949" stopColor="#9C7DCB" />
                    <stop offset="0.5583" stopColor="#8E6EC5" />
                    <stop offset="0.6111" stopColor="#8969C3" />
                    <stop offset="0.755" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <linearGradient
                    id="paint157_linear_984_11217"
                    x1="198.038"
                    y1="353.483"
                    x2="198.038"
                    y2="350.706"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.1298" stopColor="#C8ABDA" />
                    <stop offset="0.3344" stopColor="#DAC6E6" />
                    <stop offset="0.5974" stopColor="#F7F2F9" />
                    <stop offset="0.6667" stopColor="white" />
                </linearGradient>
                <linearGradient
                    id="paint158_linear_984_11217"
                    x1="192.873"
                    y1="356.243"
                    x2="198.471"
                    y2="354.567"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint159_linear_984_11217"
                    x1="141.837"
                    y1="317.542"
                    x2="89.4981"
                    y2="301.87"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint160_linear_984_11217"
                    x1="172.549"
                    y1="323.878"
                    x2="135.042"
                    y2="315.47"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint161_linear_984_11217"
                    x1="121.198"
                    y1="265.466"
                    x2="144.773"
                    y2="310.395"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint162_linear_984_11217"
                    x1="156.984"
                    y1="325.532"
                    x2="130.674"
                    y2="317.654"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint163_linear_984_11217"
                    x1="179.101"
                    y1="328.807"
                    x2="148.86"
                    y2="322.028"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint164_linear_984_11217"
                    x1="149.096"
                    y1="298.285"
                    x2="159.987"
                    y2="319.042"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint165_linear_984_11217"
                    x1="163.947"
                    y1="325.212"
                    x2="161.006"
                    y2="322.052"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#65318A" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <linearGradient
                    id="paint166_linear_984_11217"
                    x1="181.198"
                    y1="329.503"
                    x2="175.238"
                    y2="339.405"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.0488" stopColor="#C8ABDA" />
                    <stop offset="0.1149" stopColor="#DAC6E6" />
                    <stop offset="0.1998" stopColor="#F7F2F9" />
                    <stop offset="0.2222" stopColor="white" />
                    <stop offset="0.2513" stopColor="#F9F5FB" />
                    <stop offset="0.3001" stopColor="#E9DBF2" />
                    <stop offset="0.3586" stopColor="#D1B4E3" />
                    <stop offset="0.4264" stopColor="#B395D6" />
                    <stop offset="0.4949" stopColor="#9C7DCB" />
                    <stop offset="0.5583" stopColor="#8E6EC5" />
                    <stop offset="0.6111" stopColor="#8969C3" />
                    <stop offset="0.755" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <linearGradient
                    id="paint167_linear_984_11217"
                    x1="165.089"
                    y1="336.78"
                    x2="199.59"
                    y2="329.827"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.1298" stopColor="#C8ABDA" />
                    <stop offset="0.3344" stopColor="#DAC6E6" />
                    <stop offset="0.5974" stopColor="#F7F2F9" />
                    <stop offset="0.6667" stopColor="white" />
                </linearGradient>
                <linearGradient
                    id="paint168_linear_984_11217"
                    x1="202.775"
                    y1="344.461"
                    x2="184.874"
                    y2="340.448"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint169_linear_984_11217"
                    x1="192.25"
                    y1="345.356"
                    x2="195.794"
                    y2="339.562"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.0488" stopColor="#C8ABDA" />
                    <stop offset="0.1149" stopColor="#DAC6E6" />
                    <stop offset="0.1998" stopColor="#F7F2F9" />
                    <stop offset="0.2222" stopColor="white" />
                    <stop offset="0.2513" stopColor="#F9F5FB" />
                    <stop offset="0.3001" stopColor="#E9DBF2" />
                    <stop offset="0.3586" stopColor="#D1B4E3" />
                    <stop offset="0.4264" stopColor="#B395D6" />
                    <stop offset="0.4949" stopColor="#9C7DCB" />
                    <stop offset="0.5583" stopColor="#8E6EC5" />
                    <stop offset="0.6111" stopColor="#8969C3" />
                    <stop offset="0.755" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <linearGradient
                    id="paint170_linear_984_11217"
                    x1="192.655"
                    y1="341.64"
                    x2="196.008"
                    y2="343.746"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.1298" stopColor="#C8ABDA" />
                    <stop offset="0.3344" stopColor="#DAC6E6" />
                    <stop offset="0.5974" stopColor="#F7F2F9" />
                    <stop offset="0.6667" stopColor="white" />
                </linearGradient>
                <radialGradient
                    id="paint171_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(192.226 341.033) rotate(180) scale(3.41519)"
                >
                    <stop stopColor="white" />
                    <stop offset="0.0152" stopColor="#F7F7F7" />
                    <stop offset="0.132" stopColor="#BEBEBE" />
                    <stop offset="0.252" stopColor="#8B8B8B" />
                    <stop offset="0.3727" stopColor="#606060" />
                    <stop offset="0.4942" stopColor="#3E3E3E" />
                    <stop offset="0.6167" stopColor="#232323" />
                    <stop offset="0.7407" stopColor="#0F0F0F" />
                    <stop offset="0.8672" stopColor="#040404" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint172_linear_984_11217"
                    x1="161.989"
                    y1="381.833"
                    x2="134.041"
                    y2="311.291"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint173_linear_984_11217"
                    x1="149.431"
                    y1="341.38"
                    x2="113.091"
                    y2="344.907"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <radialGradient
                    id="paint174_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(149.245 316.31) rotate(180) scale(17.3348)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint175_linear_984_11217"
                    x1="134.836"
                    y1="314.315"
                    x2="138.676"
                    y2="320.695"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.0488" stopColor="#C8ABDA" />
                    <stop offset="0.1149" stopColor="#DAC6E6" />
                    <stop offset="0.1998" stopColor="#F7F2F9" />
                    <stop offset="0.2222" stopColor="white" />
                    <stop offset="0.2513" stopColor="#F9F5FB" />
                    <stop offset="0.3001" stopColor="#E9DBF2" />
                    <stop offset="0.3586" stopColor="#D1B4E3" />
                    <stop offset="0.4264" stopColor="#B395D6" />
                    <stop offset="0.4949" stopColor="#9C7DCB" />
                    <stop offset="0.5583" stopColor="#8E6EC5" />
                    <stop offset="0.6111" stopColor="#8969C3" />
                    <stop offset="0.755" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <linearGradient
                    id="paint176_linear_984_11217"
                    x1="129.329"
                    y1="319.004"
                    x2="141.828"
                    y2="316.203"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <radialGradient
                    id="paint177_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(136.695 316.611) scale(2.3844)"
                >
                    <stop stopColor="white" />
                    <stop offset="0.0152" stopColor="#F7F7F7" />
                    <stop offset="0.132" stopColor="#BEBEBE" />
                    <stop offset="0.252" stopColor="#8B8B8B" />
                    <stop offset="0.3727" stopColor="#606060" />
                    <stop offset="0.4942" stopColor="#3E3E3E" />
                    <stop offset="0.6167" stopColor="#232323" />
                    <stop offset="0.7407" stopColor="#0F0F0F" />
                    <stop offset="0.8672" stopColor="#040404" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint178_linear_984_11217"
                    x1="148.435"
                    y1="359.517"
                    x2="152.274"
                    y2="365.897"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.0488" stopColor="#C8ABDA" />
                    <stop offset="0.1149" stopColor="#DAC6E6" />
                    <stop offset="0.1998" stopColor="#F7F2F9" />
                    <stop offset="0.2222" stopColor="white" />
                    <stop offset="0.2513" stopColor="#F9F5FB" />
                    <stop offset="0.3001" stopColor="#E9DBF2" />
                    <stop offset="0.3586" stopColor="#D1B4E3" />
                    <stop offset="0.4264" stopColor="#B395D6" />
                    <stop offset="0.4949" stopColor="#9C7DCB" />
                    <stop offset="0.5583" stopColor="#8E6EC5" />
                    <stop offset="0.6111" stopColor="#8969C3" />
                    <stop offset="0.755" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <linearGradient
                    id="paint179_linear_984_11217"
                    x1="142.928"
                    y1="364.206"
                    x2="155.426"
                    y2="361.404"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <radialGradient
                    id="paint180_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(150.294 361.813) scale(2.3843)"
                >
                    <stop stopColor="white" />
                    <stop offset="0.0152" stopColor="#F7F7F7" />
                    <stop offset="0.132" stopColor="#BEBEBE" />
                    <stop offset="0.252" stopColor="#8B8B8B" />
                    <stop offset="0.3727" stopColor="#606060" />
                    <stop offset="0.4942" stopColor="#3E3E3E" />
                    <stop offset="0.6167" stopColor="#232323" />
                    <stop offset="0.7407" stopColor="#0F0F0F" />
                    <stop offset="0.8672" stopColor="#040404" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint181_linear_984_11217"
                    x1="189.12"
                    y1="344.651"
                    x2="194.718"
                    y2="342.975"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint182_linear_984_11217"
                    x1="197.177"
                    y1="363.667"
                    x2="188.494"
                    y2="341.751"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint183_linear_984_11217"
                    x1="193.371"
                    y1="351.509"
                    x2="178.521"
                    y2="352.95"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <radialGradient
                    id="paint184_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(194.469 341.597) rotate(180) scale(5.3957)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint185_linear_984_11217"
                    x1="162.043"
                    y1="337.35"
                    x2="221.944"
                    y2="319.413"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <linearGradient
                    id="paint186_linear_984_11217"
                    x1="161.677"
                    y1="315.233"
                    x2="183.927"
                    y2="353.243"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1409" stopColor="#A27DCA" />
                    <stop offset="0.2725" stopColor="#AC88CF" />
                    <stop offset="0.4" stopColor="#BC9BD7" />
                    <stop offset="0.5202" stopColor="#D1B4E3" />
                    <stop offset="0.6493" stopColor="#DBC4E9" />
                    <stop offset="0.8997" stopColor="#F4EDF8" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <radialGradient
                    id="paint187_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(175.54 334.622) scale(16.4457)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint188_linear_984_11217"
                    x1="186.888"
                    y1="343.409"
                    x2="189.05"
                    y2="347.001"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.0488" stopColor="#C8ABDA" />
                    <stop offset="0.1149" stopColor="#DAC6E6" />
                    <stop offset="0.1998" stopColor="#F7F2F9" />
                    <stop offset="0.2222" stopColor="white" />
                    <stop offset="0.2513" stopColor="#F9F5FB" />
                    <stop offset="0.3001" stopColor="#E9DBF2" />
                    <stop offset="0.3586" stopColor="#D1B4E3" />
                    <stop offset="0.4264" stopColor="#B395D6" />
                    <stop offset="0.4949" stopColor="#9C7DCB" />
                    <stop offset="0.5583" stopColor="#8E6EC5" />
                    <stop offset="0.6111" stopColor="#8969C3" />
                    <stop offset="0.755" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <linearGradient
                    id="paint189_linear_984_11217"
                    x1="183.787"
                    y1="346.049"
                    x2="190.825"
                    y2="344.472"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <radialGradient
                    id="paint190_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(187.934 344.701) scale(1.3425)"
                >
                    <stop stopColor="white" />
                    <stop offset="0.0152" stopColor="#F7F7F7" />
                    <stop offset="0.132" stopColor="#BEBEBE" />
                    <stop offset="0.252" stopColor="#8B8B8B" />
                    <stop offset="0.3727" stopColor="#606060" />
                    <stop offset="0.4942" stopColor="#3E3E3E" />
                    <stop offset="0.6167" stopColor="#232323" />
                    <stop offset="0.7407" stopColor="#0F0F0F" />
                    <stop offset="0.8672" stopColor="#040404" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint191_linear_984_11217"
                    x1="191.82"
                    y1="355.236"
                    x2="193.982"
                    y2="358.828"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.0488" stopColor="#C8ABDA" />
                    <stop offset="0.1149" stopColor="#DAC6E6" />
                    <stop offset="0.1998" stopColor="#F7F2F9" />
                    <stop offset="0.2222" stopColor="white" />
                    <stop offset="0.2513" stopColor="#F9F5FB" />
                    <stop offset="0.3001" stopColor="#E9DBF2" />
                    <stop offset="0.3586" stopColor="#D1B4E3" />
                    <stop offset="0.4264" stopColor="#B395D6" />
                    <stop offset="0.4949" stopColor="#9C7DCB" />
                    <stop offset="0.5583" stopColor="#8E6EC5" />
                    <stop offset="0.6111" stopColor="#8969C3" />
                    <stop offset="0.755" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <linearGradient
                    id="paint192_linear_984_11217"
                    x1="188.719"
                    y1="357.876"
                    x2="195.757"
                    y2="356.299"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <radialGradient
                    id="paint193_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(192.866 356.528) scale(1.34261)"
                >
                    <stop stopColor="white" />
                    <stop offset="0.0152" stopColor="#F7F7F7" />
                    <stop offset="0.132" stopColor="#BEBEBE" />
                    <stop offset="0.252" stopColor="#8B8B8B" />
                    <stop offset="0.3727" stopColor="#606060" />
                    <stop offset="0.4942" stopColor="#3E3E3E" />
                    <stop offset="0.6167" stopColor="#232323" />
                    <stop offset="0.7407" stopColor="#0F0F0F" />
                    <stop offset="0.8672" stopColor="#040404" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient
                    id="paint194_linear_984_11217"
                    x1="152.452"
                    y1="323.235"
                    x2="154.614"
                    y2="326.828"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.0101" stopColor="#C1A1D5" />
                    <stop offset="0.0488" stopColor="#C8ABDA" />
                    <stop offset="0.1149" stopColor="#DAC6E6" />
                    <stop offset="0.1998" stopColor="#F7F2F9" />
                    <stop offset="0.2222" stopColor="white" />
                    <stop offset="0.2513" stopColor="#F9F5FB" />
                    <stop offset="0.3001" stopColor="#E9DBF2" />
                    <stop offset="0.3586" stopColor="#D1B4E3" />
                    <stop offset="0.4264" stopColor="#B395D6" />
                    <stop offset="0.4949" stopColor="#9C7DCB" />
                    <stop offset="0.5583" stopColor="#8E6EC5" />
                    <stop offset="0.6111" stopColor="#8969C3" />
                    <stop offset="0.755" stopColor="#9471C6" />
                    <stop offset="1" stopColor="#B086CC" />
                </linearGradient>
                <linearGradient
                    id="paint195_linear_984_11217"
                    x1="149.351"
                    y1="325.876"
                    x2="156.389"
                    y2="324.298"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9F79C8" />
                    <stop offset="0.1367" stopColor="#A580CB" />
                    <stop offset="0.3288" stopColor="#B492D3" />
                    <stop offset="0.5529" stopColor="#CDB0E1" />
                    <stop offset="0.5808" stopColor="#D1B4E3" />
                    <stop offset="0.7644" stopColor="#DBC4E9" />
                    <stop offset="1" stopColor="#EBDEF3" />
                </linearGradient>
                <radialGradient
                    id="paint196_radial_984_11217"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(153.498 324.528) scale(1.3426)"
                >
                    <stop stopColor="white" />
                    <stop offset="0.0152" stopColor="#F7F7F7" />
                    <stop offset="0.132" stopColor="#BEBEBE" />
                    <stop offset="0.252" stopColor="#8B8B8B" />
                    <stop offset="0.3727" stopColor="#606060" />
                    <stop offset="0.4942" stopColor="#3E3E3E" />
                    <stop offset="0.6167" stopColor="#232323" />
                    <stop offset="0.7407" stopColor="#0F0F0F" />
                    <stop offset="0.8672" stopColor="#040404" />
                    <stop offset="1" />
                </radialGradient>
                <clipPath id="clip0_984_11217">
                    <rect width="567" height="480" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
